const es = {
  translations: {
    common: {
      copy: "Copiar",
      yes: "Sí",
      no: "No",
    },
    menu_bar: {
      add_variables: "Añadir variables",
    },
    home: {
      message: "¡Hola Mundo!",
    },
    page: {
      panels: {
        title: "Paneles",
        edit: "Para editar",
        search: "Buscar un panel",
        add: "Agregar panel",
        sync_confirm: {
          title: "Actualizar datos",
          description:
            "Los datos de este panel se reprocesarán en segundo plano, considerando la información hasta el día anterior. Esto puede tardar algunos minutos. ¿Desea continuar?",
          cancel: "Cancelar",
          confirm: "Sí, actualizar",
        },
        executions_modal: {
          title: "Actualizaciones de datos del panel",
          running_alert:
            "Ya existe una actualización en curso para este panel. Siga el progreso abajo.",
          running_tooltip: "Espere a que termine la actualización en curso",
          no_data:
            "No hay actualizaciones de datos registradas para este panel.",
          sync: "Actualizar datos",
          close: "Cerrar",
          of: "de",
        },
        sync_tooltip: "Actualizar Datos",
        refresh_tooltip: "Actualizar Dashboard",
        confirm: {
          title: "Eliminar panel?",
          description:
            "Esto eliminará permanentemente el panel, sus paneles y todos los datos.",
        },
        name: "Nombre",
        view_more: "Ver más",
        no_data: "No se encontraron paneles",
        cancel_button: "Cancelar",
        confirm_button: "Sí, eliminar",
        delete: "Eliminar",
      },
      reports: {
        title: "Informes",
        search: "Buscar un informe",
        code: "Código",
        name: "Nombre",
        type: "Tipo",
        description: "Descripción",
        no_data: "No se encontraron informes",
        editDescription: {
          title: "Editar descripción",
          visual: "Visual",
          html: "Código HTML",
          htmlPlaceholder: "Pegue o escriba el código HTML de la descripción",
          save: "Guardar",
          cancel: "Cancelar",
        },
        execution: {
          title: "Ejecución del Informe",
          startDate: "Fecha Inicial",
          endDate: "Fecha Final",
          ticketServices: "Servicios de Ticket",
          ticketService: "Servicio de tickets",
          workspaces: "Áreas de trabajo",
          channels: "Tableros",
          users: "Usuarios",
          attendants: "Agentes",
          created: "Creado",
          automationCode: "Automatizaciones",
          automationCodeExcept: "Excepto Automatizaciones",
          establishments: "Establecimientos",
          esignRules: "Reglas de Firma",
          monthYear: "Mes/Año",
          generate: "Generar Informe",
          search: "Buscar",
          back: "Volver",
          code: "Código",
          reportLabel: "Informe",
          all: "Todos",
          loading: "Cargando informe...",
          noResultData:
            "No se encontraron datos para los filtros seleccionados.",
          group: "Grupo",
          validation: {
            startDateRequired: "La fecha inicial es obligatoria",
            endDateRequired: "La fecha final es obligatoria",
            createdRequired: "Seleccione un mes",
            ticketServicesRequired: "Seleccione al menos un servicio de ticket",
            workspacesRequired: "Seleccione al menos un área de trabajo",
            channelsRequired: "Seleccione al menos un tablero",
            invalidDateRange:
              "La fecha inicial no puede ser posterior a la fecha final",
          },
          period: {
            thisMonth: "Mes actual",
            lastMonth: "Último mes",
            selectMonth: "Especificar mes",
          },
          header: {
            generatedAt: "Fecha y hora de generación",
            generatedBy: "Usuario",
            generatedLine: "Generado el {{date}} por {{user}}",
          },
          actions: {
            print: "Imprimir",
            exportExcel: "Excel",
          },
          metadata: {
            title: "Filtros usados",
            month: "Mes",
            period: "Periodo",
            generatedAt: "Generado en",
          },
          table: {
            reason: "Motivo",
            totalTickets: "Total de Tickets",
            monthReference: "Mes de Referencia",
            dateReference: "Fecha de Referencia",
            periodReference: "Periodo de Referencia",
            board: "Tablero",
            user: "Agente",
            quantity: "Cantidad",
            name: "Nombre",
            automation: "Automatización",
            triggers: "Disparos",
            confirm: "Confirmar",
            cancel: "Cancelar",
            notMe: "No soy yo",
            yes: "Sí",
            no: "No",
            ok: "Ok",
            invalid: "Inválida",
            talkToAttendant: "Hablar con Asistente",
            finish: "Finalizar",
            noResponse: "Sin Respuesta",
            establishment: "Establecimiento",
            client: "Cliente",
            sent: "Enviadas",
            received: "Recibidas",
            total: "Total",
            ticketsQuantity: "Cantidad de Tickets",
            tokenName: "Nombre del Token",
            invalidResponse: "Respuesta Inválida",
            service: "Servicio",
            displayOrder: "Orden de visualización",
            area: "Área",
            clicks: "Clics",
          },
        },
      },
      edit_panel: {
        title: "Panel",
        subtitle: "Nuevo panel",
        name: "Nombre",
      },
      under_construction: {
        title: "Bajo construcción",
        subtitle:
          "  Esta sección está en construcción, mientras no esté terminada visite una de las otras secciones",
        button: " Visite el registro de genéricos",
      },
      login: {
        login: "Acceso",
        accessing: "Accediendo",
        welcome: "Bienvenido de nuevo",
        rememberme: "Acuérdate de mí",
        forget_password: "¿Olvidaste tu contraseña?",
        username: "CPF",
        password: "Contraseña",
      },
      dashboardExecutions: {
        title: "Actualizaciones de datos de los dashboards",
        search_placeholder: "Busque por el nombre del panel",
        view_details: "Ver detalles",
        code: "Código",
        panel: "Panel",
        origin: "Origen",
        status_label: "Estado",
        all_status: "Todos",
        progress: "Progreso",
        running_generates: "En curso",
        failed_generates: "Con falla",
        created: "Solicitado el",
        finished_date: "Finalizado el",
        start_date: "Fecha inicial",
        end_date: "Fecha final",
        failed_alert:
          "Algunos procesamientos agotaron los intentos y no se rehacerán automáticamente. Los demás datos ya fueron actualizados.",
        purged_alert:
          "Los detalles de esta actualización fueron eliminados por la retención el {{date}}.",
        status: {
          queued: "En cola",
          processing: "Procesando",
          failed: "Con falla",
          finished: "Concluida",
          finishedwitherror: "Concluida con error",
        },
        detail: {
          header_title: "Actualización {{code}}",
          title: "Procesamientos",
          reprocess_all: "Reprocesar fallas",
          reprocess_one: "Reprocesar",
          reprocess_success: "{{count}} procesamiento(s) enviado(s) para reprocesar.",
          reprocess_nothing:
            "Nada para reprocesar: solo los procesamientos con los intentos agotados pueden reprocesarse.",
          reprocess_confirm: {
            title: "Reprocesar",
            description_all:
              "Todos los procesamientos con falla de esta actualización volverán a la cola y el panel quedará en actualización hasta que terminen. ¿Desea continuar?",
            description_one:
              "Este procesamiento volverá a la cola y el panel quedará en actualización hasta que termine. ¿Desea continuar?",
            cancel: "Cancelar",
            confirm: "Sí, reprocesar",
          },
          search_placeholder: "Busque por el error",
          component: "Componente",
          group_type: "Agrupación",
          period: "Período",
          status: "Estado",
          retries: "Intentos",
          end_process_date: "Procesado el",
          error: "Error",
        },
      },
      dashboardGenerateConfig: {
        title: "Configuración de la actualización de datos",
        subtitle: "Parámetros del procesamiento de los dashboards",
        maxBatchSize: "Tamaño del lote",
        max_batch_size_helper: "Cantidad de procesamientos en cada lote.",
        maxBatchNumbers: "Cantidad de lotes",
        max_batch_numbers_helper: "Cantidad de lotes por transacción.",
        maxRetries: "Máximo de intentos",
        max_retries_helper:
          "Cuántas veces se rehace un procesamiento con error antes de considerarlo una falla.",
        maxPendingBatchTransactions: "Máximo de transacciones pendientes",
        max_pending_batch_transactions_helper:
          "Cuántas transacciones pueden estar esperando procesamiento antes de un nuevo loteo.",
        retentionDaysReduced: "Retención de los concluidos (días)",
        retention_days_reduced_helper:
          "Durante cuántos días se mantienen los detalles de los procesamientos concluidos.",
        retentionDaysFailed: "Retención de las fallas (días)",
        retention_days_failed_helper:
          "Durante cuántos días, contados desde la última falla, una actualización con falla queda abierta para corrección antes de cerrarse.",
        alertEmails: "E-mails de alerta",
        alert_emails_helper:
          "Destinatarios del aviso diario cuando haya fallas, procesamientos detenidos o problemas en la limpieza. Separe con coma o punto y coma. Vacío = sin aviso.",
        errors: {
          max_batch_size: "Informe un tamaño de lote mayor que cero",
          max_batch_numbers: "Informe una cantidad de lotes mayor que cero",
          max_retries: "Informe un máximo de intentos mayor que cero",
          max_pending_batch_transactions:
            "Informe un máximo de transacciones pendientes mayor que cero",
          retention_days_reduced: "Informe una retención mayor que cero",
          retention_days_failed: "Informe una retención mayor que cero",
          alert_emails:
            "Informe e-mails válidos, separados por coma o punto y coma",
        },
      },
      not_found: {
        page_not_found: "¡Uy! ",
        server_not_responding: "Servidor no responde",
        try_again: "Intentar otra vez",
        back_to_begin: "De vuelta a casa",
        back_to_login: "Atrás para iniciar sesión",
        something_went_wrong: "Algo salió mal",
      },
      dashboard: {
        dashboard: "¡Muy bienvenido!",
        account_balance: "Saldo de la cuenta",
        refresh_button: "Actualizar",
        idle: "Inactivo",
        active: "Activo",
      },
      register: {
        generics: {
          identifier: "Identificador",
          code: "Código",
          value: "Valor",
          generics: "Genéricos",
          generic: "Genérico",
          description: "Descripción",
          delete_generics: "Eliminar genéricos",
          new_generic: "Nuevo Genérico",
          search_identifier: "Buscar un identificador",
          edit_generic: "Editar genérico",
          confirm: {
            title: "¿Eliminar genérico?",
            description: "Esto eliminará permanentemente el genérico",
            cancellationText: "Cancelar",
            confirmationText: "si, eliminar",
          },
          errors: {
            identifier: "El identificador es obligatorio",
            code: "El código es obligatorio",
            value: "El valor es obligatorio",
          },
        },
        roles: {
          name: "Nombre",
          establishments: "Establecimientos",
          full_name: "Nombre completo",
          privileges: "Privilegios",
          privileges_tab: "Privilegios",
          dashboards_tab: "Dashboards",
          reports_tab: "Informes",
          ticket_default_doc_categories_tab:
            "Categoría de Protocolo Predeterminado",
          list_categories_tab: "DList Categorías",
          list_classifications_tab: "DList Clasificaciones",
          dashboards_grid_title: "Dashboards",
          search_dashboard: "Buscar dashboard",
          add_dashboard: "Agregar dashboard",
          dashboard: "Dashboard",
          reports: "Informes",
          search_report: "Buscar informe",
          add_report: "Agregar informe",
          code: "Código",
          report: "Informe",
          report_with_code: "#{{code}} - {{name}}",
          linked_dashboard_remove_title: "¿Eliminar dashboard vinculado?",
          linked_dashboard_remove_description:
            "Esto solo elimina el vínculo de este dashboard con el perfil.",
          linked_report_remove_title: "¿Eliminar informe vinculado?",
          linked_report_remove_description:
            "Esto solo elimina el vínculo de este informe con el perfil.",
          linked_list_category_remove_title: "¿Quitar categoría vinculada?",
          linked_list_category_remove_description:
            "Esto quitará solo el vínculo de esta categoría con el perfil.",
          linked_list_classification_remove_title:
            "¿Quitar clasificación vinculada?",
          linked_list_classification_remove_description:
            "Esto quitará solo el vínculo de esta clasificación con el perfil.",
          linked_ticket_default_doc_category_remove_title:
            "¿Eliminar categoría vinculada?",
          linked_ticket_default_doc_category_remove_description:
            "Esto solo elimina el vínculo de esta categoría con el perfil.",
          dashboard_link_removed:
            "Vínculo con dashboard eliminado correctamente",
          report_link_removed: "Vínculo con informe eliminado correctamente",
          ticket_default_doc_categories:
            "Categorías de Protocolo Predeterminado",
          ticket_default_doc_category: "Categoría de Protocolo Predeterminado",
          search_ticket_default_doc_category: "Buscar categoría",
          add_ticket_default_doc_category: "Agregar categoría",
          list_categories: "Categorías de Lista",
          list_category: "Categoría de Lista",
          search_list_category: "Buscar categoría",
          add_list_category: "Agregar categoría",
          list_classifications: "Clasificaciones de Lista",
          list_classification: "Clasificación de Lista",
          search_list_classification: "Buscar clasificación",
          add_list_classification: "Agregar clasificación",
          edit_link: "Editar vínculo",
          roles: "Perfiles",
          profiles: "roles",
          enable: "Permitir",
          roles_profile: "Roles que tendrán este perfil vinculado",
          delete_role: "Borrar perfil",
          search_role: "Buscar por un perfil",
          description: "Descripción",
          new_role: "Nuevo perfil",
          software: "Software",
          select_software: "Seleccionar un software",
          config_access: "Configuración de acceso al perfil",
          confirm: {
            title: "¿Borrar perfil?",
            description: "Esto eliminará permanentemente el perfil.",
          },
          errors: {
            name: "El nombre es obligatorio",
            description: "La descripción es obligatoria",
            establishments: "Al menos un establecimiento es obligatorio",
            privilege: "Al menos un privilegio es obligatorio",
            ticket_default_doc_category: "La categoría es obligatoria",
            list_category: "La categoría es obligatoria",
            list_classification: "La clasificación es obligatoria",
            software: "El software es obligatorio",
          },
        },
        legalPerson: {
          new_legalPerson: "Nueva Entidad Jurídica",
          legalPersons: "Entidades legales",
          delete_legalPersons: "Eliminar entidades legales",
          search_legalPerson:
            "Búsqueda de documento, razón social o nombre de fantasía",
          add_legalPerson: "Agregar entidad legal",
          document: "Documento",
          corporateName: "Nombre de empresa",
          tradingName: "Nombre de fantasía",
          contacts: "Contactos",
          taxRegime: "Régimen Tributario",
          fiscalContributor: "contribuyente fiscal",
          stateRegistration: "Inscripción estadual",
          municipalInscription: "inscripción municipal",
          foreigner: "Extranjero",
          country: "País",
          contactType: "Tipo de Contacto",
          addContact: "Agregar contacto",
          addresses: "direcciones",
          add_address: "Añadir dirección",
          addressType: "Tipo de dirección",
          zip_code: "Código postal",
          city: "Ciudad:",
          province: "Estado:",
          addressDescription: "Calle",
          establishmentId: "Establecimiento",
          neighborhood: "Vecindario",
          number: "Número",
          complement: "Complementar",
          establishment_tooltip: "Ver establecimientos",
          confirm: {
            title: "¿Eliminar entidad legal?",
            description: "Esto eliminará permanentemente la entidad legal. ",
            title_plural: "¿Eliminar entidades legales?",
            description_plural:
              "Esto eliminará permanentemente las entidades legales.",
          },
          errors: {
            document: {
              nomempty: "El documento es obligatorio.",
              regex: "Número CNPJ no válido",
            },
            corporateName: "El nombre de la empresa es obligatorio",
            country: "El país es obligatorio para los extranjeros.",
            establishment: "El establecimiento es obligatorio.",
            fiscal_contribuitor: "El contribuyente fiscal es obligatorio.",
            tax_regime: "El régimen fiscal es obligatorio.",
            contact: {
              contactTypeId: "El tipo de contacto es obligatorio",
              phone: "Numero de telefono invalido",
              email: "Email inválido",
              site: "Sitio inválido",
              other: "El valor es obligatorio",
            },
            address: {
              zipCode: "CEP no válido",
              addressTypeId: "Seleccione un tipo",
              city: "La ciudad es obligatoria",
              province: "El estado es obligatorio",
              addressDescription: "La calle es obligatoria",
              neighborhood: "El vecindario es obligatorio",
              number: "Número invalido",
            },
          },
        },
        languages: {
          languages: "Idiomas",
          new_language: "Nuevo idioma",
          edit_language: "Editar idioma",
          search_language: "Buscar un idioma",
          name: "Nombre",
          code: "Código",
          establishments: "Establecimientos",
          establishment_tooltip: "Ver establecimientos",
          confirm: {
            title: "¿Eliminar idioma?",
            description: "Esto eliminará permanentemente el idioma.",
          },
          errors: {
            name: "El nombre es obligatorio",
            establishments: "El establecimiento es obligatorio.",
          },
        },
        users: {
          actives: "Activos",
          inactives: "Inactivos",
          start_date: "Fecha Inicial",
          end_date: "Fecha Final",
          users: "Usuarios",
          user: "Usuario",
          new_user: "Nuevo Usuario",
          username: "Acceso",
          full_name: "Nombre completo",
          user_profiles: "Perfiles de usuario",
          user_roles: "Roles del usuario",
          user_integration_type: "Tipo",
          add_new_integration: "Agregar Integración",
          user_integration: "Integración",
          integration: "Código Integración",
          integration_id: "Código Integración",
          name: "Nombre",
          enable: "Permitir",
          document: "Documento",
          email: "Correo electrónico",
          password: "Contraseña",
          individual: "Individual",
          resend_mail: "Reenviar email",
          beneficiary_sync: "Sincronización de Beneficiario",
          beneficiary_sync_success: "Beneficiario sincronizado con éxito",
          beneficiary_sync_no_document: "El usuario no tiene CPF registrado",
          email_confirmed_label: "Status del correo electrónico",
          email_confirmed_tag: "Confirmado",
          email_not_confirmed_tag: "No confirmado",
          main_establishments:
            "Establecimiento principal con el que el usuario tiene un vínculo jurídico",
          config: "Configuración de acceso de usuario",
          establishments_access:
            "Establecimientos a los que el usuario puede acceder",
          establishments_tooltip: "Ver establecimientos",
          establishment_tooltip: "Ver establecimiento",
          search_user: "Buscar un usuario",
          add_user: "Agregar usuario",
          roles_inherited:
            "Perfiles que el usuario ha heredado en función de los roles que tiene",
          none_roles_inherited: "No se encontró ningún perfil heredado",
          roles_tooltip: "Ver perfiles",
          email_tasy_warning:
            "Este es un campo informativo. Los cambios realizados en este campo no surten efecto. Por favor, cambie la dirección de correo electrónico en Tasy.",
          email_not_confirmed:
            "Correo electrónico no confirmado por el usuario",
          email_confirmation_date: "Fecha de confirmación por email",
          tooltip_main_estabishment:
            "Por defecto, en el momento de la creación, el establecimiento actual se define como el establecimiento principal",
          reset_password: {
            button: "Restablecer la contraseña",
            title:
              "¿Está seguro de que desea restablecer la contraseña del usuario? {{username}}?",
            title_form: "Reiniciar la contraseña del usuario {{username}}",
            site: "Site",
            site_error: "El site es obligatorio",
            sending: "Enviando",
            email_sent: "Enviamos un enlace de alteración da senha para:",
            confirm: "Reiniciar",
            cancel: "Cancelar",
          },
          temporary_password: {
            button: "Contraseña temporal",
            password_copied: "Copiado exitosamente",
            copy: "Copiar",
            title: "Contraseña temporal",
          },
          change_pin: {
            button: "Cambiar PIN",
            title: "Cambiar el PIN del usuario {{username}}",
            pin: "Nuevo PIN",
            pin_error: "El PIN debe contener exactamente 4 dígitos",
            confirm: "Guardar",
            cancel: "Cancelar",
            success: "PIN cambiado con éxito",
          },
          errors: {
            username: "El CPF es obligatorio",
            password: "La contraseña es obligatoria",
            individual: "El individuo es obligatorio",
            email: "El correo electrónico es obligatorio",
            user_integration_type: "El tipo es obligatorio",
            integration: "El código integración es obligatorio",
            establishments: "Seleccione al menos un establecimiento",
            establishment_standard:
              "El establecimiento principal con el que el usuario tiene un vínculo legal es obligatorio",
            roles_profiles:
              "Se debe seleccionar al menos un perfil de usuario o una función de usuario",
          },
          confirm: {
            title: "¿Borrar usuario?",
            description: "Esto eliminará permanentemente al usuario.",
          },
        },
        establishmentParams: {
          establishmentParams: "Parametros generales",
          value: "Valor",
          description: "Descripción",
          public: "Público",
          establishmentParamTypeId: "tipo de parámetro",
          add_establishmentParam: "Agregar parámetro general",
          search_param: "Buscar un parámetro",
          new_param: "Nuevo parámetro",
          confirm: {
            title: "¿Borrar el parametro general?",
            description: "Esto eliminará permanentemente el parametro general.",
          },
          errors: {
            value: "El valor es obligatorio",
            description: "La descripción es obligatoria",
            establishmentParamTypeId: "El tipo de parámetro es obligatorio",
          },
        },
        individuals: {
          sync_beneficiary: {
            button: "Sincronizar Beneficiarios",
          },
          beneficiary_sync_success: "Beneficiario sincronizado con éxito",
          beneficiary_sync_no_document:
            "La persona física no tiene CPF registrado",
          individuals: "Individuos",
          individual: "Individual",
          new_individual: "nuevo individuo",
          search_individuals: "Buscar a un individuo",
          add_individual: "Agregar individuo",
          foreigner: "Extranjero",
          identity_card: "Tarjeta de identificación",
          name: "Nombre",
          document: "Documento",
          birth_date: "Fecha de nacimiento",
          contacts: "Contactos",
          add_contact: "Agregar contacto",
          contact_type: "Tipo de Contacto",
          addresses: "direcciones",
          add_address: "Agregar dirección",
          address_type: "Tipo de dirección",
          zip_code: "Código postal",
          city: "Ciudad",
          province: "Estado",
          country: "País",
          address_description: "Calle",
          neighborhood: "Vecindario",
          number: "Número",
          complement: "Complementar",
          gender: "Género",
          family_group: "Grupo familiar",
          add_family_group: "Añadir Grupo Familiar",
          family_individual: "Individual",
          kinship_degree: "Grado de Parentesco",
          imports: "Importaciones",
          confirm: {
            title: "¿Eliminar individuo?",
            description: "Esto eliminará permanentemente a la persona.",
          },
          errors: {
            name: "El nombre es obligatorio",
            document: "El documento es obligatorio.",
            document_regex: "Debe ser un documento válido",
            birth_date: "La fecha de nacimiento es obligatoria",
            country: "El país es obligatorio",
            gender: "El género es obligatorio",
            contact: {
              contactTypeId: "El tipo de contacto es obligatorio",
              phone: "Numero de telefono invalido",
              email: "Email inválido",
              site: "Sitio inválido",
              other: "El valor es obligatorio",
            },
            address: {
              addressTypeId: "El tipo de dirección es obligatorio",
              zipCode: "El código postal es obligatorio",
              city: "La ciudad es obligatoria",
              provincy: "El estado es obligatorio",
              addressDescription: "La calle es obligatoria",
              neighborhood: "El vecindario es obligatorio",
              number: "El número es obligatorio",
            },
            family_individual: "El individuo es obligatorio",
            kinship_degree: "El grado de parentesco es obligatorio",
          },
        },
        individualsImports: {
          imports: "Importaciones",
          import: "Importación",
          search: "Buscar una importación",
          new_import: "Nueva importación",
          file_name: "Nombre del archivo",
          normalized_file_name: "Nombre del archivo normalizado",
          status: "Status",
          add_import: "Añadir importación",
          view_individuals: "Ver Individuos",
          import_individuals: "Importar Individuos",
          import_successfully: "Importación realizada con éxito",
          download_model: "Descargar modelo",
          search_imports: "Buscar una importación",
        },
        importList: {
          imports_individuals: "Importar Individuos",
          name: "Nombre",
          document: "Documento",
          status: "Status",
          birth_date: "Fecha de nacimiento",
          gender: "Género",
          foreigner: "Extranjero",
          yes: "Sí",
          no: "No",
          cns: "CNS",
          address: "Dirección",
          number: "Número",
          neighborhood: "Vecindario",
          complement: "Complementar",
          city: "Ciudad",
          zip_code: "Código postal",
          country: "País",
          neighborhood_code: "Código de vecindario",
          city_ibge_code: "Código IBGE de la ciudad",
          identity_card: "Tarjeta de identificación",
          email: "Email",
          phone: "Teléfono",
          view: "Ver más",
        },
        documents: {
          documents: "Términos y políticas",
          new_document: "Nuevo documento",
          version: "Versión",
          date: "Fecha",
          document: "Documento",
          add_document: "Agregar documento",
          doc_type: "Tipo de Documento",
          select_doc_type: "Seleccionar tipo de documento",
          no_docs_selected: "No se seleccionó ningún tipo de documento",
          no_docs_version: "El tipo de documento no tiene ninguna versión",
          see_document: "ver documento",
          table_title: "Historial de versiones",
          export_csv: "Exportar CSV",
          docsVersion: {
            last_version: "Última versión",
            new_version: "Nueva versión",
            edit_version: "Editar",
          },
          create_document: {
            new_document: "Documento",
            add_new_language: "Añadir nuevo idioma",
            version: "Versión",
            version_date: "Fecha de la versión",
            add_document: "Agregar documento",
            language: "Idioma",
            name: "Nombre",
            content: "Contenido",
            enable: "Permitir",
            language_tooltip: "Ver idioma",
          },
          document_modal: {
            version: "Versión",
            version_date: "Fecha de la versión",
            name: "Nombre",
            language: "Idioma",
            content: "Contenido",
          },
          errors: {
            version: "La versión es obligatoria",
            version_regex: "La versión debe ser un número.",
            language: "El idioma es obligatorio",
            name: "El nombre es obligatorio",
            content: "El contenido es obligatorio",
          },
        },
        establishments: {
          establishments: "Establecimientos",
          establishment: "Establecimiento",
          new_establishment: "Nuevo establecimiento",
          name: "Nombre",
          ansCode: "Código de operador en ANS",
          integration: "Código de establecimiento del cliente",
          domain_admin: "Dominio del panel de administración",
          collector_host: "Anfitrión del coleccionista",
          parent_host: "Nube de recopiladores de host",
          real_time_host: "Anfitrión en tiempo real",
          search_establishment: "Buscar un nombre",
          add_establishment: "Añadir establecimiento",
          company: "Compañía",
          enable: "Permitir",
          config_on_premise: "Configuración del entorno local",
          notifications: "Notificaciones",
          critical_communication_emails:
            "Correos electrónicos para comunicaciones críticas",
          critical_communication_emails_info:
            "Ingrese las direcciones de correo electrónico separadas por comas",
          languages: "Idiomas",
          sync: "Sincronizar entorno on premise",
          sync_beneficiaries: "Sincronizar beneficiarios",
          see_establishments: "Ver Establecimiento on premise",
          see_params: "Ver Parámetros on premise",
          see_generics: "Ver Genéricos on premise",
          see_health: "Planes de salud sincronizados",
          see_medic_specialties_on_premise: "Ver especialidades médicas",
          see_medical_practice_areas: "Ver áreas de práctica médica",
          see_provider_types: "Ver tipos de proveedores",
          see_professional_councils: "Ver consejos profesionales",
          see_extensions: "Ver extensiones on premise",
          synced: "Sincronizado con éxito",
          jobs: "Jobs",
          crmDomain: "Dominio de CRM",
          telemedDomain: "Dominio de 4uTelemed",
          languages_tooltip: "Ver idiomas",
          extensions_on_premise: "Extensiones on premise",
          generics_on_premise: "Genéricos on premise",
          params_on_premise: "Parámetros on premise",
          establishment_on_premise: "Establecimiento on premise",
          health_on_premise: "Planes de salud sincronizados",
          medic_specialties_on_premise: "Especialidades médicas",
          provider_types_on_premise: "Tipos de proveedores",
          professional_councils_on_premise: "Consejos profesionales",
          medical_practice_areas_on_premise: "Áreas de práctica médica",
          domain: "Dominio",
          filemanager_host: "Host del filemanager en la nube",
          softwares: "Aplicaciones",
          legal_entity: "Persona Jurídica",
          confirm: {
            title: "¿Eliminar establecimiento?",
            description: "Esto eliminará permanentemente el establecimiento.",
          },
          errors: {
            name: "El nombre es obligatorio",
            company: "La empresa es obligatoria",
            languages: "Seleccione al menos un idioma",
            integration:
              "El código de establecimiento en el cliente debe ser mayor a 1",
            domain_admin:
              "El dominio del panel de administración es obligatorio",
            collector_https:
              "El host recopilador debe comenzar con 'http://' o 'https://'",
            parent_https:
              "La nube de recopiladores de host debe comenzar con 'http://' o 'https://'",
            real_time_https:
              "El host en tiempo real debe comenzar con 'http://' o 'https://'",
            domain_admin_https:
              "El dominio del panel de administración debe comenzar con 'http://' o 'https://'",
            filemanager_host_https:
              "El host del filemanager en la nube debe comenzar con 'http://' o 'https://'",
            ans_code: "El código de operador en ANS es obligatorio",
            filemanager_host:
              "El host del filemanager en la nube es obligatorio",
            parent_host: "La nube de recopiladores de host es obligatoria",
            collector_host: "El Anfitrión del coleccionista es obligatorio",
            real_time_host: "El anfitrión en tiempo real es obligatorio",
            critical_communication_emails:
              "Ingrese direcciones de correo electrónico válidas separadas por comas",
          },
        },
        countries: {
          countries: "Países",
          country: "País",
          search_country: "Buscar un nombre",
          add_country: "Añadir país",
          new_country: "Nuevo país",
          name: "Nombre",
          code: "Código",
          enable: "Permitir",
          ddi_code: "Código DDI",
          phone_mask: "Máscara de teléfono",
          phone_mask_help:
            "La máscara debe enviarse como por ejemplo: (00)000000000, donde el 'cero' representa los números de teléfono",
          confirm: {
            title: "¿Eliminar país?",
            description: "Esto eliminará permanentemente el país.",
          },
          errors: {
            code: "El código es obligatorio",
            name: "El nombre es obligatorio",
          },
        },
        cities: {
          cities: "Ciudades",
          city: "Ciudad",
          new_city: "Ciudad Nueva",
          name: "Nombre",
          provincy: "estado",
          enable: "Permitir",
          ibge_code: "Código IBGE",
          correio_code: "Código postal",
          search_city: "Buscar una ciudad",
          add_city: "Agregar ciudad",
          errors: {
            name: "El nombre es obligatorio",
            ibge_code: "El código IBGE es obligatorio",
            correio_code: "El código postal es obligatorio",
            provincy: "El estado es obligatorio",
          },
        },
        neighborhoods: {
          neighborhoods: "Barrios",
          neighborhood: "Barrio",
          new_neighborhood: "Nuevo barrio",
          search_neighborhoods: "Buscar un barrio",
          add_neighborhood: "Añadir barrio",
          name: "Nombre",
          code: "Código de Correios",
          city: "Ciudad",
          enable: "Permitir",
          errors: {
            name: "El nombre es obligatorio",
            city: "La ciudad es obligatoria",
          },
        },
        companies: {
          companies: "Compañías",
          company: "Empresa",
          search_company: "Buscar una empresa",
          add_company: "Añadir empresa",
          new_company: "Nueva empresa",
          name: "Nombre",
          code: "Código",
          enable: "Permitir",
          company_group: "Grupo de Negocios",
          confirm: {
            title: "¿Eliminar empresa?",
            description: "Esto eliminará permanentemente la empresa",
          },
          errors: {
            code: "El código es obligatorio",
            name: "El nombre es obligatório",
            company_group: "El grupo de negocios es obligatorio",
          },
        },
        digital_certificates: {
          digital_certificates: "Certificados Digitales",
          digital_certificate: "Certificado Digital",
          search_digital_certificate: "Buscar un certificado digital",
          add_digital_certificate: "Agregar Certificado Digital",
          new_digital_certificate: "Nuevo Certificado Digital",
          type_document: "Tipo de documento",
          document: "Documento",
          useCertillionLocalAgent: "Usar Certillion local",
          name: "Nombre",
          status: "Estado",
          active: "Activo",
          inactive: "Inactivo",
          enable: "Habilitar",
          created_successfully: "Certificado Digital creado con éxito",
          digital_certificate_files: "Archivos de Certificado Digital",
          yes: "Si",
          no: "No",
          digitalCertificateFile: {
            digital_certificate_files: "Archivos de Certificado Digital",
            digital_certificate_file: "Archivo de Certificado Digital",
            add_digital_certificate_file:
              "Agregar Archivo de Certificado Digital",
            new_digital_certificate_file:
              "Nuevo Archivo de Certificado Digital",
            search: "Buscar un archivo de certificado digital",
            initial_date: "Fecha Inicial",
            end_date: "Fecha Final",
            password: "Contraseña",
            password_caption:
              "Contraseña generada durante la creación del certificado digital",
            file: "Archivo",
            confirm: {
              title: "¿Eliminar archivo de certificado digital?",
              description:
                "Esto eliminará permanentemente el archivo de certificado digital",
            },
            errors: {
              initial_date: "La fecha inicial es obligatoria",
              end_date: "La fecha final es obligatoria",
              password: "La contraseña es obligatoria",
              file: "El archivo es obligatorio",
              date: "La fecha final debe ser mayor que la fecha inicial",
            },
          },
          confirm: {
            title: "¿Eliminar certificado digital?",
            description:
              "Esto eliminará permanentemente el certificado digital",
          },
          errors: {
            name: "El nombre es obligatorio",
            type_document: "El tipo de documento es obligatorio",
            document: "El documento es obligatorio",
            document_max_length:
              "El documento debe tener como maximo 18 caracteres",
            document_cpf_length: "El CPF debe tener 11 digitos",
            document_cnpj_length: "El CNPJ debe tener 14 digitos",
          },
        },
        provinces: {
          provinces: "Estados",
          province: "Estado",
          search_province: "Buscar un estado",
          add_province: "Agregar estado",
          new_province: "Nuevo estado",
          name: "Nombre",
          code: "Código",
          enable: "Permitir",
          country: "País",
          confirm: {
            title: "¿Eliminar estado?",
            description: "Esto eliminará permanentemente el estado.",
          },
          errors: {
            code: "El código es obligatorio",
            name: "El nombre es obligatorio",
            country: "El país es obligatorio",
          },
        },
        banks: {
          banks: "Bancos",
          bank: "Banco",
          search_bank: "Buscar un banco",
          add_bank: "Añadir banco",
          new_bank: "Nuevo banco",
          name: "Nombre",
          short_name: "Nombre corto",
          ispb_code: "Código ISPB",
          bacen_code: "Código Bacen",
          ibge_city_code: "Código IBGE de la Ciudad",
          confirm: {
            title: "¿Eliminar banco?",
            description: "Esto eliminará permanentemente el banco.",
          },
          errors: {
            name: "El nombre es obligatorio",
            ispb_code: "El código ISPB es obligatorio",
          },
        },
        totemDevice: {
          totem_devices: "Dispositivos Tótem",
          totem_device: "Dispositivo Tótem",
          new_totem_device: "Nuevo Dispositivo Tótem",
          add_totem_device: "Agregar Dispositivo Tótem",
          search: "Buscar un dispositivo tótem",
          name: "Nombre",
          code: "Código",
          observation: "Observación",
          device_password: "Contraseña del Dispositivo",
          token_4uBus: "Token 4uBus",
          integration_queues: "Colas de Integración",
          site_app: "Sitio o App",
          change_password: "Cambiar la contraseña",
          enable: "Habilitar",
          active: "Activo",
          inactive: "Inactivo",
          confirm: {
            title: "¿Eliminar el dispositivo tótem?",
            description: "Esto eliminará permanentemente el dispositivo tótem",
          },
          errors: {
            name: "El nombre es obligatorio",
            device_password: "La contraseña es obligatoria",
            token_4uBus: "El token 4uBus es obligatorio",
            integration_queues: "La cola de integración es obligatoria",
            site_app: "El sitio o la app es obligatoria",
          },
        },
        totem: {
          totems: "Tótems",
          totem: "Tótem",
          new_totem: "Nuevo Tótem",
          add_totem: "Agregar Tótem",
          search: "Buscar un tótem",
          name: "Nombre",
          type: "Tipo",
          status: "Estado",
          domains: "Dominios",
          domain: "Dominio",
          domain_type: "Tipo de Dominio",
          add_domain: "Agregar Dominio",
          front_config: "JSON de configuración del tema",
          my_totems: "Mis Tótems",
          active: "Activo",
          inactive: "Inactivo",
          confirm: {
            title: "¿Eliminar el tótem?",
            description: "Esto eliminará permanentemente el tótem",
          },
          errors: {
            name: "El nombre es obligatorio",
            type: "El tipo es obligatorio",
            status_type: "El estado es obligatorio",
            domain_type: "El tipo de dominio es obligatorio",
            front_config: "El JSON de configuración del tema es obligatorio",
            description: "La descripción es obligatoria",
            file: "El archivo es obligatorio",
            domain: "El dominio es obligatorio",
            domains: "Al menos un dominio es obligatorio",
          },
        },
        applications: {
          applications: "Aplicaciones",
          application: "Aplicación",
          new_application: "Nuevo Aplicación",
          add_application: "Agregar Aplicación",
          search: "Buscar una Aplicación",
          name: "Nombre",
          type: "Tipo",
          app_link: "Ingrese el enlace de la aplicación en la tienda",
          status: "Status",
          domains: "Dominios",
          domain: "Dominio",
          domain_type: "Tipo de dominio",
          add_domain: "Agregar dominio",
          front_config: "Configuración del tema JSON",
          chat_ticket_service: "Servicio de Tickets de '4uChat'",
          full_screen_mode: "Modo pantalla completa",
          chat_profile: "Perfil de 4uChat",
          chat_title: "Título",
          chat_subtitle: "Subtítulo",
          chat_bot_name: "Nombre del Bot",
          chat_width: "Ancho del chat (px)",
          chat_height: "Alto del chat (px)",
          chat_primary_color: "Color primario",
          chat_secondary_color: "Color secundario",
          chat_logo: "Logo de 4uChat",
          chat_bot_avatar: "Avatar del Bot",
          chat_file_empty: "Ningún archivo",
          chat_file_select: "Seleccionar",
          chat_file_change: "Cambiar",
          chat_file_invalid:
            "Archivo inválido: use .jpg, .jpeg, .png o .webp de hasta 2 MB",
          chat_file_error: "No fue posible enviar el archivo",
          chat_preview_message: "¡Hola! ¿Cómo puedo ayudar?",
          chat_preview_hint:
            "Vista previa meramente ilustrativa: franja superior del chat (logo, título y subtítulo) y mensaje del bot.",
          chat_embed_code: "Código para su sitio",
          chat_embed_code_hint:
            "Pegue este código antes del cierre de la etiqueta </body> del sitio. La dirección del script cambia según el ambiente.",
          chat_embed_copy: "Copiar código",
          chat_embed_update_hint:
            "Perfil de 4uChat modificado: después de guardar, actualice el código en su sitio para aplicar la configuración.",
          confirm: {
            title: "¿Borrar aplicación?",
            description: "Esto eliminará permanentemente la Aplicación",
          },
          banners: {
            banners: "Banners",
            banner: "Banner",
            new_banner: "Nuevo banner",
            search: "Buscar un banner",
            add_banner: "Añadir banner",
            name: "Nombre",
            title: "Título",
            alternative_text: "Texto alternativo",
            display_order: "Orden de visualización",
            language: "Idioma",
            site_apps: "Sites o Apps",
            banner_locals: "Ubicaciones donde se mostrará el banner",
            active: "Activo",
            inactive: "Inactivo",
            enable: "Permitir",
            status: "Status",
            media_file: "Archivo multimedia móvil",
            media_file_mobile: "Mobile Media File",
            application: "Aplicación",
            targetingLink: "Enlace de redirección",
            banner_local: "Ubicación de visualización del banner",
            confirm: {
              title: "¿Borrar site el banner?",
              description: "Esto eliminará permanentemente el banner",
            },
            errors: {
              name: "El nombre es obligatorio",
              targetingLink: "El enlace no es válido",
              title: "El título es obligatorio",
              alternative_text: "El texto alternativo es obligatorio",
              display_order: "La orden de visualización es obligatoria",
              language: "El idioma es obligatorio",
              site_apps: "Al menos un site o app es obligatorio",
              banner_locals: "Al menos una ubicación es obligatoria",
              file: "El archivo es obligatorio",
              display_order_negative:
                "El orden de visualización no puede ser menor que 0",
            },
            recommendedSize:
              "Dimensiones recomendadas para desktop {{desktopWidth}}x{{desktopHeight}} píxeles. Dimensiones recomendadas para la aplicación/móvil {{appWidth}}x{{appHeight}} píxeles.",
            freeSize: "Tamaño libre",
          },
          errors: {
            name: "El nombre es obligatorio",
            type: "El tipo es obligatorio",
            status_type: "El status es obligatorio",
            domain_type: "El tipo de dominio es obligatorio",
            front_config: "El configuración del tema JSON es obligatória",
            description: "La descripción es obligatoria",
            file: "El archivo es obligatorio",
            domain: "El dominio es obligatorio",
            domains: "Al menos un dominio es obligatorio",
            chat_width: "El ancho del chat debe estar entre 320 y 800 px",
            chat_height: "El alto del chat debe estar entre 360 y 900 px",
            chat_color: "El color debe ser hexadecimal (#RGB o #RRGGBB)",
          },
        },
        faq: {
          faqs: "Áreas de FAQ",
          faq: "Área de FAQ",
          new_faq: "Nueva área de FAQ",
          add_faq: "Añadir área de FAQ",
          search: "Buscar una área de FAQ",
          question_answer: "Pregunta y respuesta",
          active: "Activo",
          inactive: "Inactivo",
          status: "Status",
          name: "Nombre",
          enable: "Permitir",
          whatsapp_phone_number: "Numero de telefono Whatsapp",
          mail: "Email",
          site_app: "Sites o Apps",
          questions_answers: "Preguntas y Respuestas",
          display_order: "Orden de visualización",
          confirm: {
            title: "¿Borrar el FAQ?",
            description: "Esto eliminará permanentemente el FAQ.",
          },
          errors: {
            name: "El nombre es obligatorio",
            site_app: "Al menos un site o app es obligatorio",
            phone_email:
              "El numero de telefono Whatsapp o email es obligatorio",
            mail: "Proporcione un email válido",
            display_order: "La orden de visualización es obligatoria",
          },
        },
        questionsAnswers: {
          questions_answers: "Preguntas y Respuestas",
          question_answer: "Pregunta y Respuesta",
          search: "Buscar una pregunta y respuesta",
          add_questions_answers: "Añadir una pregunta y respuesta",
          new_question_answer: "Nueva pregunta y respuesta",
          display_order: "Orden de visualización",
          language: "Idioma",
          question: "Pregunta",
          answer: "Respuesta",
          enable: "Permitir",
          name: "Nombre",
          status: "Status",
          active: "Activo",
          inactive: "Inactivo",
          was_useful_count: "Recuento 'Fue útil'",
          confirm: {
            title: "¿Borrar la pergunta y respuesta?",
            description: "Esto eliminará permanentemente el FAQ.",
          },
          errors: {
            display_order: "La orden de visualización es obligatoria",
            question: "La pregunta es obligatoria",
            answer: "La respuesta es obligatoria",
            language: "El idioma es obligatorio",
          },
        },
        news: {
          all_news: "Noticias",
          news: "Noticias",
          new_news: "Nuevas noticias",
          add_news: "Añadir noticias",
          search: "Buscar noticias",
        },
        notifications: {
          notifications: "Notificaciones",
          notification: "Notificación",
          add_notification: "Añadir notificaciones",
          new_notification: "Nueva notificación",
          type: "Tipo de notificación",
          status: "Estado de notificación",
          title: "Título",
          content: "Contenido",
          search: "Buscar una notificación",
          site_app: "Sites o Apps",
          language: "Idioma",
          language_tooltip: "Ver idioma",
          contents: "Contenido del lote de notificaciones",
          add_new_content: "Añadir contenido",
          filters: "Filtros por lotes de notificaciones",
          add_new_filter: "Añadir nuevo filtro",
          minimum_age: "Edad mínima",
          maximum_age: "Edad máxima",
          payer: "Pagador",
          holder: "Poseedor",
          both: "Ambos",
          is_payer: "Es un pagador",
          is_not_payer: "No es un pagador",
          is_holder: "Es un titular",
          is_not_holder: "No es un titular",
          profiles: "Perfiles",
          gender: "Género",
          users: "Usuarios",
          start_publish: "Inicio de publicación",
          finish_publish: "Fin de publicación",
          registered: "Registrado",
          generating: "Generando",
          generated: "Generado",
          canceled: "Cancelado",
          error: "Error al generar",
          push_notification: "Generar PushNotification",
          enable: "Permitir",
          rule_codes: "Códigos de reglas",
          rule_codes_helper: "Ingrese códigos de regla separados por comas",
          date_start_rule: "Fecha de inicio de la regla",
          content_info: "Puedes agregar las variables: {{variables}}",
          active_status: "Status",
          active: "Activo",
          inactive: "Inactivo",
          cleanFilters: {
            title: "¿Realmente quieres cambiar el tipo de notificación?",
            description:
              "Al cambiar el tipo de notificación, se eliminarán todos los filtros",
            confirm: "Si, cambiar",
            cancel: "Cancelar",
          },
          confirm: {
            title: "¿Borrar la notificación?",
            description: "Esto eliminará permanentemente la notificación.",
          },
          errors: {
            type: "El tipo de notificación es obligatorio",
            site_app: "Al menos un site o app es obligatorio",
            contents: "Al menos un contenido es obligatorio",
            language: "El idioma es obligatorio",
            title: "El título es obligatorio",
            content: "El contenido es obligatorio",
            notification_batch_filter:
              "Si los campos 'Pagador' y 'Titular' tienen el valor 'Ambos', al menos uno de los campos siguientes es obligatorio",
            variables:
              "Una variable que no existe en la lista fue agregada a uno de los contenidos",
            rule_codes: "Los códigos de regla son obligatorios",
            date_start_rule: "La fecha de inicio de la regla es obligatoria",
          },
        },
        notifiedUsers: {
          notified_users: "Usuarios notificados",
          search: "Buscar un usuario",
          user: "Usuario",
          read_date: "Fecha de lectura",
          acceptance_date: "Fecha de aceptación",
          acceptance_data: "Datos de aceptación",
        },
        extensions: {
          extensions: "Extensiones",
          search_name: "Buscar un nombre",
          extension: "Extensión",
          new_extension: "Nueva extensión",
          presentation_order: "Orden de presentación",
          software: "Software",
          name: "Nombre",
          title: "Título",
          description: "Descripción",
          tags: "Tags",
          files: "Archivos",
          file: "Archivo",
          media_files: "Archivos multimedia",
          add_media_file: "Agregar archivo",
          media_type_code: "Tipo de medio",
          extension_dependencies: "Tiene dependencia de extensiones.",
          extension_targets: "Disponible para tipos de aplicaciones",
          enable: "Permitir",
          is_required_setup: "Requiere configuración para la instalación",
          status: "Status",
          active: "Activo",
          inactive: "Inactivo",
          actions: {
            default_settings: "Configuración por defecto",
            price_rules: "Reglas de precio",
          },
          defaultSettings: {
            default_settings:
              "Configuración predeterminada para: {{extension}}",
            default_setting: "Configuración predeterminada",
            identifier: "Identificador",
            property: "Propiedad",
            value: "Valor",
            description: "Descripción",
            search_identifier: "Buscar identificador",
            add_default_setting: "Agregar configuración predeterminada",
            new_default_setting: "Nueva configuración predeterminada",
            is_public:
              "La configuración de extensión predeterminada es pública",
            errors: {
              identifier: "El identificador es obligatorio",
              value: "El valor es obligatorio",
              property: "La propiedad es obligatoria",
              description: "La descripción es obligatoria",
            },
            confirm: {
              title: "¿Borrar configuración por defecto?",
              description:
                "Esto eliminará permanentemente la configuración por defecto.",
            },
          },
          priceRules: {
            price_rules: "Reglas de precio para: {{extension}}",
            price_rule: "Regla de precio",
            search_type: "Buscar un tipo",
            add_price_rule: "Agregar regla de precio",
            type: "Tipo",
            initial_date: "Inicio del trimestre",
            end_date: "Fin de validez",
            value: "Valor",
            errors: {
              type: "El tipo es obligatorio",
              initial_date: "El inicio del trimestre es obligatorio",
              end_date: "El fin de validez es obligatorio",
              value: "El valor es obligatorio",
            },
            confirm: {
              title: "¿Borrar regla de precio?",
              description: "Esto eliminará permanentemente la regla de precio.",
            },
          },
          errors: {
            display_order: "El orden de presentación es obligatorio",
            software: "El software es obligatorio",
            name: "El nombre es obligatorio",
            title: "El título es obligatorio",
            tags: "Al menos una tag es obligatoria",
            file: "El archivo es obligatorio",
            file_type:
              "Sólo se admiten tipos de archivos .jpg, .jpeg, .png y .webp",
            file_size: "El tamaño máximo permitido es 5MB",
            extension_targets: "Al menos una aplicación es obrigatoria",
          },
        },
        cardsTemplates: {
          cards_templates: "Plantillas de Tarjetas",
          card_template: "Plantilla de Tarjeta",
          search: "Buscar una tarjeta",
          new_card_template: "Nueva Plantilla de Tarjeta",
          add_card_template: "Agregar Plantilla de Tarjeta",
          initial_date: "Inicio del trimestre",
          end_date: "Fin de los términos",
          health_plan: "Plan de salud",
          enable: "Permitir",
          establishment_param_type:
            "Tipo de parámetro de establecimiento directo",
          establishment_param_type_back:
            "Tipo de parámetro de establecimiento para espalda",
          confirm: {
            title: "¿Eliminar plantilla de tarjeta?",
            description:
              "Esto eliminará permanentemente la plantilla de tarjeta",
          },
          errors: {
            initial_date: "El inicio del trimestr es obligatorio",
            end_date: "El fin de los términos es obligatorio",
            health_plan: "El plan de salud es obligatorio",
            establishment_param_type:
              "El tipo de parámetro de establecimiento directo es obligatorio",
            establishment_param_type_back:
              "El tipo de parámetro de establecimiento para espalda es obligatorio",
          },
        },
        companyGroups: {
          company_groups: "Grupos Empresariales",
          company_group: "Grupo de negocios",
          new_company_group: "Nuevo grupo de negocios",
          search_company_groups: "Buscar un grupo de negocios",
          add_company_group: "Añadir grupo de negocios",
          name: "Nombre",
          code: "Código",
          is_main: "Principal",
          enable: "Permitir",
          filter_restriction_type: "Tipo de restricción de filtro",
          confirm: {
            title: "¿Eliminar grupo de negocios?",
            description: "Esto eliminará permanentemente el grupo de negocios",
          },
          errors: {
            name: "El nombre es obligatorio",
            code: "El código es obligatorio",
            filter_restriction_type:
              "El tipo de restricción de filtro es obligatorio",
          },
        },
        paramDefaultEstablishment: {
          param_default_establishment: "Parámetros de establecimiento estándar",
          param_default: "Parámetro de establecimiento estándar",
          new_param_default:
            "Nuevo parámetro predeterminado de establecimiento",
          search_param: "Buscar un parámetro",
          add_param: "Añadir parámetro predeterminado",
          establishment_param_type: "Tipo de parámetro del establecimiento",
          value: "Valor",
          description: "Descripción",
          confirm: {
            title: "¿Eliminar parámetro de establecimiento estándar?",
            description:
              "Esto eliminará permanentemente el parámetro de establecimiento estándar",
          },
          errors: {
            param_type:
              "El tipo de parámetro del establecimiento es obligatorio",
            value: "El valor es obligatorio",
            description: "La descripción es obligatoria",
          },
        },
        holidays: {
          holidays: "Vacaciones",
          holiday: "Día festivo",
          new_holiday: "Nuveo día festivo",
          search_holiday: "Buscar unas vacaciones",
          add_holiday: "Añadir vacaciones",
          name: "Nombre",
          description: "Descripción",
          holiday_type: "Tipo de vacaciones",
          date: "Fecha",
          import_holidays: "Importar feriados nacionales",
          filter: "Filtrar",
          confirm: {
            title: "¿Eliminar vacaciones?",
            description: "Esto eliminará permanentemente el día festivo.",
          },
          errors: {
            name: "El nombre es obligatorio",
            description: "La descripción es obligatoria",
            holiday_type: "El tipo de caciones es obligatorio",
            date: "La fecha es obligatoria",
          },
        },
        individualValidation: {
          individual_validations: "Validación de Registro PF",
          search: "Buscar un registro",
          individual: "Individual",
          name: "Nombre",
          document: "CPF",
          status: "Status",
          all: "Todos",
          approved: "Aprobado",
          disapproved: "Rechazado",
          pending: "Pendiente de Aprobación",
          created: "Fecha de creación",
          photos_sent: "Fotos Subidas",
          approve_registrations: "Aprobación de Registro",
          not_found: "¡Ups, no se encontró el registro!",
          no_registrations:
            "No hay más registros para validar, por favor inténtalo de nuevo más tarde",
          birth_date: "Fecha de Nacimiento",
          email: "Email",
          whatsapp_number: "Número de WhatsApp",
          approved_by: "Aprobado por",
          approved_at: "Aprobado en",
          disapproved_by: "Rechazado por",
          disapproved_at: "Falló en",
          copy: "Copiar",
          copied_successfully: "Copiado exitosamente",
          actions: {
            approved: "Registro aprobado exitosamente!",
            disapproved: "Registro rechazado exitosamente!",
            disapprove_modal: {
              title: "¿Realmente quieres rechazar el registro?",
              description: "Esto desaprobará permanentemente el registro.",
              cancel: "Cancelar",
              confirm: "Si, rechazar",
            },
            disapprove: "Rechazar",
            approve: "Aprobar",
          },
          photo_item: {
            person: "Persona",
            front_doc: "Documento Frontal",
            back_doc: "Documento Atrás",
            person_doc: "Persona con el Documento",
            error: "¡Ups, hubo un error al cargar la foto!",
          },
        },
      },
      additionalSettings: {
        additionalSettings: "Ajustes adicionales",
        search: "Buscar una configuración",
      },
      extensionsStore: {
        title: "Explora el máximo potencial de tu plan",
        subtitle:
          "Consulta las extensiones disponibles para tu plan y obtén una solución aún más completa para tu negocio.",
        no_data: "¡No se encontraron extensiones!",
        no_data_install:
          "Verifique sus extensiones ya instaladas. No hay nuevas extensiones para mostrar.",
        no_data_installed:
          "Consulta lo que hay disponible en la tienda. No hay extensiones instaladas para mostrar.",
        installed_successfully: "Extensión instalada exitosamente",
      },
      noAccess: {
        message:
          "¡Ups! ¡Parece que no tienes permiso para acceder a esta página!",
        button: "volver arriba",
      },
      user_menu: {
        preferences: "Preferencias",
        theme: "Tema",
        theme_description: "Alternar entre el tema claro y oscuro",
        language: "Idioma",
        language_description: "Seleccione el idioma del sistema",
        establishment: "Establecimiento",
        establishment_description:
          "Definir el establecimiento predeterminado al iniciar sesión en el sistema",
        notifications: "Activar notificaciones sonoras y del navegador",
        notifications_description:
          "Reciba una alerta sonora y una notificación del navegador",
        notifications_blocked:
          "Las notificaciones están bloqueadas en la configuración del navegador",
      },
      settings: {
        settings: "Ajustes",
        general: "General",
        cache: "Cache",
        "4uBus": {
          configs: {
            configs: "Configuración general",
            config: "Configuración general",
            new_config: "Nueva configuración general",
            search: "Buscar una configuración general",
            add_config: "Añadir configuración general",
            host_4ubus: "Host de 4uBus",
            host_aws: "Host de AWS",
            host_postgres_api: "Host de API Postgres",
            establishment: "Establecimiento",
            confirm: {
              title: "¿Eliminar la configuración general?",
              description:
                "Esto eliminará permanentemente la configuración general.",
            },
            errors: {
              host_4ubus: "El host de 4uBus es obligatorio",
              host_aws: "El host de AWS es obligatorio",
              host_4ubus_https:
                "El host de 4uBus debe comenzar con 'http://' o 'https://'",
              host_aws_https:
                "El host de AWS debe comenzar con 'http://' o 'https://'",
              host_postgres_api_https:
                "El host de API Postgres debe comenzar con 'http://' o 'https://'",
            },
          },
          ipm: {
            generalSettings: {
              general_settings: "IPM configuración general",
              general_setting: "IPM configuración general",
              new_general_setting: "Nueva configuración general",
              search: "Buscar una configuración general",
              add_general_setting: "Añadir configuración general",
              host: "Host",
              hostAuth: "Host autorización",
              establishment: "Estabelecimento",
              ipm_user: "Usuario IPM",
              ipm_password: "Contraseña IPM",
              token_4ubus: "Token de 4uBus",
              token_copy: "Copiar token",
              token_copied: "Token de 4uBus copiado exitosamente",
              itens_per_batch: "Artículos por lote",
              total_batches: "Lotes totales",
              ipm_version: "Versión de IPM",
              heart_beat_time_minutes:
                "Tiempo de verificación por lotes en minutos",
              establishment_codes:
                "Código de establecimientos de envío (separados por coma)",
              confirm: {
                title: "¿Eliminar la configuración general?",
                description:
                  "Esto eliminará permanentemente la configuración general.",
              },
              errors: {
                host: "El host es obligatorio",
                ipm_user: "El usuario IPM es obligatorio",
                ipm_password: "La contraseña IPM es obligatoria",
                token_4ubus: "El token de 4uBus es obligatorio",
                host_https: "El host debe comenzar con 'http://' o 'https://'",
                itens_per_batch: "Los artículos por lote son obligatorios",
                total_batches: "El número total de lotes es obligatorio",
                heart_beat_time_minutes:
                  "El tiempo de verificación por lotes en minutos es obligatorio",
                establishment_codes:
                  "El código de establecimientos de envío es obligatorio",
                ipm_version: "La versión de IPM es obligatoria",
              },
            },
          },
          zScan: {
            examSendRule: {
              exam_send_rules: "Reglas de envío de exámenes",
              exam_send_rule: "Regla de envío de exámenes",
              add_exam_send_rule: "Añadir regla de envío de exámenes",
              new_exam_send_rule: "Nueva regla de envío de exámenes",
              target_machine: "Máquina de destino",
              proc_classification_integration_id:
                "ID de clasificación del procedimiento",
              initial_date: "Fecha de inicio",
              end_date: "Fecha final",
              enable: "Permitir",
              status: "Status",
              active: "Activo",
              inactive: "Inactivo",
              errors: {
                target_machine: "La máquina de destino es obligatoria",
                proc_classification_integration_id:
                  "El ID de clasificación del procedimiento es obligatorio",
                initial_date: "La fecha de inicio es obligatoria",
                end_date: "La fecha final es obligatoria",
                initial_date_bigger: "La fecha de inicio no puede ser mayor",
              },
              confirm: {
                title: "¿Eliminar la regla de envío de exámenes?",
                description:
                  "Esto eliminará permanentemente la regla de envío de exámenes",
              },
            },
          },
          externalExamPrescription: {
            rules: {
              rules: "Reglas de Generación de Recetas",
              rule: "Regla de Generación de Recetas",
              new_rule: "Nueva regla de generación de recetas",
              add_rule: "Añadir regla de generación de recetas",
              search: "Buscar una regla de generación de recetas",
              medical_procedure_type_code:
                "Código de Tipo de Procedimiento Médico",
              sector_code: "Código de Sector",
              exec_physician_code: "Código de Médico Ejecutivo",
              patient_insurance_code: "Código de Seguro del Paciente",
              initial_date: "Fecha de Inicio",
              end_date: "Fecha Final",
              is_exception: "Es Excepción",
              yes: "Sí",
              no: "No",
              if: "Si",
              then: "Entonces",
              exception: "Excepción (No genera prescripción)",
              errors: {
                initial_date: "La fecha de inicio es obligatoria",
                end_date: "La fecha final es obligatoria",
                initial_date_bigger:
                  "La fecha de inicio no puede ser mayor que la fecha final",
                medical_procedure_type_code:
                  "El código de tipo de procedimiento médico es obligatorio",
                sector_code: "El código del médico ejecutor es obligatorio",
                execPhysicianCode: "O código do médico executor é obrigatório",
                max_medical_procedure_type_code:
                  "El código de tipo de procedimiento médico no puede tener más de 3 caracteres",
                max_sector_code:
                  "El código de sector no puede tener más de 5 caracteres",
                max_exec_physician_code:
                  "El código del médico ejecutor no puede tener más de 10 caracteres",
                max_patient_insurance_code:
                  "El código de seguro del paciente no puede tener más de 5 caracteres",
              },
              confirm: {
                title: "¿Eliminar la regla de generación de recetas?",
                description:
                  "Esto eliminará permanentemente la regla de generación de recetas",
              },
            },
          },
        },
        crm: {
          ticketAutoFinishRules: {
            ticket_auto_finish_rules: "Reglas de Finalización de Ticket (Card)",
            ticket_auto_finish_rule: "Regla de Finalización de Ticket (Card)",
            add_ticket_auto_finish_rule:
              "Añadir Regla de Finalización de Ticket (Card)",
            new_ticket_auto_finish_rule:
              "Nueva regla de finalización de ticket (card)",
            search: "Buscar una regla de finalización de ticket (card)",
            message: "Mensaje",
            minutes: "Minutos",
            initial_date: "Fecha de inicio",
            end_date: "Fecha final",
            finish_type: "Tipo de Finalización",
            finish_by_time: "Por Tiempo",
            finish_end_of_day: "Al Final del Día",
            finish_not_selected: "No Seleccionado",
            enable: "Activo",
            active: "Sí",
            inactive: "No",
            finish_rule: "Finalizar",
            finish: "Finalizado",
            end_of_day: "Finalizar al final del día (00:00)",
            finish_indifferent_person:
              "Finalizar indiferente a la persona de la interacción",
            ticket_type: "Tipo de ticket (card)",
            ticket_channel: "Marco",
            ticket_channel_step: "Lista do marco",
            ticket_workspace: "Área de trabajo",
            move_finished_to: "Traslado terminado a",
            ticket_channel_step_transfer: "Mover terminado a la lista",
            message_helper:
              "La variable {{protocolNumber}} será reemplazada por el número de protocolo asignado al ticket (card)",
            confirm: {
              title: "¿Eliminar la regla de finalización de ticket (card)?",
              description:
                "Esto eliminará permanentemente la regla de finalización de ticket (card).",
            },
            errors: {
              minutes: "Los minutos son obligatorios",
              max_minutes: "El valor no puede ser mayor que 1440",
              ticket_type: "El tipo de ticket (card) es obligatorio",
              ticket_channel: "El marco es obligatorio",
              initial_date: "La fecha de inicio es obligatoria",
              end_date: "La fecha final es obligatoria",
              end_date_less:
                "La fecha final no puede ser inferior a la fecha de inicio.",
              message: "La mensaje es obligatoria",
              ticket_workspace: "La área de trabajo es obligatoria",
              ticket_channel_step: "La lista do marco es obligatoria",
            },
          },
          ticketAutoTransferRules: {
            ticket_auto_transfer_rules:
              "Reglas de Transferencia de Ticket(Card)",
            ticket_auto_transfer_rule: "Regla de Transferencia de Ticket(Card)",
            add_ticket_auto_transfer_rule:
              "Agregar Regla de Transferencia de Ticket(Card)",
            new_ticket_auto_transfer_rule:
              "Nueva Regla de Transferencia de Ticket(Card)",
            search: "Buscar una Regla de Transferencia de Ticket(Card)",
            message: "Mensaje",
            minutes: "Minutos",
            initial_date: "Fecha de Inicio",
            end_date: "Fecha de Fin",
            transfer_indifferent_person:
              "Transferir indiferente a la persona de la interacción",
            transfer: "Transferir",
            transfer_type: "Tipo de Transferencia",
            transfer_by_time: "Por Tiempo",
            transfer_end_of_day: "Al Final del Día",
            transfer_not_selected: "No Seleccionado",
            enable: "Activo",
            active: "Sí",
            inactive: "No",
            end_of_day: "Transferir al final del día (00:00)",
            transfer_to: "Transferir para",
            transfering: "Transfiriendo",
            ticket_type: "Tipo de Ticket(Card)",
            ticket_channel: "Tablero",
            ticket_channel_step: "Lista del Tablero",
            ticket_channel_transfer: "Transferir al tablero",
            ticket_channel_step_transfer: "Transferir a la lista",
            ticket_workspace: "Área de Trabajo",
            ticket_service: "Servicio de ticket(card)",
            ticket_service_area: "Área de servicio",
            ticket_auto_transfer_rule_hour_atend: "Tipo de horario de atención",
            message_helper:
              "La variable {{protocolNumber}} será reemplazada por el número de protocolo asignado al ticket(card)",
            confirm: {
              title: "¿Eliminar Regla de Transferencia de Ticket(Card)?",
              description:
                "Esto eliminará permanentemente la Regla de Transferencia de Ticket(Card)",
            },
            errors: {
              minutes: "Los minutos son obligatorios",
              max_minutes: "El valor no puede ser mayor que 1440",
              ticket_type: "El tipo de ticket(card) es obligatorio",
              ticket_channel: "El tablero es obligatorio",
              initial_date: "La fecha de inicio es obligatoria",
              end_date: "La fecha de fin es obligatoria",
              end_date_less:
                "La fecha de fin no puede ser menor que la fecha de inicio",
              message: "El mensaje es obligatorio",
              ticket_workspace: "El área de trabajo es obligatoria",
              ticket_channel_step: "La lista del tablero es obligatoria",
              ticket_channel_step_transfer:
                "La lista del tablero para transferencia es obligatoria",
              ticket_service: "El servicio de ticket(card) es obligatorio",
              ticket_auto_transfer_rule_hour_atend:
                "El tipo de horario de atención es obligatorio",
            },
          },
          sendLimitMonths: {
            send_limits_months:
              "Límites de Envío Mensual (Presupuesto de la Empresa)",
            send_limit_months:
              "Límite de Envío Mensual (Presupuesto de la Empresa)",
            search: "Buscar un límite de envío mensual",
            add_send_limit_months: "Agregar límite de envío mensual",
            new_send_limit_months: "Nuevo límite de envío mensual",
            active: "Activo",
            enabled: "Sí",
            disabled: "No",
            enable: "Habilitar",
            name: "Nombre",
            ticket_service: "Servicio de ticket (tarjeta)",
            start_date: "Fecha de inicio",
            end_date: "Fecha de finalización",
            quantity: "Cantidad",
            alert_percent_limit: "Porcentaje de alerta",
            alert_mail:
              "Correos electrónicos de alerta (use ; para separarlos)",
            description: "Descripción",
            confirm: {
              title: "¿Eliminar límite de envío mensual?",
              description:
                "Esto eliminará permanentemente el límite de envío mensual",
            },
            errors: {
              name: "El nombre es obligatorio",
              ticket_service: "El servicio de ticket es obligatorio",
              start_date: "La fecha de inicio es obligatoria",
              end_date: "La fecha de finalización es obligatoria",
              end_date_less:
                "La fecha de finalización no puede ser anterior a la de inicio",
              value_limit: "La cantidad límite es obligatoria",
              alert_mail: "Debe ingresar al menos un correo electrónico",
              alert_percent_limit:
                "El porcentaje de alerta debe estar entre 0 y 100",
            },
          },
          sendLimitDiaries: {
            send_limits_diaries:
              "Límites de Envío Diario (Presupuesto de la Empresa)",
            send_limit_diaries:
              "Límite de Envío Diario (Presupuesto de la Empresa)",
            search: "Buscar un límite de envío diario",
            add_send_limit_diaries: "Agregar límite de envío diario",
            new_send_limit_diaries: "Nuevo límite de envío diario",
            active: "Activo",
            enabled: "Sí",
            disabled: "No",
            enable: "Habilitar",
            name: "Nombre",
            ticket_service: "Servicio de ticket (tarjeta)",
            start_date: "Fecha de inicio",
            end_date: "Fecha de finalización",
            automation: "Automatización (Opcional)",
            quantity: "Cantidad",
            alert_mail:
              "Correos electrónicos de alerta (use ; para separarlos)",
            description: "Descripción",
            confirm: {
              title: "¿Eliminar límite de envío diario?",
              description:
                "Esto eliminará permanentemente el límite de envío diario",
            },
            errors: {
              name: "El nombre es obligatorio",
              ticket_service: "El servicio de ticket es obligatorio",
              start_date: "La fecha de inicio es obligatoria",
              end_date: "La fecha de finalización es obligatoria",
              end_date_less:
                "La fecha de finalización no puede ser anterior a la de inicio",
              value_limit: "La cantidad límite es obligatoria",
              alert_mail: "Debe ingresar al menos un correo electrónico",
            },
          },
          protocolsDefault: {
            protocols_default: "Protocolos de Orientación Estándar",
            protocol_default: "Protocolo de Orientación Estándar",
            ticket_automation: "Automatizaciones",
            button_type: "Tipo de botón",
            add: "Agregar Botón",
            button_title: "Botones",
            label: "Etiqueta",
            value: "Valor",
            link: "Enlace",
            counter_hint: "Cantidad actual / máximo permitido",
            new_protocol_default: "Nuevo protocolo de orientación estándar",
            add_protocol_default: "Añadir protocolo de orientación estándar",
            search: "Buscar un protocolo de orientación estándar",
            title: "Título",
            message: "Mensaje",
            restriction_type: "Tipo de restricción",
            category: "Categoría",
            workspace: "Área de trabajo",
            workspaces: "Áreas de trabajo",
            restriction_type_board: "Tablero",
            channel: "Canal",
            channels: "Canales",
            file: "Archivo",
            description: "Descrición",
            media_files: "Archivos multimedia",
            add_media_file: "Añadir archivo",
            enable: "Permitir",
            status: "Status",
            active: "Activo",
            inactive: "Inactivo",
            buttons_no_integligence_warning:
              "Estos botones no tienen ninguna inteligencia ni acción automática por parte de la plataforma 4uHub. Su uso es totalmente responsabilidad y riesgo del usuario.",
            confirm: {
              title: "¿Eliminar el protocolo de orientación estándar?",
              description:
                "Esto eliminará permanentemente el protocolo de orientación estándar.",
            },
            errors: {
              title: "El título es obligatorio",
              message: "La mensaje es obligatoria",
              restriction_type: "El tipo de restricción es obligatorio",
              category: "La categoría es obligatoria",
              workspaces: "Al menos una área de trabajo es obligatoria",
              channels: "Al menos un canal es obligatorio",
              description: "La descripción es obligatoria",
              file: "El archivo es obligatorio",
              media_files: "Al menos un archivo es obligatorio",
              min_description: "La descrición es obligatoria",
              max_description:
                "La descripción no puede tener más de 1000 caracteres",
              value: "El valor es obligatorio",
              label: "La etiqueta es obligatoria",
              button_link_required:
                "El botón debe contener un enlace válido (http o https)",
            },
          },
          ticketDefaultDocCategories: {
            ticket_default_doc_categories:
              "Categorías de Protocolos de Orientación Estándar",
            ticket_default_doc_category:
              "Categoría de Protocolo de Orientación Estándar",
            new_ticket_default_doc_category:
              "Nueva categoría de protocolo de orientación estándar",
            add_ticket_default_doc_category:
              "Añadir categoría de protocolo de orientación estándar",
            search: "Buscar una categoría de protocolo de orientación estándar",
            code: "Código",
            name: "Nombre",
            confirm: {
              title:
                "¿Eliminar categoría de protocolo de orientación estándar?",
              description:
                "Esto eliminará permanentemente la categoría de protocolo de orientación estándar",
            },
            errors: {
              name: "El nombre es obligatorio",
            },
          },
          events: {
            events: "Eventos",
            event: "Evento",
            new_event: "Nuevo evento",
            add_event: "Añadir evento",
            search: "Buscar un evento",
            name: "Nombre",
            event_type: "Tipo de evento",
            code: "Código",
            enable: "Permitir",
            status: "Status",
            active: "Activo",
            inactive: "Inactivo",
            manage_event_types: "Gerenciar tipos de evento",
            ticket_automations: "Automatizaciones",
            confirm: {
              title: "¿Eliminar el evento?",
              description: "Esto eliminará permanentemente el evento",
            },
            errors: {
              name: "El nombre es obligatorio",
              event_type: "El tipo de evento es obligatorio",
              code: "El código es obligatorio",
            },
          },
          eventTypes: {
            event_types: "Tipos de Evento",
            event_type: "Tipo de Evento",
            new_event_type: "Nuevo tipo de evento",
            add_event_type: "Añadir tipo de evento",
            search: "Buscar un tipo de evento",
            name: "Nombre",
            enable: "Permitir",
            code: "Código",
            status: "Status",
            active: "Activo",
            inactive: "Inactivo",
            confirm: {
              title: "¿Eliminar el tipo de evento?",
              description: "Esto eliminará permanentemente el tipo de evento",
            },
            errors: {
              name: "El nombre es obligatorio",
            },
          },
          externalProcessType: {
            external_process_types: "Tipos de Procesos Externos",
            external_process_type: "Tipo de Proceso Externo",
            add_external_process_type: "Añadir tipo de proceso externo",
            new_external_process_type: "Nuevo tipo de proceso externo",
            search: "Buscar un tipo de proceso externo",
            name: "Nombre",
            confirm: {
              title: "¿Eliminar el tipo de proceso externo?",
              description:
                "Esto eliminará permanentemente el tipo de proceso externo",
            },
            errors: {
              name: "El nombre es obligatorio",
            },
          },
          ticketAutoInactivityRules: {
            ticket_auto_inactivity_rules:
              "Reglas de Inactividad de Ticket(Card)",
            ticket_auto_inactivity_rule: "Regla de Inactividad de Ticket(Card)",
            add_ticket_auto_inactivity_rule:
              "Agregar regla de inactividad de ticket(card)",
            new_ticket_auto_inactivity_rule:
              "Nueva regla de inactividad de ticket(card)",
            search: "Buscar una regla de inactividad de ticket(card)",
            ticket_channel: "Tablero",
            ticket_channel_step: "Lista del tablero",
            minutes: "Minutos",
            initial_date: "Fecha de inicio",
            end_date: "Fecha de fin",
            ticket_type: "Tipo de ticket(card)",
            ticket_workspace: "Área de trabajo",
            message: "Mensaje",
            confirm: {
              title: "¿Eliminar regla de inactividad de ticket(card)?",
              description:
                "Esto eliminará permanentemente la regla de inactividad de ticket(card)",
            },
            errors: {
              minutes: "Valor mínimo requerido de 5 minutos",
              max_minutes: "El valor no puede ser mayor que 1440",
              ticket_type: "El tipo de ticket(card) es obligatorio",
              ticket_channel: "El tablero es obligatorio",
              initial_date: "La fecha de inicio es obligatoria",
              end_date: "La fecha de fin es obligatoria",
              end_date_less:
                "La fecha de fin no puede ser anterior a la de inicio",
              ticket_workspace: "El área de trabajo es obligatoria",
            },
          },
        },
        preventMedicine: {
          workGroupTypes: {
            work_group_types: "Tipos de Grupo de Trabajo",
            work_group_type: "Tipo de Grupo de Trabajo",
            new_work_group_type: "Nuevo tipo de grupo de trabajo",
            add_work_group_type: "Añadir tipo de grupo de trabajo",
            enable: "Permitir",
            status: "Status",
            active: "Activo",
            inactive: "Inactivo",
            languages: "Idiomas",
            language: "Idioma",
            add_language: "Añadir idioma",
            name: "Nombre",
            description: "Descripción",
            search: "Buscar un grupo de trabajo",
            confirm: {
              title: "¿Eliminar el grupo de trabajo?",
              description:
                "Esto eliminará permanentemente el grupo de trabajo.",
            },
            errors: {
              name: "El nombre es obligatorio",
              language: "El idioma es obligatorio",
            },
          },
          healthProgramTypes: {
            health_program_types: "Tipos de Programas de Salud",
            health_program_type: "Tipo de Programa de Salud",
            new_health_program_type: "Nuevo tipo de programa de salud",
            add_health_program_type: "Añadir Tipo de Programa de Salud",
            search: "Buscar un tipo de programa de salud",
            name: "Nombre",
            language: "Idioma",
            description: "Descripción",
            enable: "Permitir",
            status: "Status",
            active: "Activo",
            inactive: "Inactivo",
            characters: "caracteres",
            add_language: "Añadir idioma",
            confirm: {
              title: "¿Eliminar el tipo de programa de salud?",
              description:
                "Esto eliminará permanentemente el tipo de programa de salud.",
            },
            errors: {
              name: "El nombre es obligatorio",
              description:
                "La descripción no puede tener más de 500 caracteres.",
            },
          },
        },
        generalSettings: {
          healthChecks: {
            health_checks: "Health Checks de Microservicios 4uHub",
            health_check: "Health Check de Microservicios 4uHub",
            new_health_check: "Novo health check de microservicios 4uHub",
            add_health_check: "Adicionar Health Check de Microservicios 4uHub",
            search: "Buscar un health check de microservicios 4uHub",
            name: "Nombre",
            uri: "URI",
            establishment: "Establecimiento",
            payload: "Payload de falla",
            restored_payload: "Restaurar payload",
            webhook_url: "URL de Webhook",
            enable: "Enable",
            status: "Status",
            active: "Active",
            inactive: "Inactive",
            confirm: {
              title: "¿Eliminar el health check de microservicios 4uHub?",
              description:
                "Esto eliminará permanentemente el health check de microservicios 4uHub.",
            },
            errors: {
              name: "El nombre es obligatorio",
              uri: "El URI es obligatorio",
              payload: "El payload de falla es obligatorio",
              restored_payload: "El restaurar payload de falla es obligatorio",
              webhook_url: "La URL de Webhook es obligatoria",
              webhook_url_http:
                "La URL de Webhook debe comenzar con 'http://' o 'https://'",
              establishment: "El establecimiento es obligatorio",
            },
          },
        },
        schedule: {
          scheduleCheckIn: {
            schedule_check_in: "Check In",
            add_schedule_check_in: "Añadir check in",
            new_schedule_check_in: "Nuevo check in",
            meters_approximation: "Aproximación en metros",
            time: "Tiempo en minutos",
            meters: "m.",
            min: "min.",
            latitude: "Latitud",
            longitude: "Longitud",
            help_time:
              "Ingrese la hora en minutos antes de la cita, cuando será posible registrarse para una cita",
            help_meters:
              "Por favor, informe la distancia aproximada en metros antes de la cita y podrá registrarse para concertar una cita",
            confirm: {
              title: "¿Eliminar el check in?",
              description: "Esto eliminará permanentemente el check in.",
            },
            errors: {
              meters_approximation: "La aproximación en metros es obligatoria",
              time: "El tiempo en minutos es obligatorio",
              latitude: "La latitud es obligatoria",
              longitude: "La longitud es obligatoria",
            },
          },
          scheduleFilterUser: {
            schedule_filter_user: "Filtro de agenda del usuario",
            add_schedule_filter_user: "Agregar filtro de agenda del usuario",
            new_schedule_filter_user: "Nuevo filtro de agenda del usuario",
            user: "Usuario",
            scheduleFilterUserCalendars: "Calendarios",
            confirm: {
              title: "¿Eliminar el filtro de agenda del usuario?",
              description:
                "Esto eliminará permanentemente el filtro de agenda del usuario",
            },
            errors: {
              user: "El usuario es obligatorio",
              schedule: "Los calendarios son obligatorios",
            },
          },
          scheduleConfirmation: {
            schedule_confirmation: "Confirmación de Agenda",
            add_schedule_confirmation: "Añadir confirmación de agenda",
            new_schedule_confirmation: "Nueva confirmación de agenda",
            time: "Tiempo en minutos",
            min: "min.",
            help: "Ingrese el tiempo en minutos antes de la cita, lo que le permitirá confirmar una cita",
            confirm: {
              title: "¿Eliminar la confirmación de agenda?",
              description:
                "Esto eliminará permanentemente la confirmación de agenda",
            },
            errors: {
              time: "El tiempo en minutos es obligatorio",
            },
          },
          tasySchedMenu: {
            menu_scheduling_portal_app: "Menu de Agenda Portal y APP",
            add_menu_scheduling_portal_app:
              "Agregar menu de agenda portal y APP",
            new_menu_scheduling_portal_app: "Nuevo menu de agenda portal y APP",
            name: "Nombre",
            custom_message: "Mensaje personalizado",
            display_order: "Orden de visualizacion",
            ticket_automation_received_rule: "Regla de automatizacion recibida",
            search: "Buscar un menu de agenda portal y APP",
            confirm: {
              title: "Eliminar menu de agenda portal y APP?",
              description:
                "Esto eliminara permanentemente el menu de agenda portal y APP",
            },
            errors: {
              name: "El nombre es obligatorio",
              display_order: "El orden de visualizacion es obligatorio",
              rule_or_custom_message:
                "Ingrese una regla de automatizacion recibida o un mensaje personalizado",
              custom_message_with_rule:
                "El mensaje personalizado solo puede completarse cuando no haya una regla de recepcion seleccionada",
              ticket_automation_received_rule:
                "La regla de automatizacion recibida es obligatoria",
            },
          },
        },
        system: {
          executeSql: {
            execute_sql: "Ejecutar SQL",
            execute_successfully: "SQL ejecutado con éxito",
            clean: "Limpiar",
            execute: "Ejecutar",
            errors: {
              sql: "El código SQL es obligatorio",
            },
          },
        },
        siteApp: {
          siteAppCheckIn: {
            site_app_check_in: "Check-In de la Triage PA Digital",
            add_site_app_check_in: "Agregar check in",
            new_site_app_check_in: "Nuevo check in",
            meters_approximation: "Aproximación en metros",
            patient_encounter_physician_code:
              "Código del médico de la consulta del paciente",
            sector_accommodation_type: "Tipo de alojamiento del sector",
            patient_encounter_origin_code:
              "Código de origen de la consulta del paciente",
            patient_encounter_type_code: "Código de origen del tipo consulta",
            time: "Tiempo en minutos",
            meters: "m.",
            min: "min.",
            latitude: "Latitud",
            longitude: "Longitud",
            help_time:
              "Ingrese el tiempo en minutos antes de la consulta, que se permitirá realizar el check in de una cita",
            help_meters:
              "Ingrese la aproximación en metros antes de la consulta, que se permitirá realizar el check in de una cita",
            standard_service_sector_code:
              "Código del Sector de Atención Estándar",
            standard_service_unit: "Unidad de Atención Estándar",
            insurance_allow_checkin: "Convenios permitidos",
            confirm: {
              title: "¿Eliminar check in?",
              description: "Esto eliminará permanentemente el check in",
            },
            errors: {
              meters_approximation: "La aproximación en metros es obligatoria",
              time: "El tiempo en minutos es obligatorio",
              latitude: "La latitud es obligatoria",
              longitude: "La longitud es obligatoria",
              standard_service_sector_code:
                "El código del sector de atención estándar es obligatorio",
              standard_service_unit:
                "La unidad de atención estándar es obligatoria",
              patient_encounter_origin_code:
                "El código de origen de la consulta del paciente es obligatorio",
              sector_accommodation_type:
                "El tipo de alojamiento del sector es obligatorio",
              patient_encounter_physician_code:
                "El código del médico de la consulta del paciente es obligatorio",
              patient_encounter_type_code:
                "El código de origen del tipo consulta es obligatorio",
            },
          },
          siteAppConfirmation: {
            site_app_confirmation: "Confirmación de Agenda",
            add_site_app_confirmation: "Agregar confirmación de agenda",
            new_site_app_confirmation: "Nueva confirmación de agenda",
            time: "Tiempo en minutos",
            min: "min.",
            help: "Ingrese el tiempo en minutos antes de la consulta, que se permitirá realizar la confirmación de una cita",
            confirm: {
              title: "¿Eliminar confirmación de agenda?",
              description:
                "Esto eliminará permanentemente la confirmación de agenda",
            },
            errors: {
              time: "El tiempo en minutos es obligatorio",
            },
          },
        },
        quickAnswer: {
          quick_answers: "Mensajes Rápido",
          quick_answer: "Mensaje Rápido",
          new_quick_answer: "Nueva mensaje rápido",
          search: "Buscar un mensaje rápido",
          add: "Añadir mensaje rápido",
          title: "Título",
          shortcut: "Atajo",
          message: "Mensaje",
          inactive_quick_answer: "Inactivar",
          share_type: "Tipo de acción",
          user: "Usuario",
          ticket_workspace: "Área de trabajo",
          ticket_channel: "Marco",
          inactive: {
            title: "Inactivar a mensaje rápido?",
            description:
              "Esto deshabilitará permanentemente el mensaje rápido.",
            cancel: "Cancelar",
            confirm: "Sí, inactivar",
            success: "Mensaje rápido deshabilitado exitosamente",
          },
          errors: {
            title: "El título es obligatorio",
            message: "La mensaje es obligatoria",
            shortcut: "El atajo es obligatorio",
            share_type: "El tipo de acción es obligatoria",
            user: "El usuario es obligatorio",
            ticket_workspace: "La área de trabajo es obligatoria",
            ticket_channel: "El marco es obligatorio",
          },
        },
      },
      extensionSettings: {
        extension_settings:
          "Configuración de extensión para '{{extension}}' en '{{siteApp}}'",
        add_extension_config: "Agregar configuración a la extensión.",
        extension_config: "Configuración de extensión",
        new_extension_config: "Nueva configuración de extensión",
        search_config: "Buscar una configuración",
        identifier: "Identificador",
        property: "Propiedad",
        public: "Público",
        true: "Si",
        false: "No",
        value: "Valor",
        description: "Descripción",
        is_public: "La configuración de la extensión es pública",
        is_public_info:
          "Aquí tratamos cuestiones relacionadas con la seguridad de la aplicación. Si una configuración es pública, significa que podemos acceder a ella sin autenticación. Los datos considerados confidenciales, como un token, nunca deben marcarse como públicos",
        save_in_establishment:
          "Guarde la configuración para todos los sitios web y aplicaciones de comerciantes",
        confirm: {
          title: "¿Eliminar la configuración de la extensión?",
          description:
            "Esto eliminará permanentemente la configuración de la extensión.",
        },
        switchEnableDisableConfig: {
          enabled: "Activado",
          disabled: "Desactivado",
        },
        enableDisableConfig: {
          enable: "Activar",
          disable: "Desactivar",
        },
        errors: {
          identifier: "El identificador es obligatorio",
          property: "La propiedad es obligatoria",
          value: "El valor es obligatorio",
          description: "La descripción es obligatoria",
        },
      },
      jobs: {
        title: "Has sido redirigido al panel de Empleos.",
        subtitle: "Para acceder nuevamente haga clic en el botón de abajo",
        button: "Acceso",
      },
      "4uHcp": {
        hcp: {
          healthPrograms: {
            enable: "Habilitar",
            active: "Activo",
            inactive: "Inactivo",
            health_programs: "Programas de Salud",
            health_program: "Programa de Salud",
            new_health_program: "Nuevo programa de salud",
            search: "Buscar un programa de salud",
            add_health_program: "Añadir programa de salud",
            languages: "Idiomas",
            health_program_type: "Tipo de programa de salud",
            applications: "Aplicaciones",
            work_groups: "Grupos de trabajo",
            add_language: "Añadir idioma",
            name: "Nombre",
            language: "Idioma",
            description: "Descripción",
            participants: "Participantes",
            imports: "Importaciones",
            fundraising: "Capturas",
            confirm: {
              title: "¿Eliminar programa de salud?",
              description:
                "Esto eliminará permanentemente el programa de salud",
            },
            errors: {
              health_program_type:
                "El tipo de programa de salud es obligatorio",
              site_apps: "Al menos una aplicación es obligatoria",
              languages: "Al menos um idioma es obligatorio",
              language: "El idioma es obligatorio",
              name: "El nombre es obligatorio",
            },
          },
          healthProgramsContentRules: {
            health_programs_content_rules:
              "Reglas de Contenido de Programas de Salud",
            health_program_content_rule:
              "Regla de Contenido de Programa de Salud",
            new_health_program_content_rule:
              "Nueva regla de contenido de programa de salud",
            search: "Buscar una regla de contenido de programa de salud",
            add_health_program_content_rule:
              "Añadir regla de contenido de programa de salud",
            content_view_type_hcp: "Tipo de Visualización del Contenido",
            name: "Nombre",
            health_program: "Programa de salud",
            initial_date: "Fecha de inicio",
            end_date: "Fecha de fin",
            contents: "Contenido de la regla",
            confirm: {
              title: "¿Eliminar regla de contenido de programa de salud?",
              description:
                "Esto eliminará permanentemente la regla de contenido de programa de salud",
            },
            errors: {
              name: "El nombre es obligatorio",
              health_program: "El programa de salud es obligatorio",
              initial_date: "La fecha de inicio es obligatoria",
              end_date: "La fecha de fin es obligatoria",
              initial_date_greater:
                "La fecha de fin no puede ser anterior a la fecha de inicio",
              content_view_type_hcp:
                "El tipo de visualización del contenido es obligatoria",
            },
          },
          rulesContents: {
            rules_contents: "Contenidos de Regla",
            rule_content: "Contenido de Regla",
            new_rule_content: "Nuevo contenido de regla",
            search: "Buscar un contenido de regla",
            add_rule_content: "Añadir contenido de regla",
            title: "Título",
            publication_date: "Fecha de publicación",
            content_status: "Status de contenido",
            published: "Publicado",
            not_published: "No publicado",
            status: "Status",
            active: "Activo",
            inactive: "Inactivo",
            confirm: {
              title: "¿Eliminar contenido de regla?",
              description:
                "Esto eliminará permanentemente el contenido de regla",
            },
          },
          workGroups: {
            work_groups: "Grupos de Trabajo",
            work_group: "Grupo de Trabajo",
            new_work_group: "Nuevo grupo de trabajo",
            add_work_group: "Añadir grupo de trabajo",
            search: "Buscar un grupo de trabajo",
            name: "Nombre",
            languages: "Idiomas",
            add_language: "Añadir idioma",
            language: "Idioma",
            description: "Descripción",
            work_group_type: "Tipo de grupo de trabajo",
            work_group_members: "Miembros del grupo de trabajo",
            confirm: {
              title: "¿Eliminar grupo de trabajo?",
              description: "Esto eliminará permanentemente el grupo de trabajo",
            },
            errors: {
              work_group_type: "El tipo de grupo de trabajo es obligatorio",
              languages: "Al menos un idioma es obligatorio.",
              name: "El nombre es obligatorio",
              language: "El idioma es obligatorio",
            },
          },
          participants: {
            participants: "Participantes",
            participant: "Participante",
            new_participant: "Nuevo participante",
            add_participant: "Añadir participante",
            search: "Buscar un participante",
            name: "Nombre",
            document: "CPF",
            status: "Estado",
            history: "Histórico",
            active: "Activo",
            formerMember: "Ex membro",
            membersHistory: {
              title: "Histórico",
              initialDate: "Fecha de entrada",
              endDate: "Fecha de salida",
              noEndDate: "Sin fecha final",
            },
            confirm: {
              title: "¿Eliminar participante?",
              description: "Esto eliminará permanentemente el participante",
            },
          },
          fundraising: {
            fundraising: "Capturas",
            healthProgram: "Programa de salud",
            captation: "Captura",
            add: "Añadir Captura",
            individual: "Individual",
            new_captation: "Nueva captura",
            search: "Buscar una captura",
            name: "Nombre",
            document: "CPF",
            health_program: "Programa de salud",
            captation_type: "Tipo de captura",
            captation_status: "Status de captura",
            approve_captation: "Aprobar captura",
            approved_successfully: "Captura aprobada exitosamente",
            disapprove_captation: "Desaprobar captura",
            disapproved_successfully: "Captura desaprobada exitosamente",
            denial_reason: "Razón (opcional)",
            cancel: "Cancelar",
            disapprove: "Desaprobar",
            confirm: {
              title: "¿Eliminar Captura?",
              description: "Esto eliminará permanentemente la Captura",
            },
            errors: {
              individual: "La persona física es obligatoria",
              health_program_type:
                "El tipo de programa de salud es obligatorio",
              captation_status: "El estado de captación es obligatorio",
            },
          },
          healthProgramImports: {
            imports: "Importaciones",
            healthProgram: "Programa de salud",
            import: "Importación",
            add_import: "Añadir importación",
            new_import: "Nueva importación",
            search: "Buscar una importación",
            file_name: "Nombre del archivo",
            import_person_name: "Nombre del importador",
            origin_of_demand: "Origen de la demanda",
            error_message: "Mensaje de error",
            status: "Status",
            download_template: "Descargar plantilla",
            health_program: "Programa de salud",
            errors: {
              file: "El archivo es obligatorio",
              import_person_name: "El nombre del importador es obligatorio",
              health_program: "El programa de salud es obligatorio",
            },
          },
        },
      },
      "4uBus": {
        register: {
          accessTokens: {
            access_tokens: "Tokens Externos",
            access_token: "Token de Externo",
            new_access_token: "Nuevo token de externo",
            add_access_token: "Añadir token de externo",
            search: "Buscar un token de Externos",
            name: "Nombre",
            code: "Código",
            privileges: "Privilegios",
            token_public: "Token público",
            copied_token: "Token público copiado exitosamente",
            copy: "Copiar token público",
            created: "Fecha de creación",
            individual: "Individual",
            legal_entity: "Entidad legal",
            software: "Software",
            justification: "Justificación",
            description: "Descripción",
            is_integration: "Token de integración",
            restriction_rule_profiles: "Perfiles de reglas de restricción",
            extension: "Extensión",
            profiles: "Perfiles",
            no_extensions_found:
              "No es posible registrar un token de externo, ya que no tiene instalada ninguna extensión de terminal de bus.",
            confirm: {
              title: "¿Eliminar el token de externo?",
              description: "Esto eliminará permanentemente el token de externo",
            },
            errors: {
              name: "El nombre es obligatorio",
              privileges: "Al menos un privilegio es obligatorio",
            },
          },
          profileTasyBus: {
            profile_tasy_bus: "Perfil Externo",
            search: "Buscar un perfil",
            add_profile_tasy_bus: "Añadir perfil",
            new_profile_tasy_bus: "Nuevo perfil",
            name: "Nombre",
            extension: "Extensión",
            is_global: "Perfil Global",
            enable: "Permitir",
            users: "Usuarios",
            global: "Sí",
            not_global: "No",
            status: "Status",
            active: "Activo",
            inactive: "Inactivo",
            confirm: {
              title: "¿Eliminar el perfil?",
              description:
                "Esto eliminará permanentemente el perfil, todas las reglas de restricción vinculadas a ese perfil se eliminarán y todos los usuarios vinculados se desvincularán.",
            },
            errors: {
              name: "El nombre es obligatorio",
              extension: "La extensión es obligatoria",
            },
          },
          iProcesse: {
            i_processes: "Procesos",
            i_processe: "Proceso",
            new_i_processe: "Nuevo proceso",
            add_i_processe: "Agregar proceso",
            search: "Buscar un proceso",
            processe_name: "Nombre del Proceso",
            description: "Descripción",
            code: "Código",
            status: "Estado",
            active: "Activo",
            inactive: "Inactivo",
            enable: "Habilitar",
            confirm: {
              title: "¿Eliminar proceso?",
              description: "Esto eliminará permanentemente el proceso",
            },
            errors: {
              processe_name: "El nombre del proceso es obligatorio",
            },
          },
          iService: {
            certillion: {
              name: "Certillion",
              is_certillion_cloud: "Usar Certillion Cloud",
              authorize_local: "Autorizar localmente",
              base_url: "URL Base",
              base_url_proxy: "URL Base del Proxy",
              client_id: "ID del Cliente (Client ID)",
              client_secret: "Secreto del Cliente (Client Secret)",
              pscs_accounts_path: "Ruta de Cuentas PSC",
              token_path: "Ruta del Token",
              has_token_path: "Ruta de Verificación del Token",
              upload_file_path: "Ruta de Carga de Archivos",
              signature_path: "Ruta de Firma",
              signature_standard_options: "Opciones Estándar de Firma (JSON)",
              signature_position_landscape:
                "Posicionamiento de la Firma en Modo Horizontal",
              signature_position_portrait:
                "Posicionamiento de la Firma en Modo Vertical",
              signature_horizontal_x: "Posición X",
              signature_horizontal_y: "Posición Y",
              signature_vertical_x: "Posición X",
              signature_vertical_y: "Posición Y",
              errors: {
                company_digital_certificate:
                  "Certificado Digital de la Empresa",
                method_type: "Tipo de Método",
                cpf: "CPF",
                url: "URL inválida",
                required_field: "Campo obligatorio",
                invalid_json: "JSON inválido",
                name: "Nombre",
                i_service_type: "Tipo de iService",
              },
            },
            i_services: "Servicios",
            i_service: "Servicio",
            new_i_service: "Nuevo servicio",
            add_i_service: "Agregar servicio",
            search: "Buscar un servicio",
            name: "Nombre del Servicio",
            description: "Descripción",
            configs: "Configuraciones",
            company_digital_certificate: "Certificado Digital",
            u_bus_user: "Usuario de 4uBus",
            i_service_type: "Tipo de Servicio",
            method_type: "Tipo de Método",
            status: "Estado",
            active: "Activo",
            inactive: "Inactivo",
            enable: "Habilitar",
            u_bus_user_external: "4uBus Externo",
            bus_internal_token: "Token de 4uBus",
            host: "Host de la API",
            si_pni: "SI-PNI",
            ger_acesso: "GerAcesso - TeletexSul",
            plug_notas: "PlugNotas",
            shift_lis: "Shift LIS",
            protheus: "Protheus",
            sgu: "SGU",
            configuration_under_development:
              "Las configuraciones de este tipo de servicio aún están en desarrollo. Esta sección estará disponible próximamente.",
            select_options: "Seleccionar Opciones",
            selected_options: "Opciones Seleccionadas",
            digital_certificate: "Certificado Digital",
            auth_url: "URL de Autenticación",
            base_url: "URL Base",
            cpf: "CPF",
            token: "Token",
            default_provider_document: "CNPJ Prestador Default",
            define: "Definir",
            cancel: "Cancelar",
            selected_service: "Servicio Seleccionado",
            clear_options: "Borrar Opciones",
            confirm_delete_title: "Borrar Opciones",
            confirm_delete_message:
              "¿Está seguro de que desea borrar las opciones seleccionadas?",
            confirm_clear: "Confirmar",
            service: "Servicio",
            i_service_type_error: "Seleccione un servicio",
            confirm: {
              title: "¿Eliminar servicio?",
              description: "Esto eliminará permanentemente el servicio",
            },
            errors: {
              name: "El nombre del servicio es obligatorio",
              url: "Ingrese un enlace válido (http o https)",
              company_digital_certificate:
                "El certificado digital es obligatorio",
              bus_internal_token: "El token interno de 4uBus es obligatorio",
              cpf: "El CPF es obligatorio",
              method_type: "El tipo de método es obligatorio",
              token: "El token es obligatorio",
              host: "El Host de la API es obligatorio",
              required_field: "Campo obligatorio",
              invalid_json: "JSON inválido",
            },
          },
          accessTokens4uhub: {
            access_tokens: "Tokens de 4uhub",
            access_token: "Token de 4uhub",
            new_access_token: "Nuevo token de 4uhub",
            add_access_token: "Añadir token de 4uhub",
            search: "Buscar un token de 4uhub",
            name: "Nombre",
            code: "Código",
            privileges: "Privilegios",
            token_public: "Token público",
            copied_token: "Token público copiado exitosamente",
            copy: "Copiar token público",
            created: "Fecha de creación",
            individual: "Individual",
            legal_entity: "Entidad legal",
            software: "Software",
            justification: "Justificación",
            description: "Descripción",
            is_integration: "Token de integración",
            restriction_rule_profiles: "Perfiles de reglas de restricción",
            extension: "Extensión",
            profiles: "Perfiles",
            no_extensions_found:
              "No es posible registrar un token de 4uhub, ya que no tiene instalada ninguna extensión de terminal de bus.",
            confirm: {
              title: "¿Eliminar el token de 4uhub?",
              description: "Esto eliminará permanentemente el token de 4uhub",
            },
            errors: {
              name: "El nombre es obligatorio",
              privileges: "Al menos un privilegio es obligatorio",
            },
          },
          profile4uhub: {
            profile_tasy_bus: "Perfil - 4uhub bus",
            search: "Buscar un perfil",
            add_profile_tasy_bus: "Añadir perfil - 4uhub bus",
            new_profile_tasy_bus: "Nuevo perfil - 4uhub bus",
            name: "Nombre",
            extension: "Extensión",
            is_global: "Perfil Global",
            enable: "Permitir",
            users: "Usuarios",
            global: "Sí",
            not_global: "No",
            status: "Status",
            active: "Activo",
            inactive: "Inactivo",
            confirm: {
              title: "¿Eliminar el perfil - 4uhub bus?",
              description:
                "Esto eliminará permanentemente el perfil - 4uhub bus, todas las reglas de restricción vinculadas a ese perfil - 4uhub bus se eliminarán y todos los usuarios vinculados se desvincularán.",
            },
            errors: {
              name: "El nombre es obligatorio",
              extension: "La extensión es obligatoria",
            },
          },
          restrictionRules: {
            restriction_rules: "Reglas de Restricción",
            restriction_rule: "Regla de Restricción",
            search: "Buscar una regla de restricción",
            add_restriction_rule: "Añadir regla de restricción",
            new_restriction_rule: "Nueva regla de restricción",
            status: "Status",
            active: "Activo",
            inactive: "Inactivo",
            enable: "Permitir",
            restriction_rule_type: "Tipo de regla de restricción",
            action_type: "Tipo de acción",
            value: "Valor",
            description: "Descripción",
            confirm: {
              title: "¿Eliminar la regla de restricción?",
              description:
                "Esto eliminará permanentemente la regla de restricción",
            },
            errors: {
              restriction_rule_type:
                "El tipo de regla de restricción es obligatorio",
              action_type: "El tipo de acción es obligatorio",
              value: "El valor es obligatorio",
              description: "La descripción es obligatoria",
            },
          },
        },
        relationships: {
          defaultRelationships: {
            relationship: "Relación",
            search: "Buscar una relación",
            add_relationship: "Añadir relación",
            relationship_type: "Tipo de relación",
            direction_type: "Tipo de segmentación",
            origin_name: "Nombre de origen",
            origin_value: "Valor de origen",
            destiny_name: "Nombre del destino",
            destiny_value: "Valor objetivo",
            enable: "Habilitar",
            default: "Estándar",
            status: "Status",
            active: "Activo",
            inactive: "Inactivo",
            is_default: "Sí",
            is_not_default: "No",
            confirm: {
              title: "¿Eliminar la relación?",
              description: "Esto eliminará permanentemente la relación",
            },
            errors: {
              relationship_type: "El tipo de relación es obligatorio",
              direction_type: "El tipo de segmentación es obligatorio",
              origin_name: "El nombre de origen es obligatorio",
              origin_value: "El valor de origen es obligatorio",
              destiny_name: "El nombre de destino es obligatorio",
              destiny_value: "El valor de destino es obligatorio",
              u_bus_relationship_type: "El tipo de relación es obligatorio",
            },
          },
          relationshipGroup: {
            relationship: "Relación",
            add_relationship_group: "Agregar grupo de relación",
            new_relationship_group: "Nuevo grupo de relación",
            search: "Buscar un grupo de relación",
            name: "Nombre",
            code: "Código",
            description: "Descripción",
            u_bus_automation: "Automatización de 4uBus",
            status: "Estado",
            active: "Activo",
            inactive: "Inactivo",
            enable: "Habilitar",
            created_successfully: "Grupo de relación registrado con éxito",
            relationship_group_item: "Ítem de Grupo de Relación 4uBus",
            confirm: {
              title: "¿Eliminar grupo de relación?",
              description:
                "Esto eliminará permanentemente el grupo de relación",
            },
            errors: {
              name: "El nombre es obligatorio",
              u_bus_automation: "La automatización de 4uBus es obligatoria",
            },
          },
        },
        restrictions: {
          schedule: {
            schedule: "Cronograma",
            add_schedule: "Añadir cronograma",
            search: "Buscar una cronograma",
            status: "Status",
            active: "Activo",
            inactive: "Inactivo",
            new_schedule: "Nuevo cronograma",
            enable: "Permitir",
            value: "Valor",
            restriction_rule_type: "Tipo de regla de restricción",
            description: "Descripción",
            confirm: {
              title: "¿Eliminar el cronograma?",
              description: "Esto eliminará permanentemente el cronograma",
            },
            errors: {
              value: "El valor es obligatorio",
              restriction_rule_type:
                "El tipo de regla de restricción es obligatorio",
              description: "La descripción es obligatoria",
            },
          },
        },
        logs: {
          logFileIntegration: {
            file_integration: "Registro de Integración de Archivos",
            status: "Estado",
            robot: "Robots",
            resolved: "Resuelto",
            start_date: "Initial Date",
            end_date: "Final Date",
            today: "Hoy",
            yesterday: "Ayer",
            message_status: "Mensaje del estado",
            created: "Fecha y hora",
            view_logs: "Ver Archivos",
            logs: "Archivos",
            solved: "Marcar como Resuelto",
          },
          ipmXTasy: {
            ipmxtasy: "IPM - Recibir - IPM x Tasy",
            status: "Status",
            message_status: "Mensaje del status",
            created: "Fecha de creación",
            tasy_individual_identifier: "Cd. persona",
            start_date: "Fecha Inicial",
            end_date: "Fecha Final",
            service_number_search: "Número de servicio",
            service_number: "Número de servicio (IPM)",
            service_number_tasy: "Número de servicio (Tasy)",
            lab_exam_quantity: "Cant Ex Lab",
            exam_nlab: "Examen NLab",
            medicines: "Medicamentos",
            allergy: "Alergia",
            has_evolution: "Tiene evolución",
            evolution: "Sí",
            no_evolution: "No",
            search: "Buscar por status",
            view_logs: "Ver logs",
            logs: "Logs",
          },
          logTasyImp: {
            status: "Estado",
            message_status: "Mensaje de estado",
            created: "Fecha de creación",
            qtyEmrLabExamResult: "Prueba de laboratorio QTD",
            start_date: "Fecha Inicial",
            end_date: "Fecha Final",
            qtyEmrNonLaboratoryTests: "Prueba de laboratorio QTD",
            qtyEvolution: "Evolution Qtd",
            qtyAllergy: "Alergias qtd",
            qtyMedicineInUse: "Medicamentos QTD",
            ipmtasy: "IPMxTasy",
            tasyipm: "TasyxIPM",
            TasyEncounterIntegrationId: "Número de Servicio Tasy",
            TasyIndividualIntegrationId: "Código de Persona Tasy",
            IpmEncounterIntegrationId: "Número de Servicio Ipm",
            IpmIndividualIntegrationId: "Código de Persona Ipm",
          },

          tasyXIpm: {
            tasyxipm: "IPM - Enviar - Tasy x IPM",
            status: "Status",
            message_status: "Mensaje del status",
            created: "Fecha de creación",
            start_date: "Fecha Inicial",
            end_date: "Fecha Final",
            individual_identifier: "Código de persona (Tasy)",
            service_number_search: "Número de servicio",
            service_number: "Número de servicio (Tasy)",
            search: "Buscar por status",
            view_logs: "Ver logs",
            logs: "Logs",
            allergies: "Alergias",
            occurrences: "Ocurrencias",
            exams_lab: "Exámenes Lab",
            exams_n_lab: "Exámenes N Lab",
            medicines: "Medicamentos",
          },
          tasyCalendar: {
            title: "Cronograma del Tasy",
            type_code: "Código",
            created: "Creado en",
            identifier: "Identificador",
            start_date: "Fecha Inicial",
            end_date: "Fecha Final",
            calendar_identifier: "Identificador de calendario",
            calendar_date: "Fecha del calendario",
            status: "Status",
            individual_identifier: "Identificador individual",
            last_modified: "Última modificación",
          },
          monitoring: {
            title: "Monitoreo del servidor de bus",
            subtitle: "Estadísticas del servidor local de bus",
          },
          syncPersons: {
            title: "Sync - Datos de personas",
            search_placeholder: "Buscar por nombre o CPF...",
            name: "Nombre",
            cpf: "CPF",
            birth_date: "Fecha de nacimiento",
            email: "Correo electrónico",
            phone: "Teléfono",
            cell_phone: "Celular",
            system: "Sistema",
            last_modified: "Última actualización",
            start_date: "Fecha Inicial",
            end_date: "Fecha Final",
            view_transactions: "Ver transacciones",
            transactions: "Transacciones",
            actions: "Acciones",
            logs: "Logs",
            identifier: "Identificador",
            document: "Documento",
            status: "Estado",
            message: "Mensaje",
            original_value: "Valor original",
            new_value: "Nuevo valor",
            retries: "Intentos",
            created: "Fecha de creación",
            batch_id: "Lote",
            batch_queue_id: "Cola del lote",
            success: "Éxito",
            error: "Error",
            close: "Cerrar",
            no_transactions: "No se encontraron transacciones.",
            no_actions: "No se encontraron acciones.",
            no_logs: "No se encontraron logs.",
            tasy_identifier: "Identificador Tasy",
            view_all_data: "Ver todos los datos",
            details_title: "Todos los datos",
            details_error: "No fue posible cargar los datos de la persona.",
            section_identification: "Identificación",
            section_contact: "Contacto",
            section_origin: "Origen y actualización",
            section_addresses: "Direcciones",
            no_addresses: "Esta persona no tiene direcciones.",
            system_nrec: "Sistema de creación",
            last_modified_nrec: "Fecha de creación",
            address_type: "Tipo",
            address_street: "Calle",
            address_number: "Número",
            address_complement: "Complemento",
            address_neighborhood: "Barrio",
            address_city: "Municipio",
            address_state: "Estado",
            address_zip: "Código postal",
            address_type_unknown: "Tipo {{code}}",
            address_types: {
              1: "Residencial",
              2: "Comercial",
              3: "Del responsable",
              4: "Del padre",
              5: "De la madre",
              6: "Del cónyuge",
              7: "Comercial 2",
              8: "Alojamiento",
              9: "Adicional",
              10: "Postal address",
              20: "Contacto de emergencia",
              30: "Exclusivo cooperado",
            },
          },
          nfeTotvs: {
            title: "NFe - TOTVS",
            identifier: "Identificador",
            invoice_identifier: "Identificador de Factura",
            resync: "Forzar reenvío",
            totvsIdentifier: "Identificador de TOTVS",
            resetedSuccess: "Reenvío forzado con éxito",
            status_item: "Estado",
            integration_situation: "Estado de Integracion",
            created: "Fecha de Creación",
            integrated_date: "Fecha de Integración",
            retries: "Intentos",
            last_modified: "Última Modificación",
            start_date: "Fecha Inicial",
            end_date: "Fecha Final",
            search: "Buscar",
            status: {
              pending: "Pendiente",
              processing: "Procesando",
              finished: "Finalizado",
              error: "Error",
            },
            view_logs: "Ver logs",
            view_details: "Ver detalles",
            logs: "Logs",
            search_placeholder: "Buscar por NFe TOTVS...",
            details: {
              title: "Detalles de NFe",
              log_id: "ID del Log",
              status: "Estado",
              created: "Fecha de Creación",
              last_modified: "Última Modificación",
              log_data: "Datos del Log",
              summary: "Resumen del Log",
              logs_table_title: "Logs de Integración",
              close: "Cerrar",
              view_full_log: "Ver Log Completo",
              provider: "Proveedor",
              cnpj: "CNPJ",
              invoice: "Factura",
              id: "ID",
              success: "Éxito",
              error: "Error",
            },
            integration_type: "Tipo de Integración",
            cancellation: "Cancelación",
            integration: "Integración",
          },
          calendarControl: {
            title: "Consulta de Horarios Disponibilizados",
            identifier: "Identificador",
            created: "Fecha de creación",
            created_start: "Fecha inicial",
            created_end: "Fecha final",
            last_modified: "Última modificación",
            heart_beat_date: "Último heartbeat",
            document: "CPF",
            birth_date: "Fecha de nacimiento",
            gender: "Sexo",
            individual_identifier: "Código de la persona (Tasy)",
            insurance_code: "Convenio",
            insurance_category_code: "Categoría del convenio",
            procedure_code: "Procedimiento",
            internal_procedure_code: "Procedimiento interno",
            procedure_origin_code: "Origen del procedimiento",
            valid_quantity: "Horarios válidos",
            minimum_quantity: "Cantidad mínima",
            type_of_appointment: "Tipo de agenda",
            type_calendar: "Código del tipo",
            type_of_appointment_values: {
              CONSULTA: "Consulta",
              RETORNO: "Retorno",
              CHECKUP: "Chequeo",
              EXAME: "Examen",
            },
            status: "Estado de la lista",
            status_values: {
              "LISTA EM CRIACAO": "Lista en creación",
              "LISTA CRIADA": "Lista creada",
              "LISTA FINALIZADA": "Lista finalizada",
            },
            json: "JSON",
            details: "Detalles",
            additionalFilters: "Más filtros",
            view_items: "Ver horarios evaluados",
            view_json: "Ver JSON de la solicitud",
            view_details: "Ver detalles",
            copy_json: "Copiar JSON",
            copy_details: "Copiar detalles (JSON)",
            close: "Cerrar",
            json_modal: {
              title: "JSON de la solicitud",
              empty: "Sin JSON registrado.",
            },
            details_modal: {
              title: "Otros campos de la búsqueda",
            },
            items: {
              title: "Detalle de la búsqueda",
              calendar_identifier: "Agenda",
              slot_identifier: "Identificador del slot",
              calendar_date: "Fecha y hora",
              status: "Estado",
              is_valid: "Válido",
              message: "Motivos",
            },
            item_status_values: {
              PENDENTE: "Pendiente",
              PROCESSADO: "Procesado",
            },
            is_valid_values: {
              S: "Sí",
              N: "No",
            },
          },
          refund: {
            title: "Reembolsos",
            holder_document: "Documento del Titular",
            holder_bank_account_name: "Nombre del Titular",
            protocol_integration_id: "Protocolo",
            attempt_count: "Intentos",
            created: "Fecha de Creación",
            integrated_at: "Fecha de Integración",
            last_modified: "Última Modificación",
            status: "Estado",
            start_date: "Fecha Inicial",
            end_date: "Fecha Final",
            search_placeholder: "Buscar por Reembolsos...",
            view_details: "Ver detalles",
            retry: "Reintentar",
            retry_success: "Reintento solicitado con éxito.",
            status_options: {
              pendente: "Pendiente",
              processando: "Procesando",
              processado: "Procesado",
              erro: "Error",
              erro_emailenviado: "Error (correo enviado)",
              retentativa_manual: "Reintento Manual",
            },
            details: {
              title: "Detalles del Reembolso",
              status: "Estado",
              created: "Fecha de Creación",
              last_modified: "Última Modificación",
              message: "Mensaje",
              log_data: "Datos del Log",
              view_full_log: "Ver log completo",
              close: "Cerrar",
              success: "Éxito",
              error: "Error",
              protocol_logs_title: "Logs del Protocolo",
              attachments_title: "Anexos",
              attachment_integrated: "Integrado",
              attachment_pending: "Pendiente",
              attachment_attempts: "Intentos",
              media_file_retry_success:
                "Reintento del anexo solicitado con éxito.",
            },
          },
          forubusVaccine: {
            title: "Vacunas 4uBus",
            identifier: "Identificador",
            immunization_identifier: "Identificador de la inmunización",
            vaccine_identifier: "Identificador de la vacuna",
            resync: "Forzar reenvío",
            resetedSuccess: "Reenvío forzado con éxito",
            individual_document: "Documento",
            status_item: "Estado",
            created: "Fecha de creación",
            integrated_date: "Fecha de integración",
            retries: "Reintentos",
            last_modified: "Última modificación",
            start_date: "Fecha inicial",
            end_date: "Fecha final",
            search: "Buscar",
            status: {
              pending: "Pendiente",
              sending: "Enviando",
              processing: "Procesando",
              finished: "Finalizado",
              error: "Error",
            },
            view_logs: "Ver registros",
            view_details: "Ver detalles",
            logs: "Registros",
            search_placeholder: "Buscar vacunas 4uBus...",
            details: {
              title: "Detalles de la vacuna",
              log_id: "ID del registro",
              status: "Estado",
              created: "Fecha de creación",
              last_modified: "Última modificación",
              log_data: "Datos del registro",
              logs_table_title: "Registros de integración",
              close: "Cerrar",
              view_full_log: "Ver registro completo",
              success: "Éxito",
              error: "Error",
            },
            integration_type: "Tipo de integración",
            cancellation: "Cancelación",
            integration: "Integración",
          },
          invoiceServiceAgy: {
            title: "Invoice Service Agy",
            identifier: "Identificador",
            invoice_number: "Numero de Factura",
            rec_company_name: "Tomador",
            rec_company_document: "CNPJ del Tomador",
            status_item: "Estado",
            created: "Fecha de creacion",
            integrated_date: "Fecha de integracion",
            retries: "Reintentos",
            last_modified: "Ultima modificacion",
            start_date: "Fecha inicial",
            end_date: "Fecha final",
            search: "Buscar",
            resync: "Forzar reenvio",
            resetedSuccess: "Reenvio forzado con Exito",
            status: {
              with_inconsistency: "Con Inconsistencia",
              awaiting_send: "Esperando Envio",
              sent: "Enviado",
              error: "Error",
              success: "Exito",
            },
            view_logs: "Ver logs",
            view_details: "Ver detalles",
            logs: "Logs",
            search_placeholder: "Buscar por Invoice Service Agy...",
            details: {
              title: "Detalles de Invoice Service Agy",
              log_id: "ID del Log",
              status: "Estado",
              created: "Fecha de creacion",
              last_modified: "Ultima modificacion",
              log_data: "Datos del Log",
              close: "Cerrar",
              view_full_log: "Ver Log Completo",
            },
          },
          patientEncounterPsTransferRequest: {
            title:
              "Tasy EMR - Generar nueva Atención en PS, a partir de inelegibilidad de atención en PA",
            original_patient_encounter_number: "N.º Atención Original",
            new_patient_encounter_number: "N.º Atención Nueva (PA)",
            new_prescription_number: "N.º Prescripción Nueva (PA)",
            individual_beneficiary_id: "ID del Beneficiario",
            individual_beneficiary_name: "Nombre del Beneficiario",
            original_doctor_integration_id: "Médico Original",
            target_doctor_integration_id: "Médico del PS",
            transfer_confirmed_date: "Fecha de la Transferencia",
            status: "Estado",
            status_values: {
              pending: "Pendiente",
              processing: "Procesando",
              success: "Éxito",
              manual_review: "Revisión Manual",
            },
            retries: "Intentos",
            created: "Fecha de Creación",
            created_start: "Fecha Inicial",
            created_end: "Fecha Final",
            additionalFilters: "Más filtros",
            search: "Buscar",
            search_placeholder: "Buscar por Atención...",
            view_details: "Ver detalles",
            reprocess: "Reprocesar",
            reprocess_selected: "Reprocesar seleccionados",
            reprocessedSuccess:
              "Registros enviados para reprocesamiento con éxito",
            details: {
              title: "Detalles de la Transferencia",
              success: "Estado",
              success_true: "Éxito",
              success_false: "Falla",
              created: "Fecha",
              log_data: "Datos del Log",
              last_attempt_date: "Último Intento",
              payload: "Payload",
              history: "Historial",
            },
          },
          externalLogError: {
            title: "LogError",
            id: "ID",
            error_date: "Fecha del Error",
            error_code: "Código del Error",
            error_message: "Mensaje del Error",
            source_class: "Clase de Origen",
            start_date: "Fecha inicial",
            end_date: "Fecha final",
            search: "Buscar",
            view_details: "Ver detalles",
            search_placeholder: "Buscar LogError...",
            details: {
              title: "Detalles del Log de Error",
              error_date: "Fecha del Error",
              error_code: "Código del Error",
              error_message: "Mensaje del Error",
              command_text: "Comando SQL",
              bind_parameters: "Parámetros",
              stack_trace: "Stack Trace",
              source_class: "Clase de Origen",
              copy: "Copiar contenido",
            },
          },
          gerAcessoVisitControlPacient: {
            title: "Acceso del Acompañante del Paciente",
            total_time: "Tiempo Total",
            order_by_slowest: "Más demorados",
            order_by_slowest_info:
              "Ordena por el tiempo total (desde la liberación en Tasy hasta la entrega a la API de GerAcesso), de mayor a menor.",
            identifier: "Identificador",
            patient_name: "Nombre del Paciente",
            visitor_cpf: "CPF del Acompañante",
            service_number: "Número de Atención",
            visit_date: "Fecha de la Visita",
            visitor: "Acompañante",
            exit_date: "Fecha de Salida",
            status_item: "Estado",
            retries: "Intentos",
            created: "Fecha de Creación",
            start_date: "Fecha Inicial",
            end_date: "Fecha Final",
            search: "Buscar",
            status: {
              pending: "Pendiente",
              sending: "Enviando",
              processing: "Procesando",
              finished: "Finalizado",
              error: "Error",
            },
            view_logs: "Ver logs",
            view_details: "Ver detalles",
            resync: "Forzar reenvio",
            partialResyncWarning: "Algunos registros no pudieron reenviarse.",
            resyncError: "No fue posible reenviar los registros seleccionados.",
            resetedSuccess: "Reenvio forzado con exito",
            resync_selected: "Reenviar seleccionados",
            bulk_resync_error:
              "No fue posible forzar el reenvío de todos los registros seleccionados",
            select_error_rows:
              "Seleccione al menos un registro con error para reenviar",
            logs: "Logs",
            search_placeholder: "Buscar Acceso del Acompañante del Paciente...",
            details: {
              title: "Detalles del Acceso",
              tasy_released: "Liberado en Tasy",
              tasy_to_capture: "Tasy → Captura",
              capture_to_sent: "Captura → Envío",
              total_time: "Tiempo Total",
              tasy_to_capture_info:
                "Tiempo entre la liberación en Tasy y la captura del registro por nuestra rutina.",
              capture_to_sent_info:
                "Tiempo entre la captura del registro por nuestra rutina y la entrega de los datos a la API de GerAcesso.",
              total_time_info:
                "Tiempo total entre la liberación en Tasy y la entrega de los datos a la API de GerAcesso.",
              log_id: "ID del Log",
              status: "Estado",
              created: "Fecha de Creación",
              last_modified: "Última Modificación",
              log_data: "Datos del Log",
              summary: "Resumen del Log",
              logs_table_title: "Logs de Integración",
              close: "Cerrar",
              view_full_log: "Ver Log Completo",
              provider: "Proveedor",
              cnpj: "CNPJ",
              invoice: "Factura",
              id: "ID",
              success: "Éxito",
              error: "Error",
            },
            integration_type: "Tipo de Integración",
            cancellation: "Cancelación",
            integration: "Integración",
          },
          gerAcessoVisitControlVisitor: {
            title: "Acceso del Visitante del Paciente",
            total_time: "Tiempo Total",
            order_by_slowest: "Más demorados",
            order_by_slowest_info:
              "Ordena por el tiempo total (desde la liberación en Tasy hasta la entrega a la API de GerAcesso), de mayor a menor.",
            identifier: "Identificador",
            patient_name: "Nombre del Paciente",
            visitor_cpf: "CPF del Visitante",
            service_number: "Numero de Atencion",
            visit_date: "Fecha de la Visita",
            visitor: "Visitante",
            exit_date: "Fecha de Salida",
            status_item: "Estado",
            retries: "Intentos",
            created: "Fecha de Creacion",
            start_date: "Fecha Inicial",
            end_date: "Fecha Final",
            search: "Buscar",
            status: {
              pending: "Pendiente",
              sending: "Enviando",
              processing: "Procesando",
              finished: "Finalizado",
              error: "Error",
            },
            view_logs: "Ver logs",
            view_details: "Ver detalles",
            resync: "Forzar reenvio",
            resetedSuccess: "Reenvio forzado con exito",
            logs: "Logs",
            search_placeholder: "Buscar Acceso del Visitante del Paciente...",
            details: {
              title: "Detalles del Acceso",
              tasy_released: "Liberado en Tasy",
              tasy_to_capture: "Tasy → Captura",
              capture_to_sent: "Captura → Envío",
              total_time: "Tiempo Total",
              tasy_to_capture_info:
                "Tiempo entre la liberación en Tasy y la captura del registro por nuestra rutina.",
              capture_to_sent_info:
                "Tiempo entre la captura del registro por nuestra rutina y la entrega de los datos a la API de GerAcesso.",
              total_time_info:
                "Tiempo total entre la liberación en Tasy y la entrega de los datos a la API de GerAcesso.",
              log_id: "ID del Log",
              status: "Estado",
              created: "Fecha de Creacion",
              last_modified: "Ultima Modificacion",
              log_data: "Datos del Log",
              logs_table_title: "Logs de Integracion",
              close: "Cerrar",
              view_full_log: "Ver Log Completo",
              success: "Exito",
              error: "Error",
            },
            integration_type: "Tipo de Integracion",
            cancellation: "Cancelacion",
            integration: "Integracion",
          },
          gerAcessoVisitControlSector: {
            title: "Acceso del Visitante del Sector",
            total_time: "Tiempo Total",
            order_by_slowest: "Más demorados",
            order_by_slowest_info:
              "Ordena por el tiempo total (desde la liberación en Tasy hasta la entrega a la API de GerAcesso), de mayor a menor.",
            sector: "Sector",
            identifier: "Identificador",
            patient_name: "Nombre del Paciente",
            visitor_cpf: "CPF del Visitante",
            service_number: "Número de Atención",
            access_control_number: "Número de Control de Acceso",
            visit_date: "Fecha de la Visita",
            visitor: "Visitante",
            exit_date: "Fecha de Salida",
            status_item: "Estado",
            retries: "Intentos",
            created: "Fecha de Creación",
            start_date: "Fecha Inicial",
            end_date: "Fecha Final",
            search: "Buscar",
            status: {
              pending: "Pendiente",
              processing: "Procesando",
              finished: "Finalizado",
              error: "Error",
            },
            view_logs: "Ver logs",
            view_details: "Ver detalles",
            resync: "Forzar reenvío",
            resync_selected: "Reenviar seleccionados",
            resetedSuccess: "Reenvío forzado con éxito",
            bulk_resync_error:
              "No fue posible forzar el reenvío de todos los registros seleccionados",
            select_error_rows:
              "Seleccione al menos un registro con error para reenviar",
            logs: "Logs",
            search_placeholder: "Buscar Acceso del Visitante del Sector...",
            details: {
              title: "Detalles del Acceso",
              tasy_released: "Liberado en Tasy",
              tasy_to_capture: "Tasy → Captura",
              capture_to_sent: "Captura → Envío",
              total_time: "Tiempo Total",
              tasy_to_capture_info:
                "Tiempo entre la liberación en Tasy y la captura del registro por nuestra rutina.",
              capture_to_sent_info:
                "Tiempo entre la captura del registro por nuestra rutina y la entrega de los datos a la API de GerAcesso.",
              total_time_info:
                "Tiempo total entre la liberación en Tasy y la entrega de los datos a la API de GerAcesso.",
              log_id: "ID del Log",
              status: "Estado",
              created: "Fecha de Creación",
              last_modified: "Última Modificación",
              log_data: "Datos del Log",
              logs_table_title: "Logs de Integración",
              close: "Cerrar",
              view_full_log: "Ver Log Completo",
              success: "Éxito",
              error: "Error",
            },
            integration_type: "Tipo de Integración",
            cancellation: "Cancelación",
            integration: "Integración",
          },
          invoiceLoweringTotvs: {
            title: "Tasy > TOTVS - Baja de Títulos",
            identifier: "Identificador",
            invoice_identifier: "Factura",
            account_payable_identifier: "Cuenta por Pagar",
            due_date: "Fecha de Vencimiento",
            lowering_identifier: "ID de Baja",
            status_item: "Estado",
            created: "Fecha de Creación",
            integrated_date: "Fecha de Integración",
            retries: "Intentos",
            last_modified: "Última Modificación",
            start_date: "Fecha Inicial",
            end_date: "Fecha Final",
            search: "Buscar",
            resync: "Forzar reenvío",
            resetedSuccess: "Reenvío forzado con éxito",
            status: {
              pending: "Pendiente",
              processing: "Procesando",
              finished: "Finalizado",
              error: "Error",
            },
            view_logs: "Ver logs",
            view_details: "Ver detalles",
            logs: "Logs",
            search_placeholder: "Buscar por Baja de Títulos TOTVS...",
            details: {
              title: "Detalles de Baja de Título",
              log_id: "ID del Log",
              status: "Estado",
              created: "Fecha de Creación",
              last_modified: "Última Modificación",
              log_data: "Datos del Log",
              summary: "Resumen del Log",
              logs_table_title: "Logs de Integración",
              close: "Cerrar",
              view_full_log: "Ver Log Completo",
              success: "Éxito",
              error: "Error",
              logs: "Logs",
              titles_totvs: "Títulos TOTVS",
              invoice_identifier: "Identificador de Factura",
              id_lan: "ID de Lanzamiento",
              id_mov: "ID Movimiento",
              cod_coligada: "Cod. Coligada",
              cod_filial: "Sucursal",
              due_date: "Fecha de Vencimiento",
              totvs_data: "Datos TOTVS",
              view_totvs_data: "Ver datos TOTVS",
            },
            lowering_type: "Tipo de Baja",
            reversal: "Inversión",
            normal: "Normal",
          },
          total_value: "Valor Total",
          status_item: "Estado",
          created: "Fecha de Creación",
          integrated_date: "Fecha de Integración",
          retries: "Intentos",
          last_modified: "Última Modificación",
          start_date: "Fecha Inicial",
          end_date: "Fecha Final",
          search: "Buscar",
          view_logs: "Ver logs",
          view_details: "Ver detalles",
          logs: "Logs",
          search_placeholder: "Buscar por Baja de Títulos TOTVS...",
          details: {
            title: "Detalles de Baja de Título",
            log_id: "ID del Log",
            status: "Estado",
            operation: "Operación",
            document_number: "Documento",
            created: "Fecha de Creación",
            last_modified: "Última Modificación",
            log_data: "Datos del Log",
            logs_table_title: "Logs de Integración",
            close: "Cerrar",
            view_full_log: "Ver Log Completo",
            success: "Éxito",
            error: "Error",
          },
          tasyToTasyNonLabFilters: {
            additional_filters: "Más filtros",
            local_group: "Identificadores locales",
            external_group: "Identificadores externos",
          },
          tasyToTasyNonLabExamsAvailable: {
            title: "Tasy <> Tasy - Exámenes No Laboratoriales (Disponibles)",
            identifier: "Identificador",
            service_number: "Número de Atención",
            patient_cpf: "CPF del Paciente",
            status_item: "Estado",
            prescription_number: "Número de Prescripción",
            procedure_prescription_number:
              "Número de Prescripción del Procedimiento",
            external_prescription_number: "Número de Prescripción Externa",
            external_procedure_prescription_number:
              "Número de Prescripción del Procedimiento Externo",
            external_service_number: "Número de Atención Externo",
            retries: "Intentos",
            start_date: "Fecha Inicial",
            end_date: "Fecha Final",
            view_details: "Ver detalles",
            status: {
              available: "Disponible",
              downloaded: "Descarga Completa",
              recognized: "Reconocido",
              integrated: "Integrado",
              error: "Error",
              cancelled: "Cancelado",
            },
            details: {
              title: "Detalles del Resultado",
              log_id: "ID del Log",
              status: "Estado",
              created: "Fecha de Creación",
              last_modified: "Última Modificación",
              log_data: "Datos del Log",
              status_message: "Mensaje",
              logs_table_title: "Logs de Integración",
              close: "Cerrar",
              view_full_log: "Ver Log Completo",
              success: "Éxito",
              error: "Error",
            },
          },
          tasyToTasyNonLabExamsReceived: {
            title: "Tasy <> Tasy - Exámenes No Laboratoriales (Recibidos)",
            identifier: "Identificador",
            service_number: "Número de Atención",
            patient_cpf: "CPF del Paciente",
            status_item: "Estado",
            prescription_number: "Número de la Prescripción",
            procedure_prescription_number:
              "Número de Prescripción del Procedimiento",
            external_prescription_number: "Número de la Prescripción Externa",
            external_procedure_prescription_number:
              "Número de Prescripción del Procedimiento Externo",
            external_service_number: "Número de Atención Externo",
            retries: "Intentos",
            start_date: "Fecha Inicial",
            end_date: "Fecha Final",
            view_details: "Ver detalles",
            status: {
              available: "Disponible",
              downloaded: "Descarga Completa",
              recognized: "Reconocido",
              integrated: "Integrado",
              error: "Error",
              cancelled: "Cancelado",
            },
            details: {
              title: "Detalles del Resultado",
              log_id: "ID del Log",
              status: "Estado",
              created: "Fecha de Creación",
              last_modified: "Última Modificación",
              log_data: "Datos del Log",
              status_message: "Mensaje",
              logs_table_title: "Logs de Integración",
              close: "Cerrar",
              view_full_log: "Ver Log Completo",
              success: "Éxito",
              error: "Error",
            },
          },
          serviceReceived: {
            title: "Tasy - Recibir Atenciones",
            identifier: "Identificador",
            generated_service_number: "Número de Atención Generado",
            establishment_code: "Código del Establecimiento Externo",
            external_cpf: "CPF Externo",
            status_item: "Estado",
            external_service_number: "Número de Atención Externo",
            external_person_code: "Código de Persona Externo",
            linked_person_code: "Código de Persona Generado/Vinculado",
            external_person_name: "Nombre de Persona Externa",
            view_received_data: "Ver Datos Recibidos",
            retries: "Reintentos",
            view_details: "Ver detalles",
            resync: "Forzar reenvío",
            resetedSuccess: "Reenvío forzado con éxito",
            start_date: "Fecha Inicial",
            end_date: "Fecha Final",
            more_filters: "Más Filtros",
            service_data: "Datos de la Atención",
            patient_data: "Datos del Paciente / Vínculo",
            clean_filters: "Limpiar filtros",
            cancel: "Cancelar",
            apply_filters: "Aplicar Filtros",
            encounter_date_entry: "Fecha del Servicio",
            status: {
              received: "Recibido",
              integrated: "Integrado",
              pending: "Pendiente",
              error: "Error",
            },
            details: {
              title: "Detalles de la Atención",
              log_id: "ID del Log",
              status: "Estado",
              created: "Fecha de Creación",
              last_modified: "Última Modificación",
              log_data: "Datos del Log",
              logs_table_title: "Logs de Integración",
              close: "Cerrar",
              view_full_log: "Ver Log Completo",
              success: "Éxito",
              error: "Error",
            },
          },
          tasyToTasyResultsNonLabAvailable: {
            title:
              "Tasy <> Tasy - Resultados de Exámenes No Laboratoriales (Disponibles)",
            identifier: "Identificador",
            service_number: "Número de Atención",
            patient_cpf: "CPF del Paciente",
            status_item: "Estado",
            prescription_number: "Número de Prescripción",
            procedure_prescription_number:
              "Número de Prescripción de Procedimiento",
            external_prescription_number: "Número de Prescripción Externa",
            external_procedure_prescription_number:
              "Número de Prescripción de Procedimiento Externo",
            external_service_number: "Número de Atención Externo",
            start_date: "Fecha Inicial",
            end_date: "Fecha Final",
            view_details: "Ver detalles",
            status: {
              available: "Disponible",
              downloaded: "Descarga Completa",
              recognized: "Reconocido",
              integrated: "Integrado",
              error: "Error",
              cancelled: "Cancelado",
            },
            details: {
              title: "Detalles del Resultado",
              log_id: "ID del Log",
              status: "Estado",
              created: "Fecha de Creación",
              last_modified: "Última Modificación",
              log_data: "Datos del Log",
              status_message: "Mensaje",
              logs_table_title: "Logs de Integración",
              close: "Cerrar",
              view_full_log: "Ver Log Completo",
              success: "Éxito",
              error: "Error",
            },
          },
          tasyToTasyResultsNonLabReceived: {
            title:
              "Tasy <> Tasy - Resultados de Exámenes No Laboratoriales (Recibidos)",
            identifier: "Identificador",
            service_number: "Número de Atención",
            patient_cpf: "CPF del Paciente",
            status_item: "Estado",
            prescription_number: "Número de Prescripción",
            procedure_prescription_number:
              "Número de Prescripción de Procedimiento",
            external_prescription_number: "Número de Prescripción Externa",
            external_procedure_prescription_number:
              "Número de Prescripción de Procedimiento Externo",
            external_service_number: "Número de Atención Externo",
            start_date: "Fecha Inicial",
            end_date: "Fecha Final",
            view_details: "Ver detalles",
            status: {
              available: "Disponible",
              downloaded: "Descarga Completa",
              recognized: "Reconocido",
              integrated: "Integrado",
              error: "Error",
              cancelled: "Cancelado",
            },
            details: {
              title: "Detalles del Resultado",
              log_id: "ID del Log",
              status: "Estado",
              created: "Fecha de Creación",
              last_modified: "Última Modificación",
              log_data: "Datos del Log",
              status_message: "Mensaje",
              logs_table_title: "Logs de Integración",
              close: "Cerrar",
              view_full_log: "Ver Log Completo",
              success: "Éxito",
              error: "Error",
            },
          },
          syncTransaction: {
            title: "Sync - Datos de las Transacciones",
            identifier: "Identificador",
            name: "Nombre",
            cpf: "CPF",
            external_id: "ID Externo",
            status_item: "Estado",
            start_date: "Fecha Inicial",
            end_date: "Fecha Final",
            view_action: "Ver Acción",
            actions: "Acciones",
            last_modified: "Última actualización",
            original_value: "Valor original",
            new_value: "Nuevo valor",
            message: "Mensaje",
            retries: "Reintentos",
            created: "Fecha de creación",
            resend: "Forzar reenvío",
            resend_row: "Reenviar",
            resend_confirm_title: "Forzar reenvío",
            resend_confirm_description: "¿Reenviar {{quantity}} transacción(es) seleccionada(s)? Solo las que tengan estado Error vuelven a la cola; las demás se ignorarán.",
            resend_confirm_button: "Reenviar",
            resend_cancel: "Cancelar",
            resend_select_rows: "Seleccione al menos una transacción.",
            resend_result_title: "Resultado del reenvío",
            resend_result_summary: "{{restarted}} reenviada(s), {{ignored}} ignorada(s) por estado y {{failed}} con error.",
            resend_result_failed_title: "Transacciones con error",
            resend_result_source_hint: "Si el error proviene del dato de origen (por ejemplo, un CPF inválido), la transacción volverá a fallar. Corrija el dato en el origen.",
            resend_result_close: "Cerrar",
            individual_last_modified: "Alteración en el origen",
            origin_system: "Sistema de origen",
            logs: "Logs",
            no_transactions: "No se encontraron transacciones.",
            no_actions: "No se encontraron acciones.",
            no_logs: "No se encontraron logs.",
            status: {
              error: "Error",
              success: "Éxito",
              in_process: "En Proceso",
              pending: "Pendiente",
              waiting_action_generation: "Esperando la Generación de Acciones",
            },
          },
        },
        sync: {
          sync: "Sincronización",
          sync_all: "Sincronizar todo",
          synced_all: "Sincronización completada exitosamente",
        },
        uBusAutomationRobot: {
          suffixPrefix: "Sufijo/Prefijo",
          identificationPosition: "Posición del formulario de identificación",
          exam_machine_files: "Integración de Archivos",
          add_exam_machine_files: "Agregar Integración de Archivos",
          name_table: "Nombre",
          search: "Busque una integración de archivos",
          description_table: "Descripción",
          internal_procedure_integration_id: "Código de Procedimiento Interno",
          medical_certificate_content: "Reportar mensaje",
          physician_will_report: "Genera Informe en Digitación",
          path_table: "Ruta",
          file_integration: "Integración de Archivos",
          new_file_integration: "Nueva Integración de Archivos",
          ubus_automation: "Tipo de Integración de Archivos",
          name: "Nombre del Mapeo de Archivos",
          machine_mode: "Modalidad de la Máquina de Exámenes",
          path: "Ruta de Monitoreo de Archivos",
          description: "Descripción",
          exam_machine: "Marca/Modelo de la Máquina de Exámenes",
          software: "Software",
          integration_attribute:
            "Método de Identificación del Destino en los Archivos",
          minutes: "Minutos de Ejecución",
          generate_pdf_with_images: "Agrupar Imágenes y Generar PDF",
          rotate_images: "Girar Imágenes Individualmente",
          rotation_mode: "Configuración de Giro de Imágenes",
          insert_report_test_pdf:
            "Incluir Informe PDF en el Informe del Paciente",
          minutes_to_group_pdf: "Tiempo de Agrupación de Imágenes (en minutos)",
          insert_report_test_pdf_as_image:
            "Incluir el PDF en el Anexo del Informe del Paciente",
          insert_image_as_attachment:
            "Incluir las Imágenes en el Anexo del Informe del Paciente",
          make_copy_files_end_of_process:
            "Hacer una copia de los archivos al final del proceso",
          copy_files_path: "Ruta para guardar copia de archivos",
          copy_process: "Proceso de copia",
          rename_file_process: "Cambiar el nombre de los archivos",
          ubus_automation_execution: "Destino de los Archivos",
          path_separator: "Separador",
          enable: "Permitir",
          status: "Status",
          active: "Activo",
          inactive: "Inactivo",
          confirm: {
            title: "¿Eliminar Integración de Archivos?",
            description:
              "Esto eliminará permanentemente la Integración de Archivos",
          },
          errors: {
            name: "El nombre del mapeo de archivos es obligatorio",
            path: "La ruta de monitoreo de archivos es obligatoria",
            description: "La descripción es obligatoria",
            exam_machine:
              "La marca/modelo de la máquina de exámenes es obligatoria",
            software: "El software es obligatorio",
            integration_attribute:
              "El método de identificación del destino en los archivos es obligatorio",
            minutes: "Los minutos de ejecución son obligatorios",
            insert_report_test_pdf:
              "La opción de agrupar imágenes y generar un PDF es obligatoria",
            minutes_to_group_pdf:
              "El tiempo de agrupación de imágenes (en minutos) es obligatorio",
            uBusAutomationExecution:
              "El destino de los archivos es obligatorio",
            uBusAutomation: "El tipo de integración de archivos es obligatorio",
            examMachineModality:
              "La modalidad de la máquina de exámenes es obligatoria",
            rotation_mode:
              "La configuración de giro de imágenes es obligatoria",
            external_procedure_integrationId:
              "El código de procedimiento interno es obligatorio",
            internal_procedure_integration_id:
              "El código de procedimiento interno es obligatorio",
            copy_files_path:
              "El ruta para guardar copia de archivos es obligatoria",
            copy_process: "El proceso de copia es obligatoria",
            suffixPrefix: "Sufijo/Prefijo debe tener como máximo 50 caracteres",
          },
        },
        robots: {
          list: {
            list: "Lista de Robots",
            search: "Buscar un robot",
            name: "Nombre",
            description: "Descripción",
            code: "Código",
            started: "Comenzó",
            last_success: "Último éxito",
            last_error: "Último error",
            last_error_message: "Último mensaje de error",
            status: "Status",
            active: "Activo",
            inactive: "Inactivo",
            executions_robots: "Ejecuciones de Robots",
            executions: {
              executions_robots: "Ejecuciones de Robots",
              job_name: "Nombre del job",
              start_date: "Fecha de inicio",
              end_date: "Fecha de fin",
              execution_status: "Status de ejecución",
            },
          },
        },
        zscanExamSendRule: {
          exam_send_rules: "Reglas de envío de exámenes",
          exam_send_rule: "Regla de envío de exámenes",
          add_exam_send_rule: "Agregar regla de envío de exámenes",
          new_exam_send_rule: "Nueva regla de envío de exámenes",
          target_machine: "Máquina de destino",
          proc_classification_integration_id:
            "ID de clasificación del procedimiento",
          initial_date: "Fecha de inicio",
          end_date: "Fecha de fin",
          enable: "Habilitar",
          status: "Estado",
          active: "Activo",
          inactive: "Inactivo",
          errors: {
            target_machine: "La máquina de destino es obligatoria",
            proc_classification_integration_id:
              "El ID de clasificación del procedimiento es obligatorio",
            initial_date: "La fecha de inicio es obligatoria",
            end_date: "La fecha de fin es obligatoria",
            initial_date_bigger:
              "La fecha de inicio no puede ser mayor que la fecha de fin",
          },
          confirm: {
            title: "¿Eliminar regla de envío de exámenes?",
            description:
              "Esto eliminará permanentemente la regla de envío de exámenes",
          },
        },
        integrationRule: {
          integration_rules: "Reglas de Integración",
          integration_rule: "Regla de Integración",
          add_integration_rule: "Agregar regla de integración",
          new_integration_rule: "Nueva regla de integración",
          search: "Buscar una regla de integración",
          automation: "Automatización",
          name: "Nombre",
          description: "Descripción",
          u_bus_automation: "Automatización de 4uBus",
          i_processe: "Proceso",
          start_date: "Fecha de inicio de vigencia",
          end_date: "Fecha de fin de vigencia",
          initial_date: "Fecha de corte",
          filters: "Filtros",
          status: "Estado",
          active: "Activo",
          inactive: "Inactivo",
          enable: "Habilitar",
          created_successfully: "Regla de integración registrada con éxito",
          integration_rule_relationship_group: "Grupo de Relación",
          i_services: "Servicios",
          transfers: "Movimientos",
          parameters: "Parámetros",
          rules: "Reglas",
          suspension_reason_code: "Código de motivo de suspensión",
          batch_size: "Tamaño máximo del lote",
          max_workers: "Cantidad máxima de procesos simultáneos",
          only_requestable_lab_exams:
            "Considerar solo exámenes de laboratorio solicitables",
          only_requestable_lab_exams_tooltip:
            "Cuando está activado, la búsqueda automática del procedimiento interno ignora los exámenes de laboratorio marcados como no solicitables en Tasy (IE_SOLICITACAO distinto de 'S').",
          reports_tooltip:
            "Use {{NR_LAUDOS}} en el texto para reemplazarlo por los informes liberados incluidos en el e-mail.",
          email_copy_recipients_tooltip:
            "En este campo se pueden agregar e-mails que recibirán una copia de los e-mails enviados. Se pueden agregar varios e-mails separados por comas.",
          integrationRuleRelationshipGroup: {
            integration_rule_relationship_groups: "Grupos de Relación",
            integration_rule_relationship_group: "Grupo de Relación",
            add_integration_rule_relationship_group:
              "Agregar grupo de relación",
            new_integration_rule_relationship_group: "Nuevo grupo de relación",
            search: "Buscar un grupo de relación",

            priority: "Prioridad",
            u_bus_relationship_group: "Grupo de Relación de 4uBus",
            confirm: {
              title: "¿Eliminar grupo de relación?",
              description:
                "Esto eliminará permanentemente el grupo de relación",
            },
            errors: {
              u_bus_relationship_group:
                "El grupo de relación de 4uBus es obligatorio",
            },
          },
          integrationRuleIService: {
            integration_rule_i_services: "Servicios",
            integration_rule_i_service: "Servicio",
            add_integration_rule_i_service: "Agregar servicio",
            new_integration_rule_i_service: "Nuevo servicio",
            search: "Buscar un servicio",
            integration_direction_type: "Tipo de Dirección de Integración",
            i_service: "Servicio",
            grid_warning:
              'Ningún registro estará disponible en esta integración mientras no se cree una regla en el campo "Tipo de dirección de integración" con el valor "Entrada de sistema tercero". Con base en esta configuración se habilita el acceso a los datos.',
            confirm: {
              title: "¿Eliminar servicio?",
              description: "Esto eliminará permanentemente el servicio",
            },
            errors: {
              integration_direction_type:
                "El tipo de dirección de integración es obligatorio",
              i_service: "El servicio es obligatorio",
            },
          },
          integrationRuleMov: {
            integration_rule_movs: "Movimientos",
            integration_rule_mov: "Movimiento",
            add_integration_rule_mov: "Agregar Movimiento",
            new_integration_rule_mov: "Nuevo Movimiento",
            search: "Buscar un movimiento",
            status: "Estado",
            enable: "Habilitar",
            active: "Activo",
            inactive: "Inactivo",
            individual_external_id: "Identificador Externo del Paciente",
            individual_identifier_message_helper:
              "Los valores deben separarse por comas",
            internal_proc_classification:
              "Clasificación del Procedimiento Interno",
            procedure_type: "Tipo de Procedimiento",
            tasy_ops_if_label: "Si",
            tasy_ops_then_label: "Entonces",
            establishment_external_id: "Establecimiento",
            provider_external_id: "Prestador",
            establishment_external_id_then: "Establecimiento (Entonces)",
            patient_encounter_type_external_id_then:
              "Tipo de Atención (Entonces)",
            tiss_attendance_type_external_id_then:
              "Tipo de Atención Tiss (Entonces)",
            patient_encounter_origin_external_id_then:
              "Origen de la Atención (Entonces)",
            patient_care_character_external_id_then:
              "Carácter de la Atención (Entonces)",
            patient_care_classification_external_id_then:
              "Clasificación de la Atención (Entonces)",
            insurance_type_external_id_then: "Tipo de Seguro (Entonces)",
            insurance_external_id_then: "Seguro (Entonces)",
            insurance_category_external_id_then:
              "Categoría del Seguro (Entonces)",
            insurance_plan_external_id_then: "Plan del Seguro (Entonces)",
            sector_external_id_then: "Sector (Entonces)",
            sector_basic_unit_external_id_then:
              "Unidad Básica del Sector (Entonces)",
            sector_compl_unit_external_id_then:
              "Unidad Complementaria del Sector (Entonces)",
            sector_accommodation_type_external_id_then:
              "Tipo de Alojamiento (Entonces)",
            hvs_upa_ps_if_label: "Si",
            hvs_upa_ps_then_label: "Entonces",
            hvs_upa_ps_job1_label: "Job 1 · Buscar atenciones elegibles",
            hvs_upa_ps_job1_description:
              "Define qué atenciones con alta entran en la cola de transferencia. Los filtros de abajo restringen la búsqueda; el identificador del paciente limita la búsqueda a una sola persona (útil en pruebas).",
            hvs_upa_ps_job2_phase1_label:
              "Job 2 · Fase 1 — Generar nueva atención y prescripción",
            hvs_upa_ps_job2_phase1_description:
              "Crea una nueva atención con las características de la actual (establecimiento, tipo, origen, carácter, convenio y sector) y una prescripción con los procedimientos de abajo. Sirve para remunerar al médico original por la consulta inicial.",
            hvs_upa_ps_job2_phase2_label:
              "Job 2 · Fase 2 — Transferir la atención actual a Urgencias",
            hvs_upa_ps_job2_phase2_description:
              "Actualiza la atención actual con el sector, la unidad, el tipo de atención TISS y el médico de abajo. El médico viene de la escala o de la última atención del día; si no se encuentra ninguno, se usa el Médico Predeterminado.",
            insurance: "Convenio",
            sector: "Sector",
            verify_released_opinion:
              "Verifica si existe una opinión médica liberada",
            procedure_area: "Área del Procedimiento",
            procedure_specialty: "Especialidad del Procedimiento",
            procedure_group: "Grupo del Procedimiento",
            lab_exam_classification: "Clasificación del examen de laboratorio",
            plan_operation_type: "Tipo de operación del producto",
            plan_price_formation: "Formación del precio del producto",
            plan_filters_message_helper:
              "Los Movimientos de la misma regla deben ser excluyentes: una guía que cumpla más de un Movimiento queda solo con el primero procesado.",
            internal_procedure: "Procedimiento Interno",
            internal_procedure_then: "Procedimiento Interno (Entonces)",
            doctor_obtain_mode: "Forma de obtención del médico",
            doctor_obtain_mode_schedule: "Según la escala",
            doctor_obtain_mode_last_encounter_of_day:
              "Médico de la última atención del día",
            schedule_then: "Escala (Entonces)",
            default_doctor_external_id_then: "Médico Predeterminado (Entonces)",
            confirm: {
              title: "¿Eliminar Movimiento?",
              description: "Esto eliminará permanentemente el Movimiento",
            },
            errors: {
              establishment_external_id: "El establecimiento es obligatorio",
              provider_external_id: "El proveedor es obligatorio",
              establishment_external_id_then:
                "El establecimiento (entonces) es obligatorio",
              patient_encounter_type_external_id_then:
                "El tipo de atención (entonces) es obligatorio",
              patient_encounter_origin_external_id_then:
                "El origen de la atención (entonces) es obligatorio",
              patient_care_character_external_id_then:
                "El carácter de la atención (entonces) es obligatorio",
              patient_care_classification_external_id_then:
                "La clasificación de la atención (entonces) es obligatoria",
              insurance_external_id_then:
                "El convenio (entonces) es obligatorio",
              insurance_category_external_id_then:
                "La categoría del convenio (entonces) es obligatoria",
              sector_external_id_then: "El sector (entonces) es obligatorio",
              sector_basic_unit_external_id_then:
                "La unidad básica del sector (entonces) es obligatoria",
              sector_accommodation_type_external_id_then:
                "El tipo de alojamiento (entonces) es obligatorio",
              tiss_attendance_type_external_id_then:
                "El tipo de atención Tiss (entonces) es obligatorio",
              sector_compl_unit_external_id_then:
                "La unidad complementaria del sector (entonces) es obligatoria",
              u_bus_integration_rule_mov_internal_procedures_then:
                "El procedimiento interno (entonces) es obligatorio",
              u_bus_integration_rule_mov_schedules_then:
                "La escala (entonces) es obligatoria",
            },
          },
          integrationRuleParam: {
            integration_rule_params: "Parámetros",
            integration_rule_param: "Parámetro",
            add_integration_rule_param: "Agregar Parámetro",
            new_integration_rule_param: "Nuevo Parámetro",
            search: "Buscar un parámetro",
            inclusion_rule_type: "Tipo de regla de inclusión",
            if: "Si",
            then: "Entonces",
            source_name: "Nombre de origen",
            source_value: "Valor de origen",
            destination_name: "Nombre en el destino",
            destination_value: "Valor en el destino",
            sector: "Sector",
            basic_unit: "Unidad Básica",
            complementary_unit: "Unidad Complementaria",
            insurance: "Convenio",
            category: "Categoría",
            establishment: "Establecimiento",
            procedure: "Procedimiento",
            procedure_origin: "Origen Procedimiento",
            internal_procedure: "Procedimiento Interno",
            material: "Material",
            service_code: "Código del Servicio",
            service_origin: "Origen del Servicio",
            confirm: {
              title: "¿Eliminar Parámetro?",
              description: "Esto eliminará permanentemente el Parámetro",
            },
            errors: {
              inclusion_rule_type:
                "El tipo de regla de inclusión es obligatorio",
              required_field: "Campo obligatorio",
            },
          },
          integrationRuleField: {
            integration_rule_fields: "Reglas",
            integration_rule_field: "Regla",
            add_integration_rule_field: "Agregar regla",
            new_integration_rule_field: "Nueva regla",
            search: "Buscar una regla",
            automation_field: "Campo de automatización",
            individual_external_id: "Identificador Externo del Paciente",
            if: "Si",
            then: "Entonces",
            softwares: "Softwares",
            confirm: {
              title: "¿Eliminar regla?",
              description: "Esto eliminará permanentemente la regla",
            },
            errors: {
              automation_field: "El campo de automatización es obligatorio",
            },
          },
          confirm: {
            title: "¿Eliminar regla de integración?",
            description:
              "Esto eliminará permanentemente la regla de integración",
          },
          errors: {
            name: "El nombre es obligatorio",
            start_date: "La fecha de inicio es obligatoria",
            end_date: "La fecha de fin es obligatoria",
            initial_date: "La fecha de corte es obligatoria",
            start_date_bigger:
              "La fecha de inicio no puede ser mayor que la fecha de fin",
            u_bus_automation: "La automatización de 4uBus es obligatoria",
            i_processe: "El proceso es obligatorio",
            suspension_reason_code:
              "El código de motivo de suspensión es obligatorio",
            batch_size_min: "El tamaño máximo del lote debe ser mayor que cero",
            max_workers_min:
              "La cantidad máxima de procesos debe ser mayor que cero",
            max_workers_max:
              "La cantidad máxima de procesos no puede ser mayor que 5",
          },
        },
      },
      "4uSiteApp": {
        siteLoginContent: {
          site_login_content: "Contenido de Inicio de Sesión",
          search: "Busque un contenido de inicio de sesión",
          add_site_login_content: "Agregar contenido",
          name: "Nombre",
          presentation_order: "Orden de presentación",
          enable: "Habilitar",
          link_url: "Url del enlace",
          link_label: "Etiqueta del enlace",
          document: "Documento",
          language: "Idioma",
          language_tooltip: "Registrar un nuevo idioma",
          add_new_language: "Agregar nuevo idioma",
          status: "Status",
          active: "Activo",
          inactive: "Inactivo",
          confirm: {
            title: "¿Eliminar el contenido de inicio de sesión?",
            description:
              "Esto eliminará permanentemente el contenido de inicio de sesión",
          },
          errors: {
            name: "El nombre es obligatorio",
            presentation_order: "El orden de presentación es obligatorio",
            document_text: "El contenido es obligatorio",
            language: "El idioma es obligatorio",
            languages: "Informe al menos un idioma",
          },
        },
        applications: {
          myApplications: {
            my_applications: "Mis aplicaciónes",
            search: "Buscar una aplicación",
            name: "Nombre",
            type: "Tipo",
            status: "Status",
            active: "Activo",
            inactive: "Inactivo",
          },
        },
        consultationsAndLogs: {
          beneficiarySituation: {
            title: "Situación del Beneficiario",
            document: "CPF",
            establishment_code: "Establecimiento",
            person_code: "Código de la persona",
            name: "Nombre",
            insured_code: "Código del asegurado",
            plan: "Plan",
            card_code: "Código de la tarjeta",
            card_validity: "Validez de la tarjeta",
            contract_status: "Situación del contrato",
            details: "Datos completos",
            birth_date: "Fecha de nacimiento",
            accession_date: "Fecha de adhesión",
            another_plan_qty: "Otros planes",
            locks: "Bloqueos",
            lock_code: "Código",
            description: "Descripción",
            unlock_date: "Desbloqueo",
            temporary_partial_coverage: "CPT",
            view_details: "Ver detalles",
            search_placeholder: "Buscar beneficiarios...",
            errors: {
              document_required: "El CPF es obligatorio",
            },
          },
        },
      },
      "4uSalesContract": {
        registers: {
          grantors: {
            active: "Activo",
            inactive: "Inactivo",
            name: "Nombre",
            status: "Status",
            grantors: "Otorgantes",
            add_grantor: "Agregar Otorgante",
            enabled: "Permitir",
            establishments: "Establecimientos",
            new_grantor: "Nuevo Otorgante",
            legal_entity: "Persona Jurídica",
            search_grantors: "Buscar un Otorgante",
            confirm: {
              title: "¿Eliminar otorgante?",
              description: "Esto eliminará permanentemente al otorgante",
            },
            errors: {
              name: "El nombre es obligatorio",
              establishment: "Al menos un establecimiento es obligatorio",
              legal_entity: "La persona jurídica es obligatoria",
            },
          },
          salesContractAttachments: {
            title: "Anexo",
            description: "Descripción",
            search: "Buscar Anexos",
            add: "Agregar Anexo",
            title_form: "Título",
            approval_date: "Fecha de Aprobación",
            approve: "Aprobar",
            attachment_date: "Fecha del Anexo",
            new_attachment: "Nuevo Anexo",
            attachment_type: "Tipo de Anexo",
            confirm: {
              title: "¿Eliminar Anexo?",
              description: "Esto eliminará permanentemente el Anexo",
            },
            errors: {
              title: "El Título es obligatorio",
              description: "La descripción es obligatoria",
              attachment_type: "El tipo de anexo es obligatorio",
              attachment_date: "La fecha del anexo es obligatoria",
              file: "El archivo es obligatorio",
            },
          },
          salesContractHistories: {
            title: "Historia",
            search: "Buscar Historia",
            add: "Agregar Historia",
            contract_title: "Historia",
            new_history: "Nueva Historia",
            titleForm: "Título",
            history: "Historia",
            approval_date: "Fecha de Aprobación",
            history_date: "Fecha de Historia",
            approve: "Aprobar",
            confirm: {
              title: "¿Eliminar Historia?",
              description: "Esto eliminará permanentemente la Historia",
            },
            errors: {
              title: "El Titulo es obligatorio",
              history: "El História es obligatorio",
              historyDate: "La Fecha de Historia es obligatorio",
            },
          },
          contractAttachmentType: {
            title: "Tipo de Adjunto de Contrato",
            search: "Buscar un Tipo de Adjunto de Contrato",
            add: "Añadir Tipo de Adjunto de Contrato",
            new: "Nuevo Tipo de Adjunto de Contrato",
            active: "Activo",
            inactive: "Inactivo",
            contract_type: "Tipo de Contrato",
            enabled: "Permitir",
            name: "Nombre",
            status: "Estado",
            confirm: {
              title: "¿Eliminar tipo de adjunto de contrato?",
              description:
                "Esto eliminará permanentemente el tipo de adjunto de contrato",
            },
            errors: {
              name: "El nombre es obligatorio",
              contract_type: "El tipo de contrato es obligatorio",
            },
          },
          contractTerminationReason: {
            title: "Motivo de Cancelación de Contrato",
            search: "Buscar Motivo de Cancelación de Contrato",
            add: "Agregar Motivo de Cancelación de Contrato",
            new: "Nuevo Motivo de Cancelación de Contrato",
            active: "Activo",
            inactive: "Inactivo",
            code: "Código",
            contract_type: "Tipo de Contrato",
            enabled: "Permitir",
            name: "Nombre",
            status: "Estado",
            confirm: {
              title: "¿Eliminar motivo de cancelación de contrato?",
              description:
                "Esto eliminará permanentemente el motivo de cancelación de contrato",
            },
            errors: {
              name: "El nombre es obligatorio",
              contract_type: "El tipo de contrato es obligatorio",
            },
          },
          contract_classifications: {
            name: "Nombre",
            status: "Estado",
            active: "Activo",
            inactive: "Inactivo",
            enabled: "Permitir",
            code: "Código",
            contract_type: "Tipo de Contrato",
            contract_classification: "Clasificación de Contrato",
            search_contract_classification:
              "Buscar una Clasificación de Contrato",
            add_contract_classification: "Agregar Clasificación de Contrato",
            new_contract_classification: "Nueva Clasificación de Contrato",
            confirm: {
              title: "¿Eliminar clasificación de contrato?",
              description:
                "Esto eliminará permanentemente la clasificación de contrato",
            },
            errors: {
              name: "El nombre es obligatorio",
              contract_type: "El tipo de contrato es obligatorio",
            },
          },
          baseContracts: {
            title: "Club de Beneficios y Ventajas",
            search: "Buscar Club de Beneficios y Ventajas",
            add: "Agregar Club de Beneficios y Ventajas",
            contratation_date: "Fecha de Contratación",
            start_date: "Fecha Inicial",
            end_date: "Fecha Final",
            termination_date: "Fecha de Finalización",
            situation_status: "Estado de la Situación",
            situation: "Situación",
            filter: "Para filtrar, es necesario proporcionar las fechas",
            contract_classification: "Clasificación del Contrato",
            integration_code: "Código de Integración",
            name: "Nombre",
            code: "Código",
            status: "Estado",
            approved: "Aprobado",
            canceled: "Cancelado",
            pending: "En Revisión",
            dateFutureFilter:
              "Fecha inicial o fecha final es mayor que el día de hoy",
            dateFilter: "Fecha inicial es mayor que la fecha final",
            terminated: "Rescindido",
            approve: "Aprobar",
            cancel: "Cancelar",
            terminate: "Rescindir",
            reactivation: "Reactivar",
            contractualObject: {
              substipulant: "Sustituyente",
              product: "Producto",
            },
            confirm: {
              title: "¿Eliminar el club de beneficios y ventajas?",
              description:
                "Esto eliminará permanentemente el club de beneficios y ventajas",
            },
            advantagesAndBenefitsClub: {
              title: "Club de Ventajas y Beneficios",
              advantages_and_benefits_club_contract:
                "Contratos del Club de Ventajas y Beneficios",
              grantor: "Otorgante",
              contract_classification: "Clasificación del Contrato",
              contract_number: "Número de Contrato",
              integration_code: "Código de Integración",
              contract_title: "Título del Contrato",
              renewal_period: "Período de Renovación (meses)",
              main_contract: "Contrato Principal",
              situation: "Situación",
              legal_entity: "Persona Jurídica",
              individual_person: "Persona Física",
              contratation_data: "Datos de la Contratación",
              contract_type: "Tipo de Contrato",
              contratation_date: "Fecha de la Contratación",
              termination_date: "Fecha de Terminación",
              approval_date: "Fecha de Aprobación",
              cancelation_date: "Fecha de Cancelación",
              reactivation_date: "Fecha de Reactivación",
              code: "Código",
              benefit_administrators: "Administradores de Beneficios",
              additional_data:
                "Datos Adicionales para el Club de Ventajas y Beneficios",
              tabs: {
                contractual_object: "Objetos Contratuais",
                history: "Historial",
                contract: "Contrato",
                payer: "Pagadores",
                attachment: "Anexos",
                beneficiary: "Beneficiario",
              },
              errors: {
                contract_date: "La fecha de contratación es obligatoria",
                contract_type: "El Tipo de Contrato es obligatorio",
                individual_person: "La persona física es obligatoria",
                legal_entity: "La persona jurídica es obligatoria",
                renew_months: "El Período de Renovación es obligatorio",
                grantor: "El Otorgante es obligatorio",
                situation: "La situación es obligatoria",
                contract_classification:
                  "La Clasificación de Contrato es obligatoria",
                contract_title: "El Título del contrato es obligatorio",
              },
            },
          },
          beneficiaryClassification: {
            title: "Clasificación de Beneficiarios",
            new: "Nueva Clasificación de Beneficiarios",
            add: "Agregar Clasificación de Beneficiarios",
            search: "Buscar Clasificación de Beneficiarios",
            name: "Nombre",
            status: "Estado",
            enable: "Permitir",
            active: "Activo",
            inactive: "Inactivo",
            confirm: {
              title: "¿Eliminar clasificación de beneficiarios?",
              description:
                "Esto eliminará permanentemente la clasificación de beneficiarios",
            },
            errors: {
              name: "El nombre es obligatorio",
            },
          },
          contractProductClassifications: {
            title: "Clasificación de Productos",
            contract_product_classification: "Clasificación de Producto",
            search: "Buscar una Clasificación de Productos",
            name: "Nombre",
            status: "Estado",
            active: "Activo",
            inactive: "Inactivo",
            code: "Código",
            enabled: "Permitir",
            add: "Agregar Clasificación de Producto",
            new: "Nueva Clasificación de Producto",
            contract_type: "Tipo de Contrato",
            confirm: {
              title: "¿Eliminar clasificación de producto?",
              description:
                "Esto eliminará permanentemente la clasificación de producto",
            },
            errors: {
              name: "El nombre es obligatorio",
              contract_type: "El tipo de contrato es obligatorio",
            },
          },
          channelClassifications: {
            title: "Clasificaciones del Canal de Ventas",
            channel_classification: "Clasificación del Canal de Ventas",
            search: "Buscar Clasificación del Canal de Ventas",
            add: "Agregar Clasificación del Canal de Ventas",
            new: "Nueva Clasificación del Canal de Ventas",
            name: "Nombre",
            code: "Código",
            enable: "Permitir",
            status: "Estado",
            active: "Activo",
            inactive: "Inactivo",
            confirm: {
              title: "Eliminar Clasificación del Canal de Ventas",
              description:
                "Esto eliminará permanentemente la clasificación del canal de ventas",
            },
            errors: {
              name: "El nombre es obligatorio",
              status: "El estado es obligatorio",
            },
          },
          salesChannel: {
            title: "Canales de Venta",
            sales_channel: "Canal de Ventas",
            search: "Buscar Canal de Ventas",
            add: "Agregar Canal de Ventas",
            new: "Nuevo Canal de Ventas",
            legal_entity: "Persona Jurídica",
            individual_person: "Persona Física",
            title_placeholder: "Título",
            name: "Nombre",
            code: "Código",
            active: "Activo",
            inactive: "Inactivo",
            suspension: "Suspender",
            inactivation: "Inactivo",
            reactivation: "Reactivar",
            approve: "Aprobar",
            approved: "Aprobado",
            contract_type: "Tipo de Contrato",
            enabled: "Permitir",
            reactivation_date: "Fecha de Reactivación",
            inactivation_date: "Fecha de Inactivación",
            suspension_date: "Fecha de Suspensión",
            approval_date: "Fecha de Aprobación",
            situation: "Situación",
            classification: "Clasificación",
            sales_channel_type: "Tipo de Canal de Ventas",
            tabs: {
              sales_channel: "Canal de Ventas",
              seller: "Vendedores",
            },
            confirm: {
              title: "¿Eliminar canal de ventas?",
              description: "Esto eliminará permanentemente el canal de ventas",
            },
            errors: {
              title: "El título es obligatorio",
              situation: "La situación es obligatoria",
              sales_channel_classification: "La clasificación es obligatoria",
              sales_channel_type: "El tipo de canal de ventas es obligatorio",
              individual_person: "La persona física es obligatoria",
              legal_entity: "La persona jurídica es obligatoria",
            },
          },
          salesContractBeneficiary: {
            title: "Beneficiario",
            search: "Buscar por Beneficiario",
            add: "Agregar Beneficiario",
            new: "Nuevo Beneficiario",
            individual_person: "Persona Física",
            code: "Código",
            integration_code: "Código de Integración",
            approve: "Aprobar",
            cancel: "Cancelar",
            reestablish: "Restablecer",
            rescind: "Rescindir",
            suspend: "Suspender",
            approved: "Aprobado",
            canceled: "Cancelado",
            under_analysis: "En Análisis",
            rescinded: "Rescindido",
            suspended: "Suspendido",
            beneficiary_card: "Tarjeta del Beneficiario",
            substipulant: "Subestipulante",
            admission_date: "Fecha de Admisión",
            beneficiary_holder: "Beneficiario Titular",
            original_inclusion_date: "Fecha Original de Inclusión",
            beneficiary_classification: "Clasificación del Beneficiario",
            type_of_holder: "Tipo de Titularidad",
            kinship_degree: "Grado de Parentesco",
            sales_product: "Producto",
            sales_price_list: "Lista de Precios",
            sales_payer: "Pagador",
            sales_channel: "Canal de Ventas",
            sales_seller: "Vendedor",
            reactivation_date: "Fecha de Reactivación",
            inactivation_date: "Fecha de Inactivación",
            suspension_date: "Fecha de Suspensión",
            approval_date: "Fecha de Aprobación",
            situation: "Situación",
            confirm: {
              title: "¿Eliminar Beneficiario?",
              description: "Esto eliminará permanentemente al Beneficiario",
            },
            errors: {
              situation: "La situación es obligatoria",
              individual_person: "La Persona Física es obligatoria",
              beneficiary_classification:
                "La clasificación del beneficiario es obligatoria",
              sales_product: "El producto es obligatorio",
              sales_price_list: "La lista de precios es obligatoria",
              sales_channel: "El canal de ventas es obligatorio",
              sales_payer: "El pagador es obligatorio",
              sales_seller: "El vendedor es obligatorio",
            },
          },
          salesContractBeneficiaryCard: {
            title: "Tarjeta del Beneficiario",
            add: "Agregar Tarjeta del Beneficiario",
            card_identifier: "Identificador de la Tarjeta",
            initial_date: "Fecha de Inicio",
            end_date: "Fecha Final",
            integration_code: "Código de Integración",
            confirm: {
              title: "¿Eliminar Tarjeta del Beneficiario?",
              description:
                "Esto eliminará permanentemente la Tarjeta del Beneficiario",
            },
            errors: {
              card_identifier: "El identificador de la tarjeta es obligatorio",
              initial_date: "La fecha de inicio es obligatoria",
              end_date: "La fecha final es obligatoria",
            },
          },
          salesContractPayerFinantial: {
            title: "Financiero del Pagador",
            search: "Buscar Financiero del Pagador",
            add: "Agregar Financiero del Pagador",
            new: "Nuevo Financiero del Pagador",
            mail: "Correo Electrónico",
            biling_method: "Método de Facturación",
            monthly_payment_due_date: "Día de pago",
            enable: "Permitir",
            history: "Historia",
            initial_date: "Fecha Inicial",
            new_finantial: "Nuevo",
            financial: "financeiro",
            end_date: "Fecha Final",
            phone: "Teléfono",
            whatsapp_number: "Número de WhatsApp",
            observation: "Observación",
            confirm: {
              title: "¿Eliminar Pagador?",
              description: "Esto eliminará permanentemente al Pagador",
            },
            errors: {
              biling_method: "El método de facturación es obligatorio",
              initial_date: "La fecha inicial es obligatoria",
              end_date: "La fecha final es obligatoria",
              monthly_payment_due_date: "El día de pago es obligatorio",
            },
          },
          salesContractPayer: {
            title: "Pagador",
            search: "Buscar Pagador",
            add: "Agregar Pagador",
            new: "Nuevo Pagador",
            payer_finantial: "Financiero del Pagador",
            legal_entity: "Persona Jurídica",
            individual_person: "Persona Física",
            title_payer: "Título",
            payer: "Pagador",
            address_type: "Tipo de dirección",
            address: "Dirección",
            payerType: "Tipo",
            integration_code: "Código de Integración",
            code: "Código",
            active: "Activo",
            inactive: "Inactivo",
            suspension: "Suspender",
            inactivation: "Inactivar",
            reactivation: "Reactivar",
            approve: "Aprobar",
            reactivation_date: "Fecha de Reactivación",
            inactivation_date: "Fecha de Inactivación",
            suspension_date: "Fecha de Suspensión",
            approval_date: "Fecha de Aprobación",
            situation: "Situación",
            confirm: {
              title: "¿Eliminar Pagador?",
              description: "Esto eliminará permanentemente al Pagador",
            },
            errors: {
              situation: "La situación es obligatoria",
              individual_person: "La Persona Física es obligatoria",
              legal_entity: "La Persona Jurídica es obligatoria",
              address_type: "El tipo de dirección es obligatorio",
              payer_title: "El título  es obligatorio",
              biling_method: "El método de facturación es obligatorio",
              initial_date: "La fecha inicial es obligatoria",
              date: "La fecha de finalización debe ser mayor que la fecha de inicio",
              end_date: "La fecha final es obligatoria",
              monthly_payment_due_date: "El día de pago es obligatorio",
            },
          },
          salesContractSubStipulant: {
            title: "Subestipulante",
            search: "Buscar por subestipulante",
            add: "Agregar Subestipulante",
            new: "Nuevo Subestipulante",
            legal_entity: "Persona Jurídica",
            individual_person: "Persona Física",
            code: "Código",
            active: "Activo",
            inactive: "Inactivo",
            suspension: "Suspender",
            inactivation: "Inactivar",
            reactivation: "Reactivar",
            approve: "Aprobar",
            reactivation_date: "Fecha de Reactivación",
            inactivation_date: "Fecha de Inactivación",
            suspension_date: "Fecha de Suspensión",
            approval_date: "Fecha de Aprobación",
            situation: "Situación",
            confirm: {
              title: "¿Eliminar Subestipulante?",
              description: "Esto eliminará permanentemente el Subestipulante",
            },
            errors: {
              situation: "La situación es obligatoria",
              individual_person: "La Persona Física es obligatoria",
              legal_entity: "La Persona Jurídica es obligatoria",
            },
          },
          salesContractHcpInclusionRule: {
            title: "Programas de Salud - Inclusión Automática",
            search: "Buscar una regla de Inclusión Automática",
            add: "Agregar Regla de Inclusión Automática",
            enable: "Habilitar",
            status: "Estado",
            active: "Activo",
            inactive: "Inactivo",
            initial_date: "Fecha Inicial",
            health_program: "Programa de Salud",
            end_date: "Fecha Final",
            confirm: {
              title: "¿Eliminar Regla de Inclusión Automática?",
              description:
                "Esto eliminará permanentemente la Regla de Inclusión Automática",
            },
            errors: {
              initial_date: "La fecha inicial es obligatoria",
              end_date: "La fecha final es obligatoria",
              date: "La fecha final debe ser mayor que la fecha inicial",
              health_program: "El programa de salud es obligatorio",
            },
          },
          salesContractProducts: {
            title: "Producto",
            add: "Agregar Producto",
            new: "Nuevo Producto",
            code: "Código",
            name: "Nombre",
            product: "Producto",
            price_list: "Lista de Precios",
            price_list_product: "Listas de Precios",
            confirm: {
              title: "¿Eliminar Producto?",
              description: "Esto eliminará permanentemente el Producto",
            },
            errors: {
              product: "El producto es obligatorio",
              price_list: "La lista de precios es obligatoria",
            },
          },
          salesContractPriceList: {
            title: "Listas de Precios",
            price_list: "Lista de Precio",
            search: "Buscar por lista de precios",
            add: "Agregar Lista de Precios",
            name: "Nombre",
            initial_date: "Fecha Inicial",
            end_date: "Fecha Final",
            approval_date: "Fecha de Aprobación",
            approve: "Aprobar",
            code: "Código",
            new_price_list: "Nueva Lista de Precios",
            add_new_item: "Agregar Nuevo Ítem",
            degree_of_entitlement: "Grado de Propiedad",
            initial_age: "Edad Inicial",
            end_age: "Edad Final",
            items: "Ítems",
            price: "Precio",
            confirm: {
              title: "¿Eliminar Lista de Precios?",
              description: "Esto eliminará permanentemente la Lista de Precios",
            },
            errors: {
              name: "El nombre es obligatorio",
              initial_date: "La fecha inicial es obligatoria",
              end_date: "La fecha final es obligatoria",
              code: "El código es obligatorio",
              price: "El precio es obligatorio",
              degree_of_entitlement: "El grado de elegibilidad es obligatorio",
              date: "La fecha de finalización debe ser mayor que la fecha de inicio",
              age: "La edad final debe ser mayor que la edad inicial",
              sales_contract_price_list_items:
                "Al menos un ítem es obligatorio",
            },
          },
          salesSeller: {
            title: "Vendedor",
            title_seller: "Título del Vendedor",
            search: "Buscar Vendedor",
            add: "Agregar Vendedor",
            new: "Nuevo Vendedor",
            code: "Código",
            individual: "Individual",
            active: "Activo",
            inactive: "Inactivo",
            suspension: "Suspender",
            inactivation: "Inactivar",
            reactivation: "Reactivar",
            approve: "Aprobar",
            suspended: "Suspendido",
            approved: "Aprobado",
            reactivation_date: "Fecha de Reactivación",
            inactivation_date: "Fecha de Inactivación",
            suspension_date: "Fecha de Suspensión",
            approval_date: "Fecha de Aprobación",
            situation: "Situación",
            confirm: {
              title: "¿Eliminar vendedor?",
              description: "Esto eliminará permanentemente al vendedor",
            },
            errors: {
              title: "El título del vendedor es obligatorio",
              situation: "La situación es obligatoria",
              individual: "El individuo es obligatorio",
            },
          },
          contractProducts: {
            tabs: {
              products: "Productos",
              price: "Precio",
              history: "Historial",
              priceList: "Listas de Precios",
            },
            products: {
              title: "Productos",
              product: "Producto",
              situation: "Situación",
              search: "Buscar Productos",
              new_product: "Nuevo Producto",
              add: "Agregar Producto",
              contract_title: "Título del Contrato",
              name: "Nombre",
              active: "Activo",
              inactive: "Inactivo",
              approved: "Aprobado",
              canceled: "Cancelado",
              suspended: "Suspendido",
              reactivation_date: "Fecha de Reactivación",
              inactivation_date: "Fecha de Inactivación",
              suspension_date: "Fecha de Suspensión",
              approval_date: "Fecha de Aprobación",
              cancelation_date: "Fecha de cancelación",
              suspension: "Suspender",
              inactivation: "Inactivo",
              reactivation: "Reactivar",
              approve: "Aprobar",
              cancelation: "Cancelar",
              fantasy_name: "Nombre Fantasía",
              sales_contract_type: "Tipo de Contrato",
              integration_code: "Código de Integración",
              sales_product_ctr_classification: "Clasificación del Producto",
              sales_grantors: "Otorgantes",
              code: "Código",
              confirm: {
                title: "¿Eliminar producto?",
                description: "Esto eliminará permanentemente el producto",
              },
              errors: {
                name: "El nombre es obligatorio",
                fantasy_name: "El nombre fantasía es obligatorio",
                sales_grantors: "Al menos un otorgante es obligatorio",
                sales_product_ctr_classification:
                  "La clasificación del producto es obligatoria",
                sales_contract_type: "El tipo de contrato es obligatorio",
              },
            },
          },
          salesProductCtrPriceList: {
            title: "Listas de Precios",
            price_list: "Lista de Precio",
            search: "Buscar por lista de precios",
            add: "Agregar Lista de Precios",
            name: "Nombre",
            initial_date: "Fecha Inicial",
            end_date: "Fecha Final",
            approval_date: "Fecha de Aprobación",
            approve: "Aprobar",
            code: "Código",
            new_price_list: "Nueva Lista de Precios",
            add_new_item: "Agregar Nuevo Ítem",
            degree_of_entitlement: "Grado de Propiedad",
            initial_age: "Edad Inicial",
            end_age: "Edad Final",
            items: "Ítems",
            price: "Precio",
            confirm: {
              title: "¿Eliminar Lista de Precios?",
              description: "Esto eliminará permanentemente la Lista de Precios",
            },
            errors: {
              name: "El nombre es obligatorio",
              initial_date: "La fecha inicial es obligatoria",
              end_date: "La fecha final es obligatoria",
              code: "El código es obligatorio",
              price: "El precio es obligatorio",
              degree_of_entitlement: "El grado de elegibilidad es obligatorio",
              date: "La fecha de finalización debe ser mayor que la fecha de inicio",
              age: "La edad final debe ser mayor que la edad inicial",
              sales_product_ctr_price_list_items:
                "Al menos un ítem es obligatorio",
            },
          },
          salesProductCtrHistories: {
            title: "Historia",
            search: "Buscar Historia",
            add: "Agregar Historia",
            contract_title: "Historia",
            new_history: "Nueva Historia",
            titleForm: "Título",
            history: "Historia",
            approval_date: "Fecha de Aprobación",
            history_date: "Fecha de Historia",
            approve: "Aprobar",
            confirm: {
              title: "¿Eliminar Historia?",
              description: "Esto eliminará permanentemente la Historia",
            },
            errors: {
              title: "El Titulo es obligatorio",
              history: "El História es obligatorio",
              historyDate: "La Fecha de Historia es obligatorio",
            },
          },
          beneficiaryTerminationReasons: {
            title: "Motivo de Terminación de Beneficiarios",
            search: "Buscar Motivo de Terminación de Beneficiarios",
            add: "Agregar Motivo de Terminación de Beneficiarios",
            new: "Nuevo Motivo de Terminación de Beneficiarios",
            name: "Nombre",
            status: "Estado",
            active: "Activo",
            code: "Código",
            inactive: "Inactivo",
            enabled: "Permitir",
            confirm: {
              title: "¿Eliminar motivo de terminación de beneficiarios?",
              description:
                "Esto eliminará permanentemente el motivo de terminación de beneficiarios",
            },
            errors: {
              name: "El Nombre es obligatorio",
            },
          },
          beneficiaryCancellationsReason: {
            title: "Motivo de Cancelación del Beneficiario",
            search: "Buscar por Motivo de Cancelación del Beneficiario",
            add: "Agregar Motivo de Cancelación del Beneficiario",
            new: "Nuevo Motivo de Cancelación del Beneficiario",
            name: "Nombre",
            status: "Estado",
            code: "Código",
            inactive: "Inactivo",
            active: "Activo",
            enable: "Permitir",
            confirm: {
              title: "¿Eliminar el motivo de cancelación del beneficiario?",
              description:
                "Esto eliminará permanentemente el motivo de cancelación del beneficiario",
            },
            errors: {
              name: "El nombre es obligatorio",
            },
          },
          beneficiarySuspensionsReason: {
            title: "Motivo de Suspensión del Beneficiario",
            search: "Buscar por Motivo de Suspensión del Beneficiario",
            add: "Agregar Motivo de Suspensión del Beneficiario",
            new: "Nuevo Motivo de Suspensión del Beneficiario",
            enable: "Permitir",
            code: "Código",
            name: "Nombre",
            status: "Estado",
            active: "Activo",
            inactive: "Inactivo",
            confirm: {
              title: "¿Eliminar el motivo de suspensión del beneficiario?",
              description:
                "Esto eliminará permanentemente el motivo de suspensión del beneficiario",
            },
            errors: {
              name: "El nombre es obligatorio",
            },
          },
        },
      },
      assessments: {
        questions: {
          questions: "Preguntas",
          question: "Pregunta",
          new_question: "Nueva pregunta",
          add_question: "Adicionar questão",
          always_visible:
            "Mantener la justificación/comentario siempre visible para el respondiente",
          search: "Buscar una pregunta",
          question_evaluation_type: "Tipo de evaluación de pregunta",
          integration_id: "Id de integración",
          title: "Título",
          description: "Descripción",
          is_required: "Respuesta Obligatoria",
          min_chars: "Mínimo de Caracteres",
          question_category: "Categoría de pregunta",
          created: "Fecha de creación",
          required_justification: "Requerir/obligar justificación",
          required_justification_less_than:
            "Requerir justificación a continuación",
          required_justification_options:
            "Requerir justificación para estas alternativas (separadas por comas)",
          required_justification_options_tooltip:
            "Requerir justificación para las alternativas siguientes según el campo `Valor de referencia` (valores separados por comas)",
          alternatives_integration_id_tooltip:
            "En Tasy, configure el Id de integración de cada alternativa con dos dígitos (01, 02, 03...), en el mismo orden que las opciones.",
          required_justification_min_chars: "Número mínimo de caracteres",
          required_justification_message: "Texto de justificación",
          guidance_text_position: "Mostrar texto de orientación:",
          guidance_text: "Texto de orientación:",
          category: {
            label: "Categoría",
            no_options_text: "No hay categorías seleccionadas",
            options_button_label: "Buscar categoría",
            drawer_props: {
              title: "Selecciona categoría",
              search_placeholder: "Buscar categorías",
              create_button_label: "Crear categoría",
              apply_button_label: "Aplicar categoría",
              input_label: "Nombre de la categoría",
              delete_confirm: {
                title: "Eliminar categoría",
                message:
                  "Esto eliminará la categoría y todas las categorías relacionadas.",
              },
            },
          },
          confirm: {
            title: "¿Eliminar la pregunta?",
            description: "Esto eliminará permanentemente la pregunta",
          },
          errors: {
            integration_id: "El id de integración es obligatorio",
            title: "El título es obligatorio",
            description: "La descripción es obligatoria",
            question_evaluation_type:
              "El tipo de evaluación de pregunta es obligatorio",
            question_category: "La categoría de pregunta es obligatoria",
            required_justification_less_than:
              "El 'requerir justificación a continuación' es obligatorio",
            required_justification_options:
              "Introduzca los valores de referencia separados por comas",
            required_justification_min_chars:
              "El número mínimo de caracteres es obligatorio",
            required_justification_message:
              "El texto de justificación es obligatorio",
            min_chars: "El número mínimo de caracteres es obligatorio",
          },
        },
      },
      logs: {
        dateRange: {
          title: "Rango de fechas",
          today: "Hoy",
          this_week: "Esta semana",
          this_month: "Este mes",
          last_month: "Mes anterior",
          last_30_days: "Últimos 30 días",
          last_6_months: "Últimos 6 meses",
          select_period: "Seleccionar período",
          filterBy: "Filtrar por",
        },
        healthChecks: {
          health_checks: "Health Checks",
          name: "Nombre",
          data: "Datos",
          start_date: "Fecha Inicial",
          end_date: "Fecha Final",
          created: "Fecha de creación",
          search: "Buscar un registro de controles de salud",
        },
        logRegisterError: {
          errorMessage: "Mensaje de error",
          document: "Documento",
          title: "Errores de registro",
          created: "Fecha",
          start_date: "Fecha Inicial",
          end_date: "Fecha Final",
          confirm: {
            confirm: {
              title: "Eliminar registro de errores?",
              description: "Esto eliminará permanentemente el registro",
            },
          },
          placeholder: "Buscar algunos CPF",
        },
      },
      evaluation: {
        forms: {
          forms: "Formularios",
          form: "Formulario",
          new_form: "Nuevo formulario",
          search: "Buscar un formulario",
          add_form: "Añadir formulario",
          type_form: "Tipo de Formulario",
          answered_form: "Forma de iniciar el llenado de las respuestas",
          layout_form: "Forma de Presentación",
          title: "Título",
          description: "Descripción",
          show_link_on_end:
            "Ofrecer link de evaluación para promotores del NPS",
          show_link_greater_than: "Nota minima",
          response_time_limit_hours: "Limitar el tiempo de respuesta en horas",
          show_link_link: "Link",
          show_link_description: "Texto de compromiso",
          show_link_button_label: "Etiqueta del botón",
          status: "Status",
          active: "Atcivo",
          inactive: "Inactivo",
          release_status: "Estado de liberación",
          awaiting_release: "Pendiente de liberación",
          released: "Liberado",
          release_form: "Liberar Formulario",
          undo_release: "Deshacer Liberación",
          clone_form: "Clonar Formulario",
          cancel_action: "Cancelar",
          continue_action: "Continuar",
          release_requires_question:
            "El formulario debe tener al menos una pregunta antes de ser liberado.",
          released_form_warning:
            "Este formulario fue liberado. Solo se pueden editar el título y el estado.",
          locked_question_warning:
            "Esta pregunta está vinculada a un formulario liberado y no se puede editar ni eliminar.",
          release_confirm: {
            title: "¿Liberar formulario?",
            description:
              "Al liberar, el formulario y las preguntas vinculadas se bloquearán para edición. ¿Desea continuar?",
          },
          clone_confirm: {
            title: "¿Clonar formulario?",
            description:
              "Se clonará el formulario y todas las preguntas vinculadas. ¿Desea continuar?",
          },
          extension: "Aplicación/Site/App",
          initial_date: "Inicio del trimestre",
          end_date: "Fin de validez",
          domains: {
            domains: "Dominios",
            tooltip:
              "Copie el link para compartir formulario para usarlo en plantillas",
            copied_successfully: "Link copiado exitosamente",
          },
          select_questions: {
            questions: "Preguntas",
            display_order: "Orden",
            title: "Título",
            type: "Tipo",
            add_button: "Añadir preguntas",
            modal_title: "Seleccionar preguntas",
            modal_add_button: "Añadir preguntas",
            modal_remove_button: "Eliminar preguntas",
            search: "Buscar preguntas",
          },
          confirm: {
            title: "¿Eliminar el formulario?",
            description: "Esto eliminará permanentemente el formulario",
          },
          errors: {
            type: "El tipo es obligatorio",
            title: "El título es obligatorio",
            site_app_extension: "La aplicación/site/app es obligatoria",
            initial_date: "La fecha de inicio del trimestre es obligatoria",
            end_date: "La fecha de fin de validez es obligatoria",
            bigger_date:
              "La fecha de inicio del trimestre no puede ser mayor que la fecha de fin de validez",
            description: "La descripción es obligatoria",
            questions: "Al menos una pregunta es obligatoria",
            order: "La orden debe ser mayor o igual a 1",
            duplicate_order: "No se permiten pedidos duplicados",
            visual_description: "La descripción visual es obligatoria",
            response_time_limit_hours:
              "Ingrese un número entero mayor que cero",
            show_link_greater_than: "La nota minima es obligatoria",
            show_link_link: "El link es obligatorio",
            show_link_description: "El texto de compromiso es obligatorio",
            show_link_button_label: "La etiqueta del botón es obligatoria",
            layoutForm: "La forma de presentación es obligatoria",
            answeredForm:
              "La forma de iniciar el llenado de las respuestas es obligatoria",
            typeForm: "El tipo de formulario es obligatorio",
          },
        },
        logs: {
          id: "Id da pesquisa",
          title: "Registros de integración",
          evaluationForm: "Forma",
          ticket: "Ticket (tarjeta)",
          start_date: "Fecha Inicial",
          end_date: "Fecha Final",
          attempts: "Intentos",
          shippingDate: "Fecha de Envío",
          answerDate: "Fecha de respuesta",
          encounterIntegrationId: "Número de servicio",
          errorMessage: "Mensaje de error",
          copy: "copiar",
          copied_successfully:
            "El enlace de la encuesta se copió correctamente",
          ticketChannel: "Cuadro",
          ticketMembers: "Miembros de ticket",
          externalUrl: "URL externo",
        },
      },
      "4uDonation": {
        donors: {
          title: "Donantes",
          name: "Nombre",
          search: "Buscar un donante",
          add: "Agregar Donante",
          new: "Nuevo Donante",
          donor: "Donante",
          document: "Documento",
          new_donor: "Nuevo Donante",
          donor_code: "Código del Donante",
          whatsapp_contacts: "Contactos de WhatsApp",
          donor_integration_id: "ID de Integración del Donante",
          attendant_integration_id: "ID de Integración del Atendente",
          attendant: "Atendente",
          confirm: {
            title: "¿Eliminar Donante?",
            description: "Esto eliminará permanentemente al donante",
          },
          form: {
            name: "Nombre",
            document: {
              cpf: "CPF",
              cnpj: "CNPJ",
            },
            entityType: "Entidad",
            individual_person: "Persona Física",
            legal_entity: "Persona Jurídica",
            birth_date: "Fecha de Nacimiento",
            incorporation_date: "Fecha de Constitución",
            donor_type: "Entidad Donante",
            gender: "Género",
            contacts: "Contactos",
            new_contact: "Nuevo Contacto",
            addresses: "Direcciones",
            new_address: "Nueva Dirección",
            contact_type: "Tipo de Contacto",
            ddi: "DDI",
            contact_number: "Número de Contacto",
            integration_id: "ID de Integración",
            attendant: "Atendente",
            attendant_secondary: "Atendente Secundario",
            user_integration_type: "Tipo de Integración del Usuario",
            errors: {
              name: "El nombre es obligatorio",
              document: "El documento es obligatorio",
              user_integration_type:
                "El tipo de integración del usuario es obligatorio",
              value: "Ingrese un número de teléfono",
              zipCode: "Ingrese un código postal válido",
              addressDescription: "Ingrese la calle",
              number: "Ingrese el número",
              addressTypeId: "Seleccione el tipo de dirección",
            },
          },
        },
      },
      "4uDlist": {
        listClassification: {
          title: "Clasificaciones",
          list_classification: "Clasificación de Lista",
          search: "Buscar clasificación de lista",
          add: "Añadir Clasificación de Lista",
          new: "Nueva Clasificación de Lista",
          name: "Nombre",
          description: "Descripción",
          enable: "Permitir",
          copy: "Copiar Código",
          copied: "Código copiado",
          code: "Código",
          status: "Status",
          active: "Activo",
          inactive: "Inactivo",
          confirm: {
            title: "¿Eliminar la clasificación de lista?",
            description:
              "Esto eliminará permanentemente la clasificación de lista",
          },
          errors: {
            name: "El nombre es obligatorio",
          },
        },
        listCategory: {
          title: "Categorías",
          list_category: "Categoría de Lista",
          search: "Buscar categoría de lista",
          add: "Añadir Categoría de Lista",
          new: "Nueva Categoría de Lista",
          name: "Nombre",
          description: "Descripción",
          enable: "Permitir",
          status: "Status",
          active: "Activo",
          inactive: "Inactivo",
          confirm: {
            title: "¿Eliminar la categoría de lista?",
            description: "Esto eliminará permanentemente la categoría de lista",
          },
          errors: {
            name: "El nombre es obligatorio",
          },
        },
        listFiles: {
          title: "Importación de Listas",
          list_file: "Archivo de listas",
          search: "Buscar por un archivo de lista",
          add: "Añadir Archivo de Lista",
          new: "Nuevo Archivo de Lista",
          purposes: "Objetivos",
          list_classification: "Clasificación",
          import_origin: "Origen de la Importación",
          import_api_status: "Estado de la API",
          define: "Cambiar el Estado de la API a Definitivo",
          integration_type: "Sistema de origen del dato",
          download: "Descargar Plantilla",
          model_file_name: "modelo_de_archivo_de_listas",
          file: "Archivo",
          file_caption: "Solo archivo .xls o .xlsx",
          name: "Nombre",
          code: "Código",
          import_status: "Estado de Importación",
          total: "Total",
          with_error: "Error",
          with_alert: "Alerta",
          converted: "Convertidos",
          description: "Descripción",
          status: "Status",
          active: "Activo",
          inactive: "Inactivo",
          list_contacts: "Lista de Contactos",
          convertToList: {
            name: "Nombre",
            description: "Descripción",
            status: "Estado",
            active: "Activo",
            inactive: "Inactivo",
            convert_to_new_list: "Convertir en nueva Lista",
            add_to_existing_list: "Agregar a lista existente",
            convert: "Convertir",
            converted: "¡Lista convertida con éxito!",
            search: "Buscar Lista",
            select_existing_list: "Seleccionar Lista Existente",
            select_list: "Seleccionar Lista",
            cancel: "Cancelar",
            createList: {
              title: "Lista",
              new: "Nueva Lista",
              name: "Nombre",
              description: "Descripción",
              list_categories: "Categorías de Lista",
              list_classifications: "Clasificaciones de Lista",
              integration_type: "Tipo de Integración",
              enable: "Habilitar",
            },
          },
          errors: {
            purposes: "Al menos un objetivo es obligatorio",
            file: "El archivo es obligatorio",
            list_classification: "La clasificación es obligatoria",
          },
        },
        listImportAutomation: {
          title: "Automatización para Generar Listas de Distribución",
          list_import_automation: "Automatización de Importación de Listas",
          search: "Buscar automatización de importación de listas",
          add: "Agregar Automatización de Importación de Listas",
          new: "Nueva Automatización de Importación de Listas",
          active: "Activo",
          enabled: "Sí",
          disabled: "No",
          enable: "Habilitar",
          name: "Nombre",
          initial_date: "Fecha de inicio",
          end_date: "Fecha de finalización",
          description: "Descripción",
          created_successfully:
            "Automatización de Importación de Listas creada con éxito",
          classifications: "Clasificaciones",
          dlist_classifications: {
            search: "Buscar por clasificación",
            add_classification: "Agregar Clasificación",
            list_classification: "Clasificación",
            title: "Clasificación",
            new: "Nueva Clasificación",
            confirm: {
              title: "¿Eliminar la Clasificación?",
              description: "Esto eliminará permanentemente la Clasificación",
            },
            errors: {
              list_classification: "La clasificación es obligatoria",
            },
          },
          confirm: {
            title: "¿Eliminar la automatización de importación de listas?",
            description:
              "Esto eliminará permanentemente la automatización de importación de listas",
          },
          errors: {
            name: "El nombre es obligatorio",
            initial_date: "La fecha de inicio es obligatoria",
            end_date: "La fecha de finalización es obligatoria",
            end_date_less:
              "La fecha de finalización no puede ser anterior a la de inicio",
          },
        },
        list: {
          title: "Listas De Distribuición",
          list: "Controle de Lista",
          search: "Buscar por un controle de lista",
          list_contacts: "Lista de Contactos",
          add: "Añadir Controle de Lista",
          new: "Nuevo Controle de Lista",
          name: "Nombre",
          integration_type: "Tipo de Integración",
          list_categories: "Categorías de Lista",
          list_classifications: "Clasificaciones de Lista",
          created_date: "Fecha de Creación",
          category: "Categoría",
          classification: "Clasificación",
          description: "Descripción",
          enable: "Permitir",
          status: "Status",
          active: "Activo",
          inactive: "Inactivo",
          confirm: {
            title: "¿Eliminar la campaña?",
            description: "Esto eliminará permanentemente la campaña",
          },
          errors: {
            name: "El nombre es obligatorio",
            name_max_length: "El nombre debe tener como máximo 255 caracteres",
            type: "El tipo es obligatorio",
            list_categories: "Al menos una categoría es obligatoria",
            list_classifications: "Al menos una clasificación es obligatoria",
            integration_type: "El tipo de integración es obligatorio",
          },
        },
        listContacts: {
          title: "Listado de Contactos",
          name: "Nombre",
          document: "Documento",
          mail: "Correo Electrónico",
          whatsapp_number: "WhatsApp",
          phone: "Número de Teléfono",
          search: "Buscar un contacto",
          contact_detail: "Detalles del Contacto",
          modal: {
            title: "Detalles del Contacto",
            address_city_name: "Ciudad",
            address_complement: "Complemento de Dirección",
            address_description: "Calle",
            address_neighborhood_name: "Barrio",
            address_number: "Número de Dirección",
            address_province_name: "Estado",
            address_zip_code: "Código Postal",
            attendant_integration_id: "Código de Integración del Atendente",
            beneficiary_integration_id:
              "Código de Integración del Beneficiario",
            code: "Código",
            date_of_birth: "Fecha de Nacimiento",
            document: "Documento",
            donor: "Donante",
            enable: "Activo",
            errors: "Errores",
            disable: "Inactivo",
            event_date: "Fecha del Evento",
            event_number_control: "Control de Número de Evento",
            facebook: "Facebook",
            instagram: "Instagram",
            linkedin: "LinkedIn",
            list_import_batch: "Archivo",
            list_import_contact_status: "Estado",
            mail: "Correo Electrónico",
            name: "Nombre",
            occurrence_date: "Fecha de Ocurrencia",
            person_integration_id: "Código de Integración de Persona",
            phone: "Teléfono",
            telegram_number: "Número de Telegram",
            trigger_date: "Fecha de Disparo",
            trigger_priority: "Prioridad de Disparo",
            whats_app_number: "Número de WhatsApp",
            is_deleted: "Estado",
            warnings: "Avisos",
            donor_integration_id: "Código de Integración de Donante",
            list: "Nombre de la Lista",
            main_message: "Mensaje principal",
            subject: "Sujeto",
            comment: "Comentario",
            alert: "Alerta",
            orientation: "Orientación",
          },
        },
        generationRule: {
          generation_rules: "Reglas de Generación",
          generation_rule: "Regla de Generación",
          search: "Buscar reglas de generación",
          add_generation_rule: "Agregar Regla de Generación",
          new_generation_rule: "Nueva Regla de Generación",
          name: "Nombre",
          data_origin: "Origen de los Datos",
          created_successfully: "¡Regla de generación creada con éxito!",
          individual_title: "Persona Física",
          employee_title: "Empleado",
          doctor_title: "Médico",
          beneficiary_title: "Beneficiario",
          schedule_title: "Agendas",
          service_period_title: "Período de Atención",
          individual: {
            individuals: "Personas Físicas",
            individual: "Persona Física",
            search: "Buscar persona física",
            add_individual: "Agregar Persona Física",
            new_individual: "Nueva Persona Física",
            sex: "Sexo",
            age: "Edad",
            confirm: {
              title: "¿Eliminar la persona física?",
              description: "Esto eliminará permanentemente la persona física",
            },
            errors: {
              sex: "El sexo es obligatorio",
              age: "La edad es obligatoria",
            },
          },
          employee: {
            employees: "Empleados",
            employee: "Empleado",
            search: "Buscar empleado",
            add_employee: "Agregar Empleado",
            new_employee: "Nuevo Empleado",
            sector: "Sector",
            confirm: {
              title: "¿Eliminar el empleado?",
              description: "Esto eliminará permanentemente el empleado",
            },
            errors: {
              sector: "El sector es obligatorio",
            },
          },
          doctor: {
            doctors: "Médicos",
            doctor: "Médico",
            search: "Buscar médico",
            add_doctor: "Agregar Médico",
            new_doctor: "Nuevo Médico",
            sector: "Sector",
            confirm: {
              title: "¿Eliminar el médico?",
              description: "Esto eliminará permanentemente el médico",
            },
            errors: {
              sector: "El sector es obligatorio",
            },
          },
          beneficiary: {
            beneficiaries: "Beneficiarios",
            beneficiary: "Beneficiario",
            search: "Buscar beneficiario",
            add_beneficiary: "Agregar Beneficiario",
            new_beneficiary: "Nuevo Beneficiario",
            ownership: "Titularidad",
            confirm: {
              title: "¿Eliminar el beneficiario?",
              description: "Esto eliminará permanentemente el beneficiario",
            },
          },
          schedule: {
            schedules: "Agendas",
            schedule: "Agenda",
            search: "Buscar agenda",
            add_schedule: "Agregar Agenda",
            new_schedule: "Nueva Agenda",
            identifier: "Identificador",
            confirm: {
              title: "¿Eliminar la agenda?",
              description: "Esto eliminará permanentemente la agenda",
            },
            errors: {
              identifier: "El identificador es obligatorio",
            },
          },
          servicePeriod: {
            service_periods: "Períodos de Atención",
            service_period: "Período de Atención",
            search: "Buscar período de atención",
            add_service_period: "Agregar Período de Atención",
            new_service_period: "Nuevo Período de Atención",
            start_date: "Fecha de Inicio",
            end_date: "Fecha de Fin",
            service_types: "Tipos de Atención",
            confirm: {
              title: "¿Eliminar el período de atención?",
              description:
                "Esto eliminará permanentemente el período de atención",
            },
            errors: {
              start_date: "La fecha de inicio es obligatoria",
              end_date: "La fecha de fin es obligatoria",
              service_type: "Seleccione al menos un tipo de atención",
            },
          },
          confirm: {
            title: "¿Eliminar la regla de generación?",
            description:
              "Esto eliminará permanentemente la regla de generación",
          },
          errors: {
            name: "El nombre es obligatorio",
            data_origin: "El origen de los datos es obligatorio",
          },
        },
        listGeneration: {
          lists_generation: "Generación de Listas",
          list_generation: "Generación de Lista",
          search: "Buscar generación de lista",
          add_list_generation: "Agregar Generación de Lista",
          new_list_generation: "Nueva Generación de Lista",
          generate_list: "Generar Lista",
          generated_successfully: "¡Lista generada com éxito!",
          name: "Nombre",
          generation_rule: "Regla de Generación",
          confirm: {
            title: "¿Eliminar la generación de lista?",
            description:
              "Esto eliminará permanentemente la generación de lista",
          },
          errors: {
            name: "El nombre es obligatorio",
            generation_rule: "La regla de generación es obligatoria",
          },
        },
      },
      "4uMarCom": {
        campaigns: {
          title: "Inscripciones de Campaña",
          campaign: "Campaña",
          search: "Buscar campaña",
          add: "Añadir Campaña",
          new: "Nueva Campaña",
          name: "Nombre",
          description: "Descripción",
          type: "Tipo",
          enable: "Permitir",
          status: "Status",
          active: "Activo",
          inactive: "Inactivo",
          confirm: {
            title: "¿Eliminar la campaña?",
            description: "Esto eliminará permanentemente la campaña",
          },
          errors: {
            name: "El nombre es obligatorio",
            type: "El tipo es obligatorio",
          },
        },
        communicationPermissions: {
          title: "Permiso de Comunicación",
          communication_permissions: "Permiso de Comunicación",
          search: "Buscar por permiso de comunicación",
          name: "Nombre",
          type: "Tipo",
          document: "Documento",
          birthOfDate: "Fecha de Nacimiento",
        },
        automationRules: {
          title: "Reglas de Automatización",
          automation_rule: "Reglas de Automatización",
          search: "Buscar reglas de automatización",
          add: "Agregar Regla de Automatización",
          new: "Nueva Regla de Automatización",
          created_by: "Creado por",
          name: "Nombre",
          enable: "Habilitar",
          type: "Tipo",
          status: "Estado",
          active: "Activo",
          inactive: "Inactivo",
          distribution_list: "Lista de Distribución",
          classifications: "Clasificaciones",
          categories: "Categorías",
          time_rule: "Regla de Tiempo",
          messages: "Mensajes",
          send_service: "Servicio de Envío",
          marcom_type: "Tipo de MarCom",
          send_ype: "Tipo de Envío",
          campaign: "Campaña",
          confirm: {
            title: "¿Eliminar la regla de automatización?",
            description:
              "Esto eliminará permanentemente la regla de automatización",
          },
          errors: {
            name: "El nombre es obligatorio",
            type: "El tipo es obligatorio",
            marcom_type: "El tipo de MarCom es obligatorio",
            send_type: "El tipo de envío es obligatorio",
            campaign: "La campaña es obligatoria",
          },
          ticketautomationRules: {
            automation_rules: "Reglas de Automatización",
            automation_rule: "Regla de Automatización",
            new_automation_rule: "Nueva regla de automatización",
            search: "Buscar una regla de automatización",
            add_automation_rule: "Añadir regla de automatización",
            name: "Nombre",
            automation: "Automatización",
            created_by: "Creado por",
            status: "Status",
            active: "Activo",
            inactive: "Inactivo",
            enable: "Permitir",
            event: "Evento",
            automation_message_ticket_defaul_doc: "Documento Predeterminado",
            automation_message_ticket_automation_template:
              "Plantilla después de la respuesta",
            automation_tasy_orientation: "Orientación Tasy",
            ticket_service: "Servicio de ticket(card)",
            action_after_24_hours: "Acción después de 24 horas",
            select_action_after_24_hours:
              "Seleccione la acción después de 24 horas",
            restart_conversation: "Reinicio de conversación",
            new_contact_attempt: "Nuevo intento",
            both: "Ambos",
            no_action: "Sin acción",
            initial_date: "Data de inicio",
            end_date: "Data de fin",
            whatsapp_template: "Template de WhatsApp",
            robot: "Robot",
            attendant: "Atendente",
            pendent: "Envío Pendiente",
            when_error: "Cuando hay un error al iniciar template",
            when_blacklist: "Cuando el contacto esté en la blacklist",
            board: "Tablero",
            list: "Lista",
            time_rule: "Regla de tiempo",
            automation_message: "Mensaje de automatización",
            messages: "Mensajes",
            created_successfully: "Regla de automatización creada con éxito",
            confirm: {
              title: "¿Eliminar la regla de automatización?",
              description:
                "Esto eliminará permanentemente la regla de automatización",
            },
            errors: {
              name: "El nombre es obligatorio",
              ticket_automation: "La automatización es obligatoria",
              ticket_event: "El evento es obligatorio",
              ticket_service: "El servicio de ticket(card) es obligatorio",
              initial_date: "La fecha de inicio es obligatoria",
              end_date: "La fecha de fin es obligatoria",
              ticket_automation_template:
                "El template de WhatsApp es obligatorio",
              ticket_channel_step_robot: "La lista del robot es obligatoria",
              ticket_channel_step_attendant:
                "La lista del atendente es obligatoria",
              ticket_channel_step_pendent:
                "La lista de envío pendiente es obligatoria",
              action_after_24_hours: "Seleccione la acción después de 24 horas",
              initial_date_bigger:
                "La fecha de inicio no puede ser mayor que la fecha de fin",
            },
          },
          marcom_categories: {
            title: "Categorías",
            new: "Nueva Categoría",
            list_category: "Categoría",
            add_category: "Agregar Categoría",
            search: "Buscar categoría",
            confirm: {
              title: "¿Eliminar la categoría?",
              description: "Esto eliminará permanentemente la categoría",
            },
            errors: { list_category: "La categoría es obligatoria" },
          },
          marcom_classifications: {
            title: "Clasificaciones",
            new: "Nueva Clasificación",
            list_classification: "Clasificación",
            add_classification: "Agregar Clasificación",
            search: "Buscar clasificación",
            confirm: {
              title: "¿Eliminar la clasificación?",
              description: "Esto eliminará permanentemente la clasificación",
            },
            errors: {
              list_classification: "La clasificación es obligatoria",
            },
          },
          marcom_distributionList: {
            title: "Lista de Distribución",
            new: "Nueva Lista de Distribución",
            list: "Lista",
            add_List: "Agregar Lista",
            search: "Buscar lista",
            confirm: {
              title: "¿Eliminar la lista?",
              description: "Esto eliminará permanentemente la lista",
            },
            errors: { list: "La lista es obligatoria" },
          },
          marcom_message: {
            message: "Mensaje",
            new_message: "Nuevo Mensaje",
            name: "Nombre",
            start_date: "Fecha de Inicio",
            end_date: "Fecha de Fin",
            status: "Estado",
            active: "Activo",
            inactive: "Inactivo",
            search: "Buscar mensaje",
            add_message: "Agregar Mensaje",
            enable: "Habilitar",
            exception: "Excepción",
            isMoveHumanAttendant: "Mover a agente (miembro) asignado",
            priority: "Prioridad",
            ticket_flow_pattern: "Patrón de flujo del ticket",
            opened_with_flow_direction: "Abierto con direccionamiento de flujo",
            finished_from_start: "Finalizado desde el inicio del disparo",
            ticket_channel: "Tablero",
            ticket_channel_step: "Lista",
            ticket_automation_received_rule: "Regla de Recepción",
            ticket_automation_received_rule_info:
              "Para el correcto funcionamiento se recomienda utilizar una plantilla con botones Sí/No",
            move_ticket_when_not_identified:
              "Mover cuando la respuesta no sea identificada",
            confirm: {
              title: "¿Eliminar el mensaje?",
              description: "Esto eliminará permanentemente el mensaje",
            },
            errors: {
              name: "El nombre es obligatorio",
              start_date: "La fecha de inicio es obligatoria",
              end_date: "La fecha de fin es obligatoria",
              ticket_channel: "El tablero es obligatorio",
              ticket_channel_step: "La lista es obligatoria",
              ticket_automation_received_rule:
                "La regla de recepción es obligatoria",
              ticket_channel_when_not_identified: "El tablero es obligatorio",
              ticket_channel_step_when_not_identified:
                "La lista es obligatoria",
            },
          },
          marcom_timerule: {
            time_rule: "Regla de Tiempo",
            new_time_rule: "Nueva Regla de Tiempo",
            time_classification: "Clasificación de Tiempo",
            type: "Tipo",
            value: "Valor",
            add_time_rule: "Agregar Regla de Tiempo",
            search: "Buscar regla de tiempo",
            confirm: {
              title: "¿Eliminar la regla de tiempo?",
              description: "Esto eliminará permanentemente la regla de tiempo",
            },
            errors: {
              time_classification: "La clasificación de tiempo es obligatoria",
              type: "El tipo es obligatorio",
              value: "El valor es obligatorio",
            },
          },
        },
      },
    },
    components: {
      usecopy: {
        copied_successfully: "Copiado con éxito",
        copied_error: "No se pudo copiar",
      },
      copyButton: {
        copy: "Copiar",
      },
      content: {
        contents: "Contenido",
        add_new_video: "Añadir video",
        add_new_content: "Añadir contenido",
        content_type: "Tipo de noticia",
        content_status: "Status de noticias",
        enable: "Permitir",
        reading_time: "Tiempo de leer",
        reading_time_info: "Tiempo en minutos",
        site_app: "Aplicaciones",
        title: "Título",
        language: "Idioma",
        language_tooltip: "Ver idioma",
        summary: "Resumen",
        publication_date: "Fecha de publicación",
        content_tags: "Tags de noticias",
        is_published: "Publicar",
        status: "Status",
        published: "Publicado",
        not_published: "No publicado",
        enabled: "Activo",
        inactive: "Inactivo",
        videos: "Videos",
        link: "Enlace",
        link_helper: "Agregar un enlace de YouTube",
        display_order: "Orden",
        highlight_end: "Destacado acabado en",
        highlight_start: "Destacado iniciado en",
        confirm: {
          title: "¿Borrar la noticia?",
          description: "Esto eliminará permanentemente la noticia",
        },
        errors: {
          reading_time: "El tiempo de leer es obligatorio",
          site_apps: "Al menos una aplicación es obligatorio",
          language: "El idioma es obligatorio",
          title: "El titulo es obligatorio",
          tags: "Al menos una tag de noticias es obligatoria",
          summary: "El resumen es obligatorio",
          content: "El contenido es obligatorio",
          contents: "Al menos un contenido es obligatorio",
          file: "El archivo es obligatorio",
          link: "El enlace no es válido.Agregue un enlace de YouTube",
          display_order: "La orden de visualización es obligatoria",
          highlight_end:
            "La fecha de finalización no puede ser mayor que la fecha de inicio",
        },
      },
      schedule: {
        selectAll: "Seleccionar todo",
        seeMore: "Ver más {{quantity}}",
        day: "Es",
        week: "Semana",
        month: "Mẽs",
        today: "Hoy",
        newSchedule: {
          required: "Campo obligatorio",
          date: "Datos",
          hour: "Tiempo",
          professional: "Profesional",
          type: "Tipo de programación",
          duration: "Duración",
          button: "Para programar",
          title: "Nuevo programación",
          confirm_contact_phone: "Confirme su teléfono de contacto",
          main_whatsapp_number: "Este es mi WhatsApp principal",
          phone_number: "Número de Teléfono",
          insurance: {
            add: "Agregar acuerdo",
            edit: "Editar acuerdo",
            validate: "Validez de la tarjeta",
            code: "Número de tarjeta",
            number: {
              label: "Número de tarjeta (opcional)",
              error: "El número es obligatorio",
            },
            validity: {
              label: "Validez de tarjeta (opcional)",
              error: "La validez es obligatoria",
            },
            individual: {
              label: "Paciente",
              error: "El paciente es obligatorio",
            },
            insurance: {
              label: "Seguro de salud",
              error: "El acuerdo es obligatorio",
            },
          },
        },
        menu: {
          source: {
            both: "Todo",
          },
          exams: "Pruebas",
          subtitle: {
            title: "Leyenda",
            someFree: "Hay gratis",
            full: "todosOcupados",
            allFree: "Todo gratis",
          },
          period: "período",
          situation: "Situación",
          both: "ambas",
          specialitys: "especialidades",
          professionals: {
            label: "Profesionales",
            noOptionsText: "No se encontró un profesional",
            loading: "Cargando...",
          },
        },

        schedulePopover: {
          copy: "copiarIdentificador",
          copyCardNumber: "Copiar número de tarjeta",
          insurance: "Seguro de salud",
          cancel: "Horario de cancelación",
          confirm: "Confirmar cancelación",
          cancelButton: "cancelar",
          justification: {
            label: "Justificación",
            placeholder: "Ingrese una justificación",
            error: "La justificación es obligatoria",
          },
          reason: {
            label: "Razón",
            placeholder: "Seleccione una razón",
            error: "La razón es obligatoria",
          },
          cancelDescription:
            "Cancelar consulta {{pacient}} con {{doctor}} en {{date}}",
        },
      },
      scheduleAssistant: {
        button: "Asistente de programación",
        insurance: {
          title: "Mis acuerdos",
          subtitle: "Administre sus acuerdos y los del grupo familiar",
          add: "Para agregar",
          individual: "Individual",
          insuranceName: "Acuerdo",
          cardNumber: "numero de tarjeta",
          cardValidity: "Validez",
          delete: {
            title: "Eliminar un acuerdo?",
            description: "¡Esta acción es permanente!",
            confirmationText: "Si, eliminar",
            cancellationText: "Cancelar",
          },
          addInsurance: {
            edit: "Editar acuerdo",
            add: "Agregar acuerdo",
            buttonSave: "Ahorrar",
            buttonEdit: "Para editar",
            number: {
              label: "Número de tarjeta (opcional)",
              error: "El número es obligatorio",
            },
            validity: {
              label: "Validez de tarjeta (opcional)",
              error: "La validez es obligatoria",
            },
            individual: {
              label: "Paciente",
              error: "El paciente es obligatorio",
            },
            insurance: {
              label: "Seguro de salud",
              error: "El acuerdo es obligatorio",
            },
          },
        },
        newSchedule: {
          success: "Programación registrada exitosa",
          sched: "Para programar",
          next: "próximo",
          back: "Volver",
          notAvaiableModal: {
            button: "De acuerdo",
            description:
              "El tiempo elegido ya no está disponible, seleccione otra vez.",
          },
          finish: "finalizar",
          steps: {
            patient: {
              title: "Seleccione al paciente",
              error: "El paciente es obligatorio",
            },
            insurance: {
              title: "Seleccione el Acuerdo",
              error: "El acuerdo es obligatorio",
            },
            search: {
              title: "Buscar una agenda",
              specialityError: "La especialidad es obligatoria",
              periodError: "El período es obligatorio",
              examError: "El examen es obligatorio",
            },
            schedule: {
              title: "Seleccione una fecha y hora",
              error: "El tiempo es obligatorio",
            },
            confirm: "confirmarDatos",
          },
          insurance: "Seguro de salud",
          addInsurance: "Agregar acuerdo",
          addFamilyGroup: "Agregar familiar",
          search: {
            from: "Desde",
            examGroup: "Examen",
            professional: "Profesional (opcional)",
            speciality: "Especialidad",
            type: "Tipo de programación",
            period: "Período",
          },
          schedule: {
            freeDays: "Días con fechas disponibles",
          },
          confirm: {
            descriptionSite: "Profesional",
            patient: "paciente",
            insurance: "Seguro de salud",
            schedule: "Planificación",
            confirm_contact_phone: "Confirme su teléfono de contacto",
            main_whatsapp_number: "Este es mi WhatsApp principal",
            phone_number: "Número de Teléfono",
          },
        },
      },
      panel: {
        add_dashboard: "Agregar tablero",
        select: "Seleccione y ordene el componentes",
        helper_text: "El tablero debe tener al menos un componente",
        no_data: "Sin datos",
        reviews: "reseñas",
        search_placeholder: "Buscar por um nombre",
        order: "Ordenación",
        name: "Nombre",
        value: "Valor",
        attendant: "Asistente",
        xAxis: "Horas",
        ticketChannelName: "Junta",
        count: "Cantidad",
        search: "Buscar por un componente",
        select_all: "Seleccionar todo",
        select_components: "Seleccione los componentes",
        next: "Siguiente",
        average_asc: "Grado Más Bajo",
        average_desc: "Grado Más Alto",
        view_comments: "Ver comentarios",
        comments: "Comentarios",
        delete_dashboard: {
          delete: "Deletar dashboard",
          title: "Deletar dashboard {{ name }}",
          description:
            "Esto eliminará permanentemente sus paneles y sus datos.",
          cancel: "Cancelar",
          confirm: "Si, eliminar",
        },
        not_found: "Panel no encontrado",
        no_dashboards:
          "No se encuentra el tablero, ¡agregue su primer tablero!",
        select_tooltip: "Seleccionar y ordenar componentes",
        filters: "Filtros:",
        filters_modal: {
          filters: "Filtros Aplicados",
          tooltip: "Ver filtros aplicados",
        },
        filter: {
          day: "Día",
          week: "Semana",
          month: "Mes",
          year: "Todavía",
        },
        helper: {
          title: "Información de datos del tablero",
          first:
            "Los datos de los tableros se actualizan automáticamente una vez al día, durante la madrugada, siempre considerando la información hasta el día anterior.",
          second:
            "<1>Diario:</1> muestra los datos de un solo día. La información del día actual estará disponible a partir de la madrugada siguiente.",
          third:
            "<1>Semanal:</1> considera la semana de lunes a domingo. La semana en curso se actualiza diariamente con los datos hasta el día anterior y se completa en la madrugada del lunes.",
          fourth:
            "<1>Mensual:</1> el mes en curso se actualiza diariamente con los datos hasta el día anterior y se completa en la madrugada del día 1 del mes siguiente.",
          fifth:
            "<1>Anual:</1> el año en curso se actualiza diariamente con los datos hasta el día anterior y se completa en la madrugada del 1 de enero.",
          sixth:
            "<1>Nuevos tableros y componentes:</1> al agregar un tablero o activar un componente, el historial de datos se procesa en segundo plano y puede tardar algunos minutos en mostrarse por completo.",
        },
        enable_component: {
          title: "Activar componente",
          title_all: "Activar todos los componentes",
          description:
            "Al activar este componente, todo su historial de datos se procesará en segundo plano. Esto puede tardar algunos minutos en mostrarse por completo en el tablero. ¿Desea continuar?",
          description_all:
            "Al activar los componentes, el historial de datos de cada uno se procesará en segundo plano. Esto puede tardar algunos minutos en mostrarse por completo en el tablero. ¿Desea continuar?",
          cancel: "Cancelar",
          confirm: "Sí, activar",
        },
      },
      selectBool: {
        true: "Verdadeiro",
        false: "Falso",
      },
      menu: {
        home: {
          home: "Inicio",
          begin: "Resumen",
          dashboard: "Dolor",
        },
        myDashboards: {
          myDashboards: "Dashboards",
          dashboards: "Configuración de KPI",
          view: "Paneles de KPI",
          executions: "Historial de ejecuciones",
          generateConfig: "Configuración de Dashboards",
        },
        reports: {
          reports: "Reportes",
          crm: "CRM",
          internal: "Internos",
        },
        people: {
          people: "Gente",
          individuals: "Persona Física",
          legalEntities: "Entidad Legal",
          individualValidations: "Validación de Registro PF",
        },
        registers: {
          beneficiaries: "Beneficiarios",
          doctors: "Medicos",
          userProfiles: "Perfiles de Usuario",
          client: "Cliente",
          templates: "Plantillas",
          integrations: "Integraciones",
          profile_roles: "Roles de Perfil",
          documents: "Términos y Políticas",
          holidays: "Vacaciones",
        },
        admSystem: {
          admSystem: "Adm. Sistema",
          users: "Usuarios",
          establishmentParams: "Parametros Generales",
          roles: "Perfil",
          establishments: "Establecimientos",
          aditionalSettings: {
            aditionalSettings: "Ajustes Adicionales",
            cardsTemplates: "Plantillas de Tarjetas",
          },
          companygroups: "Grupos Empresariales",
          companies: "Compañías",
          companyDigitalCertificates: "Certificados Digitales",
        },
        globals: {
          globals: "Global",
          languages: "Idiomas",
          menus: "Menús",
          generics: "Genérico",
          countries: "Países",
          extensions: "Extensiones",
          cities: "Ciudades",
          neighborhoods: "Barrios",
          provinces: "Estados",
          banks: "Bancos",
          jobs: "Jobs",
          paramsDefaultEstablishment: "Parámetros de Establecimiento Estándar",
        },
        menu_secondary_item: {
          modal_title: "En desarrollo",
          modal_content:
            "Seguimos trabajando en el desarrollo de esta pantalla, pronto tendremos novedades.",
        },
        secondary_menu: {
          suport: "Soporte",
          configs: "Configuraciones",
          extensions_store: "Tienda de extensiones",
        },
        applications: {
          applications: "Aplicaciones",
          register: "Registro",
        },
        "4uChatBot": {
          templates: {
            templates: "Templates",
            whatsapp: "WhatsApp",
          },
          createAutomations: {
            createAutomations: "Automatizaciones",
            automationRules: "Reglas de envío",
            receivedAutomationRules: "Reglas de Recepción",
          },
          fluxos: {
            fluxos: "Corrientes",
            serviceWhatsapp: "Servicio WhatsApp",
          },
          logs: {
            examManagementNotificationLog:
              "Notificaciones por Email de Informes",
            logs: "Logs",
            calendarControl: "Consulta de Horarios Disponibilizados",
            ticketsHistory: "Historial de tickets",
            examSchedulingAttachmentLog:
              "Log de Anexos de los Agendamientos de Exámenes",
          },
          registrationsAndRules: {
            registrationsAndRules: "Registros y Reglas",
            ticketServiceArea: "Vía de servício",
            ticketServiceDay: "Horario de atención",
            ticketServiceMessage: "Mensajes",
            blacklist: "Blacklist",
            ticketFinishReason: "Motivo de cierre de ticket",
            ticketChannelMemberAvailabilityPauseReason: "Razón de pausa",
            banList: "BanList",
            appointmentarrivalrule: "Horarios de Llegada de Agendas",
          },
        },
        "4uDonation": {
          donors: {
            donors: "Donantes",
            register: "Registrar Donantes",
          },
        },
        "4uTotem": {
          applications: {
            applications: "Aplicaciones",
            myTotens: "Mis Tótems",
          },
          register: {
            register: "Registro",
            totemDevices: "Dispositivos Tótem",
          },
        },
        evaluation: {
          evaluation: "Evaluaciones",
          questions: "Preguntas",
          evaluationForms: "Formularios",
          evaluationLogs: "Registros de integración",
          evaluationLogsTicket:
            "Registros de Encuesta de Satisfacción de Ticket",
          activeServiceSearchSurvey:
            "Registros de Encuesta de Búsqueda Activa de Servicio",
        },
        chatBot: {
          register: "Registro",
          ticket_service: "Servicios de tickets(cards)",
          service: "Servicio",
          ticket_service_area: "Vía de servício",
          ticket_protocol_rule: "Reglas de generación de protocolos",
          ticket_service_day: "Horario de atención",
          ticket_service_message: "Mensajes",
        },
        logs: {
          logs: "Logs",
          healthcheck: "Health Checks",
          logRegisterError: "Errores de registro",
        },
        settings: {
          system: {
            system: "Sistema",
            generalSettings: {
              generalSettings: "Ajustes globales",
              correios: "Correios",
              centralBank: "Banco central",
              geolocalization: "Geolocalización",
              certillion: "Certillion",
            },
            cache: "Cache",
            paramsDefaultEstablishment:
              "Parámetros de establecimiento estándar",
            executeSql: "Ejecutar SQL",
          },
          generalSettings: {
            generalSettings: "Configuración general",
            holidays: "Vacaciones",
            establishmentParams: "Parámetros de establecimiento",
            healthChecks: "Health Checks de Microservicios 4uHub",
          },
          applications: {
            applications: "Aplicaciones",
            cardsTemplates: "Plantillas de tarjetas",
          },
          crm: {
            crm: "CRM",
            chatBot: {
              chatBot: "ChatBot",
              ticketServiceArea: "Áreas de servicio",
              ticketServiceMessage: "Mensajes",
            },
            ticketProtocolRule: "Reglas de generación de protocolos",
            ticketService: "Servicio de tickets(cards)",
            ticketServiceDay: "Horario de atención",
            ticketAutoFinishRule: "Reglas de finalización de ticket(card)",
            ticketAutoTransferRule: "Reglas de transferencia de ticket(card)",
            ticketDefaultDocs: "Protocolos de Orientación Estándar",
            ticketDefaultDocCategories:
              "Categorías de Protocolos de Orientación Estándar",
            events: "Eventos",
            externalProcessType: "Tipos de Procesos Externos",
            quickAnswer: "Mensajes Rápidos",
            sendLimitMonths:
              "Límites de Envío Mensual (Presupuesto de la Empresa)",
            sendLimitDiaries:
              "Límites de Envío Diario (Permitido por WhatsApp)",
            ticketAutoInactivityRule: "Reglas de Inactividad de Ticket(Card)",
          },
          chatBot: {
            chatBot: "ChatBot",
            ticketServiceArea: "Áreas de servicio",
            ticketServiceMessage: "Mensajes",
            ticketServiceDay: "Horario de atención",
          },
          "4uChatBot": {
            templates: {
              templates: "Templates",
              whatsapp: "WhatsApp",
            },
          },
          hcp: {
            hcp: "4uHcP",
            healthProgramTypes: "Tipos de programas de salud",
            workGroupTypes: "Tipos de grupos de trabajo",
          },
          "4uBus": {
            "4uBus": "4uBus",
            ipm: {
              ipm: "IPM",
              generalSettings: "Configuración general",
            },
            globals: {
              globals: "Configuración general",
              sync: "Sincronización",
            },
            zscan: {
              zscan: "ZScan",
              examSendRule: "Regla de envío de exámene",
            },
            externalExamPrescription: {
              externalExamPrescription:
                "Generación de Prescripción de Solicitud de Examen Externo",
              rules: "Reglas de Generación de Recetas",
            },
          },
          "4uSched": {
            "4uSched": "4uSched",
            menuSchedulingPortalApp: "Menu de Agenda Portal y APP",
            tasyCalendar: {
              tasyCalendar: "Tasy - Consultas y exámenes",
              checkIn: "Check in",
              confirmation: "Confirmación de Agenda",
            },
          },
          "4uSiteApp": {
            "4uSiteApp": "4uSiteApp",
            digitalTriage: {
              digitalTriage: "Check-In de la Triage PA Digital",
              checkIn: "Check in",
            },
          },
        },
        "4uSiteApp": {
          applications: {
            applications: "Aplicaciones",
            register: "Registro",
            myApplications: "Mis aplicaciones",
          },
          communication: {
            communication: "Comunicación",
            banners: "Banners",
            notifications: "Notificaciones",
            news: "Noticias",
          },
          privacyAndSecurity: {
            privacyAndSecurity: "Seguridad y Privacidad",
            termsAndPolicies: "Términos y políticas",
            loginContents: "Contenido de Inicio de Sesión",
          },
          sac: {
            sac: "SAC y Defensor del Pueblo",
            faq: "FAQ",
          },
          consultationsAndLogs: {
            consultationsAndLogs: "Consulta y Logs",
            beneficiarySituation: "Situación del beneficiario",
          },
        },
        "4uHcP": {
          structure: {
            structure: "Estructura de programas",
            healthPrograms: "Programas de salud",
            workGroups: "Grupos de trabajo",
          },
          content: {
            content: "Contenido",
            contentRules: "Reglas de contenido",
          },
          captation: {
            captation: "Captura",
            captations: "Captaciones",
            imports: "Importar",
          },
        },
        "4ubus": {
          automations: {
            automations: "Automatizaciones",
            fileIntegration: "Integración de Archivos",
            zscanExamSendRule: "Reglas de Envío de Exámenes de ZScan",
            integrationRule: "Reglas de Integración",
          },
          register: {
            register: "Registro",
            accessTokens: "Tokens Externos",
            profileTasy: "Perfil Externo",
            services: "Servicios",
            accessTokens4uHub: "Tokens de 4uHub",
            profile4uhub: "Perfil – Bus de 4uHub",
          },
          setRelationships: {
            setRelationships: "Relaciones",
            ipm: "IPM x TASY",
            "4uHub": "Tasy - Call Center",
            tasyReceivePatientEncounters: "Tasy - Recibir Atenciones",
            zscanEvo: "ZScan Evo",
            invoiceLoweringTotvs: "Tasy > TOTVS - Baja de Títulos",
            relationshipGroup: "Tasy > RNDS - Inmunización SI-PNI",
            syncPhysicalPerson: "Sync Persona",
            tasyToTasy: "Tasy x Tasy",
            tasyOps: "Tasy OPS - (Execução Requisição)",
          },
          restriction: {
            restriction: "Restricciones",
            rule: "Cronograma",
          },
          logs: {
            logs: "Logs",
            tasyCalendar: "Calendario del Tasy",
            ipmxtasyinternal: "IPM - Recibir - IPM x Tasy (Interno)",
            tasyxipminternal: "IPM - Enviar - Tasy x IPM (Interno)",
            ipmtasy: "IPM - Recibir - IPM x Tasy",
            tasyipm: "IPM - Enviar - Tasy x IPM",
            monitoring: "Monitoreo sel servidor local",
            examFilesLogIntegration:
              "Tasy - Registro de integración de archivos",
            accessDbObjectErrors: "Error de acceso a objetos Tasy",
            nfeTotvs: "Tasy - TOTVS - NFE",
            syncPersons: "Sync - Datos de personas",
            forubusVaccine: "Tasy > RNDS - Inmunización SI-PNI",
            refund: "Reembolsos",
            invoiceServiceAgy: "Tasy > Invoice Service Agy",
            externalLogError: "LogError",
            patientEncounterPsTransferRequest:
              "Tasy EMR - Generar nueva Atención en PS, a partir de inelegibilidad de atención en PA",
            gerAcessoVisitControlPacient:
              "Tasy GerAcesso - Envío de Control de Acceso del Acompañante del Paciente",
            gerAcessoVisitControlVisitor:
              "Tasy GerAcesso - Envio de Control de Acceso del Visitante del Paciente",
            gerAcessoVisitControlSector:
              "Tasy GerAcesso - Envío de Control de Acceso del Visitante del Sector",
            invoiceLoweringTotvs: "Tasy > TOTVS - Baja de Títulos",
            tasyToTasyNonLabExamsAvailable:
              "Tasy <> Tasy - Exámenes No Laboratoriales (Disponibles)",
            tasyToTasyNonLabExamsReceived:
              "Tasy <> Tasy - Exámenes No Laboratoriales (Recibidos)",
            serviceReceived: "Tasy - Recibir Atenciones",
            tasyToTasyResultsNonLabAvailable:
              "Tasy <> Tasy - Resultados de Exámenes No Laboratoriales (Disponibles)",
            tasyToTasyResultsNonLabReceived:
              "Tasy <> Tasy - Resultados de Exámenes No Laboratoriales (Recibidos)",
            syncTransaction: "Sync - Datos de las Transacciones",
          },
          robots: {
            robots: "Robots",
            list: "Lista",
          },
        },
        "4uSalesContract": {
          register: {
            register: "Registros",
            salesGrantors: "Otorgantes",
            salesContractAttachmentTypes: "Tipo de Anexo de Contrato",
            salesContractClassifications: "Clasificación de Contrato",
            salesProductCtrClassifications: "Clasificación de Productos",
            salesChannelClassifications: "Clasificaciones del Canal de Ventas",
            salesChannels: "Canales de Venta",
            salesProductCtrs: "Producto",
            salesContractTerminationReason: "Motivo Cancelación Contrato",
            beneficiaryContractReasonOfTerminations:
              "Motivo de Terminación del Contrato de Beneficiario",
            salesContractBeneficiaryClassifications:
              "Clasificación de Beneficiario",
            beneficiaryContractReasonOfCancellations:
              "Motivo de Cancelación del Beneficiario",
            beneficiaryContractReasonOfSuspensions:
              "Motivo de Suspensión del Beneficiario",
          },
        },
        "4uESign": {
          createAutomations: {
            createAutomations: "Automatizaciones",
            automationRules: "Reglas de Automatización",
            emailSendRules: "Envío de correo electrónico",
            signatureGroups: "Grupos de Firma",
          },
          logs: {
            logs: "Logs",
            forubusSignatureLogs: "Logs de firma",
          },
        },
        "4uDlist": {
          register: {
            register: "Inscripciones",
            classification: "Clasificaciones",
            category: "Categorías",
          },
          imports: {
            imports: "Importaciones",
            listFiles: "Importación de Listas",
            listImportAutomation:
              "Automatización para Generar Listas de Distribución",
          },
          distributionList: {
            distributionList: "Listas de Distribuición",
            list: "Listas de Distribuición",
          },
          listGenerator: {
            listGenerator: "Generador de Listas",
            generationRules: "Reglas de Generación",
            generateList: "Generación de Listas",
          },
        },
        "4uMarCom": {
          campaigns: {
            campaigns: "Campañas",
            campaignRegister: "Registro de Campañas",
          },
          templates: {
            templates: "Plantillas",
            whatsapp: "WhatsApp",
          },
          automations: {
            automations: "Automatizaciones",
            automationRule: "Reglas de Automatización",
          },
          optInOptOut: {
            optInOptOut: "Opt-in / Opt-out",
            permissionCommunication: "Permisos de Comunicación",
            distributionList: {
              distributionList: "Listas de Distribución",
              list: "Controles de Listas",
            },
          },
        },
      },
      logs_accordions: {
        user: "Usuario:",
        duration: "Duración",
      },
      logs_table: {
        name: "Nombre",
        original_value: "valores originales",
        new_value: "Nuevos valores",
        button_see_more: "Ver más",
      },
      logs_no_data: {
        message: "¡Datos no encontrados!",
      },
      roles: {
        title: "Perfil",
        name: "Nombre",
        establishment: "Establecimiento",
        search_name: "Buscar un nombre",
        new_role: "Nuevo perfil",
        privileges_tab: "Privilegios",
        dashboards_tab: "Dashboards",
        reports_tab: "Informes",
        dashboard_panel: "Dashboard",
        dashboard_panels: "Dashboards",
        add_dashboard_panel: "Agregar dashboard",
        search_dashboard_panel: "Buscar dashboard",
        report: "Informe",
        reports: "Informes",
        add_report: "Agregar informe",
        search_report: "Buscar informe",
        code: "Código",
        report_with_code: "#{{code}} - {{name}}",
        edit_link: "Editar",
        delete_link: "Eliminar",
        cancel: "Cancelar",
      },
      roles_basic_data: {
        name: "Nombre",
        description: "Descripción",
      },
      roles_establishments: {
        title: "Establecimientos",
        add_establishments: "Añadir nuevo establecimiento",
        name: "El nombre es obligatorio",
        label: "Establecimiento(s) que pueden utilizar este perfil",
        establishmentsTypeId: "Seleccione un establecimiento",
        establishments_tooltip: "Ver establecimientos",
      },
      roles_privileges: {
        title: "Privilegios",
        add_privileges: "Agregar nuevo privilegio",
      },
      private: {
        permission: "¡Uy! ",
      },
      forgetPasswordForm: {
        title: "¿Has olvidado tu contraseña?",
        subtitle:
          "Ingrese su nombre de usuario a continuación y le enviaremos un código a su correo electrónico para restablecer su contraseña.",
        button: "Enviar",
        sending: "Enviando",
        login: "CPF",
        login_required: "¡CPF es requerido!",
        notification_email_sent: "Correo electrónico enviado con éxito!",
        back_login: "Atrás para iniciar sesión",
      },
      forgetPasswordModal: {
        title: "¡Instrucciones enviadas!",
        message:
          "Hemos enviado instrucciones para restablecer la contraseña a su correo electrónico, verifique todas las bandejas de entrada y las carpetas de correo no deseado.",
        close: "Cerca",
      },
      resetPasswordForm: {
        title: "Nueva contraseña",
        subtitle:
          "Ingresa el código enviado a tu correo electrónico. Si no lo encuentras, revisa tu área de spam.",
        password: "Contraseña",
        confirm_password: "Confirmar Contraseña",
        confirmation_code: "Código de confirmación",
        sending: "Enviando",
        send: "Enviar",
        new_password_required: "Se requiere contraseña.",
        confirm_new_password_required: "Se requiere confirmar la contraseña.",
        passwords_match: "Las contraseñas no coinciden.",
        confirmation_code_required: "El código de confirmación es obligatorio",
        notification_password_success: "¡Contraseña cambiada con éxito!",
      },
      noRowsMessage: {
        no_permission: "No tienes permiso para ver la información.",
        no_data: "No tienes información registrada",
      },
      onPremiseModal: {
        establishment: {
          establishment_on_premise: "Establecimiento on premise",
          no_data: "No se encontró ningún establecimiento",
        },
        params: {
          params_on_premise: "Parámetros on premise",
          no_data: "No se encontró ningún parámetro",
        },
        generics: {
          generics_on_premise: "Genéricos on premise",
          no_data: "No se encontró ningún genérico",
        },
        health: {
          health_on_premise: "Planes de salud sincronizados",
          no_data: "No se encontró ningún plano de salud",
        },
        medicSpecialties: {
          no_data: "No se encontraron especialidades médicas",
        },
        providerTypes: {
          no_data: "No se encontraron tipos de proveedores",
        },
        professionalCouncils: {
          no_data: "No se encontró asesoramiento profesional.",
        },
        medicalPracticeAreas: {
          no_data: "No se encontraron áreas de práctica médica",
        },
      },
      cardMenu: {
        button: "Ver más",
      },
      extensionsStoreHeader: {
        title: "Tienda de extensiones",
        search: "Buscar por una extensión o tag",
        add_extensions: "Agregar extensiones",
        my_extensions: "Mi extensiones",
        back: "Volver",
      },
      extensionsCard: {
        details: "Detalles",
        install: "Instalar",
        request_install: "Solicitar instalación",
        requested: "Instalación solicitada",
        installing: "Instalación",
        installed: "Instalado",
        setup_requested: "Configuración Solicitada",
        free: "Gratis",
        select: "Seleccione un sitio web",
        tooltip_install: "Instalación",
        tooltip_month: "Mensualidad",
        site_app: "Sites o Apps",
        setup_cancel: "Solicitud de Setup Cancelada",
        cancel: "Cancelar Setup",
        errors: {
          site_app: "Seleccione al menos un site o app para instalar",
        },
      },
      extensionsStoreDetail: {
        title: "Detalles de la extensión",
        free: "Gratis",
        installed: "Instalado",
        request_install: "Request installation",
        requested: "Installation requested",
        about: "Sobre la extensión",
        available_for: "Disponible para",
        install: "Instalar",
        settings: "Ajustes",
        configure: "Configurar en",
        tooltip_install: "Instalar",
        tooltip_month: "Mensualidad",
        tooltip_uninstall: "Desinstalar",
        tooltip_settings: "Ajustes",
        tags: "Tags",
        dependencies: "Dependencias",
      },
      extensionInstallPopper: {
        title: "¿Realmente quieres instalar la extensión?",
        cancel: "Cancelar",
        install: "Instalar",
      },
      extensionUninstallPopper: {
        title: "¿Realmente quieres desinstalar la extensión?",
        request_title:
          "¿Realmente deseas solicitar la instalación de la extensión?",
        cancel: "Cancelar",
        uninstall: "Desinstalar",
        uninstalling: "Desinstalar",
        request: "Solicitar",
      },
      extensionSettings: {
        title: "Configurar extensión",
        identifier: "Identificador",
        property: "Propiedad",
        value: "Valor",
        description: "Descripción",
      },
      settingsCorreios: {
        url_token: "Token de URL",
        user_token: "Token de Usuario",
        access_token: "Token de Código de Acceso",
        post_card: "Tarjeta Postal",
      },
      settingsGeneral: {
        user_token: "correiosTokenUser",
        access_token: "correiosTokenAccessCode",
        post_card: "correiosTokenPostCard",
        correios_url: "URL de los Correios",
        correios_token_user: "correiosTokenUser",
        correios_authentication: "correiosAuthenticationUrl",
        correios_locations: "correiosLocationsUrl",
        correios_addresses: "correiosAddressesUrl",
        cep_cache_time: "cepCacheTime",
        correios_page_size: "correiosPageSize",
        bank_base: "bankBaseUrl",
        bank_cooperativas: "bankCooperativasUrl",
        bank_bancos: "bankBancosUrl",
        geolocation: "Geolocalización",
        api_geocoding_key: "apiGeocodingKey",
        save: "Ahorrar",
        saving: "Ahorro",
        success: "Configuración general actualizada con éxito",
        errors: {
          user_token: "El correiosTokenUser es obligatorio",
          access_token: "El correiosTokenAccessCode es obligatorio",
          post_card: "El correiosTokenPostCard es obligatorip",
          correios_url: "La URL de los Correios es obligatoria",
          correios_token_user: "El correiosTokenUser es obligatorio",
          correios_authentication:
            "El correiosAuthenticationUrl es obligatorio",
          correios_locations: "El correiosLocationsUrl es obligatorio",
          correios_addresses: "El correiosAddressesUrl es obligatorio",
          cep_cache_time: "El cepCacheTime es obligatorio",
          bank_base: "El bankBaseUrl es obligatorio",
          bank_cooperativas: "El bankCooperativasUrl es obligatorio",
          bank_bancos: "El bankBancosUrl es obligatorio",
          correios_page_size: "El correiosPageSize es obligatorio",
          api_geocoding_key: "El apiGeocodingKey es obligatorio",
        },
      },
      certillionSettings: {
        title: "Configuraciones de Certillion",
        base_url: "URL base",
        client_secret: "Secreto del cliente",
        seconds_to_find_signed_files:
          "Segundos para encontrar archivos firmados",
        token_path: "Ruta del token",
        upload_file_path: "Ruta del archivo para subir",
        pscs_accounts_path: "Ruta de las cuentas PSCs",
        client_id: "ID del cliente",
        default_minutes_signature_session:
          "Minutos predeterminados para la sesión de firma",
        authorize_path: "Ruta de autorización",
        signature_path: "Ruta de la firma",
        client_token_path: "Ruta del token del cliente",
        save: "Guardar",
        saving: "Ahorro",
        success: "Configuración actualizada",
        paths: "Paths",
        errors: {
          base_url: "La URL base es obligatoria",
          client_secret: "El secreto del cliente es obligatorio",
          seconds_to_find_signed_files:
            "Los segundos para encontrar archivos firmados son obligatorios",
          token_path: "La ruta del token es obligatoria",
          upload_file_path: "La ruta del archivo para subir es obligatoria",
          pscs_accounts_path: "La ruta de las cuentas PSCs es obligatoria",
          client_id: "El ID del cliente es obligatorio",
          default_minutes_signature_session:
            "Los minutos predeterminados para la sesión de firma son obligatorios",
          authorize_path: "La ruta de autorización es obligatoria",
          signature_path: "La ruta de la firma es obligatoria",
          client_token_path: "La ruta del token del cliente es obligatoria",
        },
      },
      settingsCache: {
        settingsCacheTotal: {
          clean_all_cache: "Borrado completo de caché (excepto Hangfire)",
          clean_all_description:
            "Limpia toda la caché de la plataforma, a excepción de las gestionadas por HangFire, nuestro gestor de trabajos.",
          clean_all_button: "Limpiar",
          clean_all_success: "Caché borrado con éxito",
        },
        settingsCacheKey: {
          clean_key_cache: "Borrado de caché por clave (acepta clave parcial)",
          clean_key_description:
            "Borra el caché según la clave ingresada. También acepta proporcionar una clave parcial. Ejemplo: si se especifica EF_, se borrará toda la caché de Entity Framework de la plataforma. Si se informa a Hangfire*, se borrará todo el caché relacionado con nuestro administrador de trabajos.",
          clean_key: "Clave",
          clean_key_button: "Limpiar",
          clean_key_success:
            "Caché borrado exitosamente para la clave '{{key}}'",
          errors: {
            cache_key: "La clave es obligatoria.",
          },
        },
        searchCacheKey: {
          search_cache_key: "Búsqueda de caché por clave",
          search_cache_description:
            "Busca en el caché según la clave dada. También acepta proporcionar una clave parcial. Ejemplo: si se especifica *EF_*, recuperará todo el caché de Entity Framework de la plataforma. Si se informa a *HANGFIRE*, recuperará todo el caché relacionado con nuestro administrador de trabajos.",
          search: "Buscar",
          search_key: "Clave",
          results: "Resultados de la búsqueda de clave",
          no_data: "No se encontró información",
          errors: {
            cache_key: "La clave es obligatoria.",
          },
        },
      },
      neighborhood: {
        neighborhood: "Vecindario",
        other: "No encontré mi barrio y quiero ingresar a uno nuevo",
        cep: "Ingrese un código postal primero",
      },
      addressContent: {
        cep_first: "Ingrese un código postal primero",
      },
      appDomain: {
        domain: "Dominio",
        title: "Copiar dominio",
      },
      nationalHolidays: {
        import_holidays: "Importar feriados nacionales",
        select_all: "Seleccionar todo",
      },
      cepInput: {
        zip_code: "CEP",
        helper_text: "Ingrese un código postal para buscar",
        city: "Ciudad",
        province: "Estado",
      },
      daysOfWeek: {
        sunday: "Domingo",
        monday: "Lunes",
        tuesday: "Martes",
        wednesday: "Miércoles",
        thursday: "Jueves",
        friday: "Viernes",
        saturday: "Sábado",
      },
      notificationInformations: {
        status: "Status",
        is_published: "Status de publicación",
        start_publish: "Inicio de publicación",
        finish_publish: "Fin de publicación",
        published: "Publicado",
        not_published: "No publicado",
      },
      notificationBatchActions: {
        generate: "Generar lote",
        cancel: "Cancelar lote",
        batch_generated: "Lote generado exitosamente",
        batch_canceled: "Lote cancelado exitosamente",
        cancel_popover_title:
          "Al cancelar el lote, ya no será posible generar lotes para esta notificación.",
        users: "Usuarios notificados",
      },
      searchResults: {
        no_data: "Ningún resultado encontrado",
      },
      yearSelect: {
        label: "Filtrar por año",
      },
      syncSection: {
        sync: "Sincronizar",
        view_data: "Ver datos integrados",
      },
      syncEstablishment: {
        title: "Establecimiento",
        description:
          "Sincronizar los datos del Establecimiento con el entorno 4uBus",
        synced: "Datos del Establecimiento sincronizados exitosamente",
        modal_title: "Datos integrados del establecimiento",
      },
      syncGeneric: {
        title: "Genérico",
        description: "Sincronizar los datos del Genérico con el entorno 4uBus",
        synced: "Datos del Genérico sincronizados exitosamente",
        modal_title: "Datos integrados del genérico",
      },
      syncUsers: {
        title: "Usuario",
        description: "Sincronizar los datos del Usuario con el entorno 4uBus",
        synced: "Datos del Usuario sincronizados exitosamente",
        modal_title: "Datos integrados del usuario",
      },
      syncPrivilege: {
        title: "Privilegio",
        description:
          "Sincronizar los datos del Privilegio con el entorno 4uBus",
        synced: "Datos del Privilegio sincronizados exitosamente",
        modal_title: "Datos integrados del privilegio",
      },
      syncEstablishmentParam: {
        title: "Parámetro de establecimiento",
        description:
          "Sincronizar los datos del Parámetro de establecimiento con el entorno 4uBus",
        synced:
          "Datos del Parámetro de establecimiento sincronizados exitosamente",
        modal_title: "Datos integrados del parámetro de establecimiento",
      },
      syncRelationshipType: {
        title: "Tipo de relación",
        description:
          "Sincronizar los datos del Tipo de relación con el entorno 4uBus",
        synced: "Datos del Tipo de relación sincronizados exitosamente",
        modal_title: "Datos integrados del tipo de relación",
      },
      syncRelationship: {
        title: "Relación",
        description:
          "Sincronizar los datos de la Relación con el entorno 4uBus",
        synced: "Datos de la Relación sincronizados exitosamente",
        modal_title: "Datos integrados de la relación",
      },
      syncExtension: {
        title: "Extensión",
        description:
          "Sincronizar los datos de la Extensión con el entorno 4uBus",
        synced: "Datos de la Extensión sincronizados exitosamente",
        modal_title: "Datos integrados de la extensión",
      },
      integratedData: {
        no_data: "No se encontraron datos integrados",
      },
      filtersActions: {
        filter: "Filtrar",
        clean: "Limpiar filtros",
        refresh: "Actualizar",
      },
      callToActionsButtons: {
        call_to_action: "Llamada a la acción",
        change_buttons_order: "Cambiar el orden de agrupación de botones",
      },
      quickAnswerButtons: {
        quick_aswer: "Respuesta rápida",
        change_buttons_order: "Cambiar el orden de agrupación de botones",
      },
      buttonSetting: {
        action_type: "Tipo de acción",
      },
      accessSiteAction: {
        static: "Estático",
        dynamic: "Dinámica",
        text: "Botón de texto",
        url_type: "Tipo de URL",
        payload: "URL del site",
        url_placeholder: "https://www.exemplo.com",
        url_tooltip:
          "Agregar una variable crea un enlace personalizado para que el cliente vea su información. Sólo se puede agregar una variable al final de una URL.",
      },
      callAction: {
        text: "Botón de texto",
        country: "País",
        payload: "Teléfono",
      },
      copyOfferCodeAction: {
        text: "Botón de texto",
        info: {
          title: "Agregar código de oferta de muestra",
          subtitle:
            "Para ayudarnos a analizar su plantilla de mensaje, agregue un código de oferta de ejemplo.",
        },
        payload: "Ofrece código",
      },
      selectWhatsButtons: {
        tooltip_limit:
          "Se alcanzó el límite de botones. Para agregar otro tipo de botón, elimine primero un botón",
        generate_automatically:
          "Los botones se determinan automáticamente según la automatización seleccionada",
        add_button: "Añadir un botón",
        quick_answer_buttons: "Botones de respuesta rápida",
        call_to_action_buttons: "Botones de llamada a la acción",
        help: "Si agrega más de 3 botones, aparecerán en una lista.",
        buttons_no_integligence_warning:
          "Estos botones no tienen ninguna inteligencia ni acción automática por parte de la plataforma 4uHub. Su uso es totalmente responsabilidad y riesgo del usuario.",
      },
      whatsButtonsOptions: {
        personalized: {
          name: "Personalizado",
        },
        access_site: {
          name: "Acceder al sitio",
          description: "2 botones máximo",
        },
        call: {
          name: "Llamar",
          description: "1 botón máximo",
        },
        call_whats: {
          name: "Llamar por Whatsapp",
          description: "1 botón máximo",
        },
        copy_offer_code: {
          name: "Copiar código de oferta",
          description: "1 botón máximo",
        },
      },
      customButton: {
        text: "Botón de texto",
      },
      addVariablesButton: {
        variables: "Variables",
        variable: "Variable",
        cancel: "Cancelar",
        add: "Añadir",
        add_variables: "Añadir variables",
      },
      variablesContainer: {
        title: "Ejemplo de contenido corporal.",
        description:
          "Para ayudarnos a analizar su plantilla de mensaje, incluya un ejemplo de cada variable en el cuerpo del texto. No utilice información real del cliente. La API de la nube alojada por Meta analiza modelos y parámetros variables para proteger la seguridad e integridad de nuestros servicios.",
      },
      variableField: {
        label: "Insertar contenido a ",
        character_limit: "Límite de caracteres",
        exceeded: "El contenido supera el límite de caracteres",
      },
      bodyInput: {
        error: "Todas las variables deben ser válidas",
      },
      timeRules: {
        add_time_rule: "Añadir regla de tiempo",
        time_classification: "Clasificación del Tiempo",
        type: "Tipo",
        value: "Valor",
        search: "Buscar una regla de tiempo",
        confirm: {
          title: "¿Eliminar la regla de tiempo?",
          description: "Esto eliminará permanentemente la regla de tiempo",
        },
        errors: {
          type: "El tipo es obligatorio",
          time_classification: "La clasificación del tiempo es obligatoria",
          value: "El valor es obligatorio",
        },
      },
      automationMessages: {
        automation_message: "Mensaje de Automatización",
        new_automation_message: "Nueva mensaje de automatización",
        add_automation_message: "Añadir mensaje de automatización",
        search: "Buscar una mensaje de automatización",
        automation_message_type: "Tipo de mensaje de automatización",
        message: "Mensaje",
        send_rule_message: "Enviar mensaje",
        yes: "Sí",
        no: "No",
        confirm: {
          title: "¿Eliminar la mensaje de automatización?",
          description:
            "Esto eliminará permanentemente la mensaje de automatización",
        },
        errors: {
          automation_message_type:
            "El tipo de mensaje de automatización es obligatorio",
          message: "La mensaje es obligatoria",
        },
      },
      messages: {
        message: "Mensaje",
        new_message: "Nueva mensaje",
        add_message: "Añadir mensaje",
        search: "Buscar una mensaje",
        name: "Nombre",
        preference: "Preferencias",
        enable: "Permitir",
        exception: "Excepción",
        send: "Enviar",
        status: "Status",
        active: "Activo",
        inactive: "Inactivo",
        initial_date: "Fecha de inicio",
        end_date: "Fecha de finalización",
        evaluation_form: "Formulario",
        rounded_schedules_date: "Redondeo de Fechas",
        arrival_time_rule: "Regla de Horario de Llegada",
        e_sign_rules: "Reglas de Automatización de 4ue-Sign",
        schedule_reminder_filter_type: "Restringir a",
        establishment: "Establecimiento",
        schedule_records: "Agendas",
        schedule_classifications: "Clasificaciones de programación",
        active_service_search_survey_type: "Tipo de encuesta de búsqueda",
        evaluation_link_same_as_template:
          "El enlace de evaluación será el mismo que el registrado en la plantilla.",
        schedule_types: "Tipo de agenda",
        schedule_health_insurances: "Seguro de salud",
        if: "Si",
        then: "Entonces",
        move_ticket:
          "Mueva el ticket(card) si la persona responde otra cosa que no sea SIM / OK / CONFIRMAR",
        move_ticket_cancel:
          "Mover ticket(card) si la persona responde CANCELAR",
        move_ticket_not_me:
          "Mover ticket(card) si la persona responde NÃO SOU EU",
        move_ticket_confirm:
          "Mover ticket(card) si la persona responde CONFIRMAR",
        move_ticket_attendant:
          "Mover ticket(card) si la persona responde FALAR COM ATENDENTE",
        warning:
          "Al habilitar la excepción, al menos uno de los campos siguientes es obligatorio.",
        qty_pacient_sent: "Número de pacientes a enviar",
        priority: "Prioridad",
        origin: "Orígenes",
        schedulingMethod: "Métodos de programación",
        originMessageHelper: "Los valores deben estar separados por comas",
        schedulingMethodMessageHelper:
          "Los valores deben estar separados por comas",
        serviceClassification: "Clasificación",
        serviceSector: "Sectores",
        serviceType: "Tipo de servicio",
        serviceComplaint: "Queja/Motivo del servicio",
        groupingIdentifier: "Grupo de programación",
        integrationType: "Tipo de integración",
        tasyAuthStatuses: "Autorización",
        tasyCalendarStatuses: "Estado de la Agenda",
        surgeryTypes: "Tipo de Cirugía",
        surgeryPortes: "Porte",
        surgeryCareCharacters: "Carácter",
        surgeryServiceSectors: "Sector de Atención de la Cirugía",
        surgeryHealthInsurances: "Seguro de Salud de la Cirugía",
        calendarHistoryType: "Código del Tipo de Historial",
        cancellationReasonCode:
          "Código(s) de motivo de cancelación de la consulta",
        cancellationReasonHelpText:
          "Ingrese los códigos de motivo separados por comas. Si se registra solo uno, se aplicará directamente; si se registra más de uno, el usuario podrá elegir cuál usar.",
        cancellationReasonDescription:
          "Descripción del motivo de la cancelación de la consulta",
        cancellationReasonDescHelpText:
          "Ingrese una descripción alternativa para el motivo seleccionado.",
        examCancellationReasonCode:
          "Código(s) de motivo de cancelación del exame",
        examCancellationReasonHelpText:
          "Ingrese los códigos de motivo separados por comas. Si se registra solo uno, se aplicará directamente; si se registra más de uno, el usuario podrá elegir cuál usar.",
        examCancellationReasonDescription:
          "Descripción del motivo de la cancelación del exame",
        examCancellationReasonDescHelpText:
          "Ingrese una descripción alternativa para el motivo seleccionado.",
        surgeryCancellationReasonCode:
          "Código(s) del motivo de cancelación de la cirugía",
        surgeryCancellationReasonHelpText:
          "Ingrese los códigos de motivo separados por comas. Si se registra solo uno, se aplicará directamente; si se registra más de uno, el usuario podrá elegir cuál usar.",
        surgeryCancellationReasonDescription:
          "Descripción del motivo de cancelación de la cirugía",
        surgeryCancellationReasonDescHelpText:
          "Ingrese una descripción alternativa para el motivo seleccionado.",
        qtyMessageSendingAttempts: "Intentos de reenvío",
        missing_status: "Status da Agenda",
        internalProcedure: "Procedimiento interno",
        individualIdentifier: "Identificador individual",
        indicationSequence: "Indicación del atendimento (NR_SEQ_INDICACAO)",
        indicationSequenceHelper: "Los valores deben estar separados por comas",
        usePatientEncounterInfoPhone:
          "Enviar al teléfono de las informaciones adicionales del atendimento del paciente",
        serviceClassificationMessageHelper:
          "Los valores deben estar separados por comas",
        serviceSectorMessageHelper:
          "Los valores deben estar separados por comas",
        serviceTypeMessageHelper: "Los valores deben estar separados por comas",
        serviceComplaintMessageHelper:
          "Los valores deben estar separados por comas",
        groupingIdentifierMessageHelper:
          "Los valores deben estar separados por comas",
        integrationTypeMessageHelper:
          "Los valores deben estar separados por comas",
        internalProcedureMessageHelper:
          "Los valores deben estar separados por comas",
        individualIdentifierMessageHelper:
          "Los valores deben estar separados por comas",
        sendToConfimed: "Enviar a confirmado",
        confirmScheduleWithOk: "Al hacer clic en OK, confirmar la agenda",
        noReplyActionsWarning:
          'Opciones de acción no disponibles, ya que la plantilla "{{template}}" no tiene ninguna opción de respuesta configurada en los botones. El ticket se finalizará justo después del envío del mensaje.',
        confirm: {
          title: "¿Eliminar la mensaje?",
          description: "Esto eliminará permanentemente la mensaje",
        },
        errors: {
          name: "El nombre es obligatorio",
          evaluation_form: "El formulario es obligatorio",
          initial_date: "La fecha de inicio es obligatoria",
          end_date: "La fecha de finalización es obligatoria",
          initial_date_bigger:
            "La fecha de inicio no puede ser mayor que la fecha de fin",
          qty_pacient_sent: "El número de pacientes a enviar es obligatorio",
          ticket_channel_when_not: "El tablero es obligatorio",
          ticket_channel_step_when_not: "La lista es obligatoria",
          ticket_channel_when_cancel: "El tablero es obligatorio",
          active_service_search_survey_type:
            "Tipo de encuesta de búsqueda es obligatorio",
          ticket_channel_step_when_cancel: "La lista es obligatoria",
          ticket_channel_when_not_me: "El tablero es obligatorio",
          ticket_channel_step_when_not_me: "La lista es obligatoria",
          ticket_channel_when_confirm: "El tablero es obligatorio",
          ticket_channel_step_when_confirm: "La lista es obligatoria",
          ticket_channel_when_attendant: "El tablero es obligatorio",
          ticket_channel_step_when_attendant: "La lista es obligatoria",
          calendarHistoryType: "El tipo de historial es obligatorio",
          cancellationReasonCode: "El código es obligatorio",
          cancellationReasonDescription: "La descripción es obligatoria",
          examCancellationReasonCode: "El código es obligatorio",
          examCancellationReasonDescription: "La descripción es obligatoria",
          surgeryCancellationReasonCode: "El código es obligatorio",
          surgeryCancellationReasonDescription: "La descripción es obligatoria",
        },
      },
      boardList: {
        board: "Marco",
        list: "Lista",
      },
      ticketServiceAreaDays: {
        ticket_service_area_days: "Días de servicio",
        ticket_service_area_day: "Día de servicio",
        add_ticket_service_area_day: "Añadir día de servicio",
        new_ticket_service_area_day: "Nuevo día de servicio",
        edit_ticket_service_area_day: "Editar día de servicio",
        day_of_week: "Día de la semana",
        initial_time: "Hora de inicio",
        end_time: "Hora de finalización",
        enable: "Permitir",
        search: "Buscar un día de servicio",
        confirm: {
          title: "¿Eliminar el día de servicio?",
          description: "Esto eliminará permanentemente el día de servicio",
        },
        errors: {
          day_of_week: "El día de la semana es obligatorio",
          initial_time: "La hora de inicio es obligatoria",
          end_time: "La hora de finalización es obligatoria",
          initial_time_bigger:
            "La hora de inicio no puede ser mayor que la hora de finalización",
        },
      },
      selectCategories: {
        label: "Seleccionar categorías",
        no_options_text: "No hay categorías seleccionadas",
        options_button_label: "Buscar categorías",
        drawer_props: {
          title: "Seleccionar Categorías",
          create_button_label: "Crear nueva categoría",
          input_label: "Nombre de la categoría",
          apply_button_label: "Seleccionar categorías",
        },
      },
      viewModeSelect: {
        list: "Modo Lista",
        grid: "Modo Grid",
      },
    },
    chatBot: {
      page: {
        register: {
          ticketService: {
            id: "Id de servicio",
            allowDistributionList: "Permitir listas de distribución",
            ticket_service: "Servicio de tickets(cards)",
            new_ticket_service: "Nuevo servicio de tickets(cards)",
            ticket_channel_donor_work: "Panel de Donantes",
            enable: "Permitir",
            name: "Nombre",
            phoneNumber: "Teléfono",
            qualityRating: "Calificación de calidad",
            ticket_service_type: "Tipo de servicio de tickets(cards)",
            search: "Buscar un servicio de tickets(cards)",
            add_ticket_service: "Añadir servicio de tickets(cards)",
            site_app_extensions: "Sitios o Apps",
            ticket_channel_initial: "Marco de inicio",
            whats_settings: "Configuración de Whatsapp",
            typebot_settings: "Configuración de TypeBot",
            external_chat_site_app:
              "Sitio / Aplicación para Chat Interno (4uChat)",
            full_screen_mode: "Modo Pantalla Completa",
            send_protocol_number:
              "Enviar el Protocolo al finalizar el ticket al transferir al chat interno (4uChat)",
            config_title: "Configuración",
            show_message_disable_area:
              "Mostrar un mensaje que indique que algunas opciones no están disponibles porque está fuera del horario comercial y requiere un asistente cara a cara",
            show_badge_name_color:
              "¿Mostrar globo con el nombre del servicio en el tickets(cards)?",
            badge_background_name_color:
              "Selecciona el color de fondo del globo",
            badge_name_color: "Seleccionar color de texto del globo",
            ticket_message_received_rvent: "Lista de mensajes",
            confirm: {
              title: "¿Eliminar el servicio de tickets(cards)?",
              description:
                "Esto eliminará permanentemente el servicio de tickets(cards).",
            },
            copied_successfully: "Copiado exitosamente",
            errors: {
              name: "El nombre es obligatorio",
              ticket_service_type:
                "El tipo de servicio de tickets(cards) es obligatorio",
              site_app_extensions: "Al menos uno sitio o app es obligatorio",
              ticket_channel_initial: "El marco de inicio es obligatorio",
              badge_background_name_color:
                "El color de fondo del globo es obligatorio",
              badge_name_color: "El color del texto del globo es obligatorio",
            },
            sync_whats: "Sincronizar con WhatsApp",
            sync_whats_success: "Sincronizado exitosamente",
            sync_whats_error: "Se produjo un error durante la sincronización",
          },
          ticketServiceWhats: {
            ticket_service_whats: "Configuración de Whatsapp",
            new_ticket_service_whats: "Nueva Configuración de Whatsapp",
            business_phone_number:
              "Id del número de teléfono de Whatsapp Business",
            business_account: "Id de cuenta Whtsapp Business",
            whatsapp_business: "Id de App Whatsapp Business",
            access_token: "Token de Acceso",
            webhook_link: "Link de Webhook",
            webhook_link_tooltip: "Copiar link",
            verify_token: "Token de Verificación",
            verify_token_tooltip: "Copiar Token de Verificación",
            webhook_updated: "¡Webhook actualizado exitosamente!",
            phone_number_registered:
              "¡Número de teléfono registrado exitosamente!",
            register_succesfully:
              "¡Registro completo! Tu ID de teléfono es {{phoneNumberId}} y tu ID de WABA es {{whatsAppBusinessAccountId}}.",
            sync_error:
              "Hubo un error al sincronizar la información, por favor revísala en tu cuenta Meta.",
            register_cancel:
              "Se ha cancelado el proceso de conexión de WhatsApp.",
            register_error:
              "Se produjo un error durante el registro: {{error_message}}",
            button_update_webhook: "Actualizar webhook",
            button_register_phone_number: "Registrar número",
            button_business_profile: "Perfil de Whatsapp Business",
            button_phone_profile: "Perfil del Número",
            errors: {
              business_phone_number:
                "El id del número de teléfono de Whatsapp Business es obligatorio",
              business_account:
                "El id de cuenta Whtsapp Business es obligatorio",
              whatsapp_business:
                "El id de App Whatsapp Business es obligatorio",
              access_token: "El token de acceso es obligatorio",
              webhook_updated: "¡Hubo un error al actualizar wehook!",
              phone_number_registered:
                "¡Hubo un error al registrar el número de teléfono!",
            },
            whatsappProfilePath: {
              whatsappProfileModalTitle: "Perfil de Empresa de Whatsapp",
              description: "Descripción",
              about: "Acerca de",
              email: "Correo electrónico",
              websites: "Sitios web",
              address: "Dirección",
              websites_help_text: "Presiona enter para agregar los sitios web",
              vertical: "Categoría",
              profile_picture: "Foto de perfil",
              profileUpdated:
                "Perfil de empresa de Whatsapp actualizado con éxito",
              select_file: "Selecciona un archivo",
              error: {
                profileUpdated:
                  "Ocurrió un error al actualizar el perfil de empresa de Whatsapp",
              },
            },
            whatsappNamePath: {
              nameUpdated:
                "Nuevo nombre de visualización enviado para análisis",
              whatsappNameModalTitle: "Perfil del número de teléfono",
              verifiedName: "Nombre verificado",
              newDisplayName: "Nuevo nombre de visualización",
              qualityRating: "Clasificación de Calidad",
              messagingLimitTier: "Límite de mensajes",
              waiting_update:
                "¡Espere la aprobación de la última solicitud de cambio para volver a cambiar!",
              error: {
                nameUpdated:
                  "Ocurrió un error al enviar el nuevo nombre de visualización para análisis",
              },
            },
          },
          ticketServiceTypebot: {
            ticket_service_typebot: "Configuraciones de TypeBot",
            new_ticket_service_typebot: "Nueva configuración de TypeBot",
            typebot_viewer_host: "Visualizador del Host de TypeBot",
            errors: {
              viewer_host: "El visualizador del host de typebot es obligatorio",
            },
          },
        },
        logs: {
          ticketHistories: {
            title: "Historial de Tickets",
            start_date: "Fecha inicial",
            end_date: "Fecha final",
            occurrence_type: "Tipo de ocurrencia",
            ticket_service: "Servicio de Ticket",
            search: "Buscar mensaje",
            created: "Fecha/hora",
            message: "Mensaje",
            ticket_id: "Ticket",
            view_full_message: "Ver mensaje completo",
            full_message_title: "Mensaje completo",
            close: "Cerrar",
            open_ticket: "Abrir ticket en CRM",
            retry: "Intentar nuevamente",
            errors: {
              period_required: "Informe un período antes de buscar los logs.",
              invalid_period:
                "La fecha inicial no puede ser mayor que la fecha final.",
              start_date_required: "La fecha inicial es obligatoria",
              end_date_required: "La fecha final es obligatoria",
              invalid_date_range:
                "La fecha final debe ser mayor o igual a la fecha inicial",
              occurrence_type_required: "El tipo de ocurrencia es obligatorio",
              filters_load: "No fue posible cargar los filtros de la pantalla.",
              ticket_redirect: "No fue posible abrir el ticket en el CRM.",
            },
          },
          examSchedulingAttachmentLog: {
            title: "Log de Anexos de los Agendamientos de Exámenes",
            date_start: "Fecha Inicial",
            date_end: "Fecha Final",
            status: "Estado",
            sync: "Sincronizado",
            not_sync: "No Sincronizado",
            identifier: "Identificador",
            ticket_id: "ID del Ticket",
            protocol_number: "Número de Protocolo",
            ticket_number: "Número del Ticket",
            integration_id: "ID de Integración",
            error_message: "Mensaje de Error",
            retries: "Reintentos",
            force_retry: "Forzar Reenvío",
            reseted_success: "Reenvío forzado con éxito",
          },
        },
        service: {
          ticketFinishReason: {
            ticket_finish_reasons: "Motivos de cierre de tickets",
            ticket_finish_reason: "Motivo de cierre de ticket",
            new_ticket_finish_reason: "Nuevo motivo de cierre de ticket",
            add_ticket_finish_reason: "Agregar motivo de cierre de ticket",
            search: "Buscar un motivo de cierre de ticket",
            name: "Nombre",
            enable: "Habilitar",
            code: "Código",
            status: "Status",
            active: "Activo",
            inactive: "Inactivo",
            confirm: {
              title: "¿Eliminar motivo de cierre de ticket?",
              description:
                "Esto eliminará permanentemente el motivo de cierre del ticket",
            },
            errors: {
              name: "El nombre es obligatorio",
            },
          },
          memberAvailabilityPauseReason: {
            member_availability_pause_reason: "Motivos de pausa de miembros",
            member_availability_pause_reasons: "Motivo de pausa de miembros",
            new_member_availability_pause_reason:
              "Nuevo motivo de pausa de miembros",
            add_member_availability_pause_reason:
              "Agregar motivo de pausa de miembros",
            search: "Busque un motivo de pausa de miembros",
            name: "Nombre",
            code: "Código",
            confirm: {
              title: "¿Eliminar motivo de pausa de miembros?",
              description:
                "Esto eliminará permanentemente el motivo de pausa de miembros",
            },
            errors: {
              name: "El nombre es obligatorio",
            },
          },
          protocolGenerateRule: {
            protocol_generate_rules: "Reglas de generación de protocolos",
            protocol_generate_rule: "Regla de generación de protocolos",
            new_protocol_generate_rule:
              "Nueva regla de generación de protocolos",
            name: "Nombre de la regla",
            enable: "Permitir",
            initial_date: "Inicio del trimestre",
            end_date: "Fin de validez",
            search: "Buscar una regla de generación de protocolo",
            add_protocol_generate_rule:
              "Añadir regla de generación de protocolo",
            protocol_rule_details:
              "Detalles de la regla de generación de protocolo",
            add_protocol_rule_details:
              "Añadir detalle de regla de generación de protocolo",
            order: "Orden",
            field_type: "Tipo",
            fixed_code: "Valor fijo",
            mask: "Mascarilla",
            mask_information:
              "La máscara se utiliza para formatear el valor del campo '{{type}}' en el protocolo, en los casos en que la longitud es menor que el límite aceptado.",
            mask_no_information:
              "La máscara se utiliza para formatear el valor del campo 'tipo' en el protocolo, en los casos en que la longitud es menor que el límite aceptado.",
            confirm: {
              title: "¿Eliminar regla de generación de protocolos?",
              description:
                "Esto eliminará permanentemente la regla de generación de protocolos",
            },
            errors: {
              name: "El nombre de la regla es obligatorio",
              initial_date: "El inicio del trimestre es obligatorio",
              end_date: "El fin de validez es obligatorio",
              fixed_code: "El Valor fijo es obligatorio",
              protocol_rule_details:
                "Al menos un detalle de la regla de generación de protocolo es obligatorio",
            },
          },
          ticketServiceArea: {
            ticket_service_areas: "Áreas de servicio",
            ticket_service_area: "Vía de servício",
            search: "Buscar un área de servicio",
            add_ticket_service_area: "Añadir área de servicio",
            new_ticket_service_area: "Nueva vía de servício",
            ticket_service_area_parent: "Área de Servicio para Padres",
            ticket_event: "Evento Desencadenante",
            ticket_event_type: "Tipo de Evento",
            name: "Nombre",
            code: "Código",
            enable: "Permitir",
            identification: "Requiere identificación",
            display_order: "Orden de Visualización",
            summary: "Resumen",
            ticket_services: "Servicio de Tickets(Cards)",
            ticket_channel: "Marco para Transferir",
            ticket_channel_step: "Marco para Transferir",
            ticket_default_doc: "Protocolo Predeterminado",
            enable_all_the_time: "Servicio 24/7",
            enable_special_time: "Horario especial",
            service_type: "Tipo de Servicio",
            show_outside_business_day: "Display Area Outside Business Hours",
            message_outside_business_day:
              "Message Displayed to the User Outside Business Hours",
            summary_outside_business_day:
              "Summary Displayed to the User Outside Business Hours",
            ticket_automation_received_rule: "Regla de Recepción",
            received_rule_caption:
              "Siempre que se seleccione una regla de recepción, se requerirá la identificación del paciente.",
            status: "Status",
            active: "Activo",
            inactive: "Inactivo",
            yes: "Sí",
            no: "No",
            actions: "Comportamiento",
            time: "Tiempo",
            action_type: "Tipo de Acción",
            no_action: "Menú Sin Acción",
            trigger_event: "Disparar un Evento",
            default_protocol: "Enviar un Protocolo Predeterminado",
            channel_transfer: "Transferir a una Lista/Tablero",
            received_rule: "Seguir una Regla de Recepción",
            direct_to_internal_chat: "Dirigir al chat interno (4uChat)",
            external_chat_site_app:
              "Sitio / Aplicación para Chat Interno (4uChat)",
            full_screen_mode: "Modo Pantalla Completa",
            send_protocol_number:
              "Enviar el Protocolo al finalizar el ticket al transferir al chat interno (4uChat)",
            automatic_external_chat_alert:
              "Este servicio de tickets tiene activado un redireccionamiento automático al chat interno (4uChat) del Sitio \"{{siteAppName}}\"",
            enableModal: {
              disable: "Desactivar área de servicio?",
              enable: "Permitir área de atendimento?",
              disable_message:
                "Al deshabilitar esta área de servicio, todas las áreas de servicio dependientes serán deshabilitadas también.",
              enable_message:
                "Al habilitar esta área de servicio, todas las áreas de servicio dependientes serán habilitadas también.",
              cancel_button: "Cancelar",
              confirm_button: "Confirmar",
            },
            confirm: {
              title: "¿Eliminar la área de servicio?",
              description:
                "Esto eliminará permanentemente la área de servicio.",
            },
            errors: {
              name: "El nombre es obligatorio",
              display_order: "La orden de visualización es obligatoria",
              code: "El código es obligatorio",
              ticket_services: "El servicio de tickets(cards) es obligatorio",
              summary: "El resumen es obligatorio",
              summary_characteres:
                "El resumen no puede tener más de 72 caracteres",
              name_characteres:
                "El nombre no puede tener más de 24 caracteres.",
              summary_outside_characteres:
                "El resumen no puede tener más de 72 caracteres",
              message_outside_characteres:
                "El mensaje para fuera del horario de atención no puede tener más de 500 caracteres",
              message_outside_business_day:
                "El mensaje fuera de los días de atención es obligatorio",
              ticket_channel_step:
                "La lista es obligatoria cuando se selecciona un tablero",
            },
          },
          ticketServiceMessage: {
            ticket_service_messages: "Mensajes",
            ticket_service_message: "Mensaje",
            search: "Buscar una mensaje",
            message: "Mensaje",
            message_type: "Tipo de mensaje",
            ticket_service: "Servicio de ticket(card)",
            target: "Target",
            add_message: "Nuevo Mensaje",
            errors: {
              message: "La mensaje es obligatoria",
              message_type: "El tipo de mensaje es obligatorio",
              ticket_service: "El servicio de ticket(card) es obligatorio",
              target: "El target es obligatorio",
            },
          },
          serviceDay: {
            service_days: "Horario de apertura",
            service_day: "Horario de atención",
            new_service_day: "Nuevo horario de apertura",
            search: "Buscar un horario de atención",
            add_service_day: "Añadir horario de atención",
            day_of_week: "Dia de la semana",
            start_time: "Hora de inicio",
            end_time: "Hora de cierre",
            ticket_service: "Servicio de ticket(card)",
            enable: "Permitir",
            confirm: {
              title: "¿Eliminar horario de atención?",
              description:
                "Esto eliminará permanentemente el horario de atención",
            },
            errors: {
              day_of_week: "El dia de la semana es obligatorio",
              ticket_service: "El servicio de ticket(card) es obligatorio",
              start_time: "La hora de inicio es obligatoria",
              end_time: "La hora de cierre es obligatoria",
            },
          },
          blacklist: {
            blacklist_registrations: "Registros de Blacklist",
            blacklist_registration: "Registro de Blacklist",
            name: "Nombre",
            active: "Activo",
            inactive: "Inactivo",
            status: "Estado",
            phone_number: "Teléfono",
            creation_date: "Fecha de Blacklist",
            search: "Buscar registro en la blacklist",
            add_button: "Agregar Registro a la Blacklist",
            enable: "Habilitar",
            individual: "Persona Física",
            contact_number: "Número de Contacto",
            ddi: "DDI",
            confirm: {
              title: "¿Eliminar registro de la blacklist?",
              description:
                "Esto eliminará permanentemente el registro de la blacklist",
            },
            errors: {
              phone_number_value: "Número de contacto obligatorio",
              ddi: "DDI obligatorio",
              individual: "Seleccione una persona",
            },
          },
          banList: {
            ban_lists: "Listas de Teléfonos Prohibidos por Servicio",
            ban_list: "Lista de Teléfonos Prohibidos por Servicio",
            add_ban_list: "Agregar Lista de Teléfonos Prohibidos por Servicio",
            new_ban_list: "Nueva Lista de Teléfonos Prohibidos por Servicio",
            search: "Buscar una lista de teléfonos prohibidos por servicio",
            phone_number: "Número de Teléfono",
            phone_info:
              "Ingrese el número con código de país y código de área (solo números). Ejemplo: 5547912345678",
            ticket_service: "Servicio de ticket (card)",
            type: "Tipo",
            observation: "Observación",
            created: "Fecha y hora",
            confirm: {
              title: "¿Eliminar lista de teléfonos prohibidos por servicio?",
              description:
                "Esto eliminará permanentemente la lista de teléfonos prohibidos por servicio",
            },
            errors: {
              phone_number: "El número de teléfono es obligatorio",
              only_phone_numbers: "Ingrese solo números",
              ticket_service: "El servicio de ticket (card) es obligatorio",
            },
          },
          appointmentArrivalRule: {
            appointment_arrivals: "Horarios de Llegada de Agendas",
            appointment_arrival: "Horario de Llegada de Agenda",
            new_appointment_arrival: "Nuevo Horario de Llegada de Agenda",
            add_appointment_arrival: "Agregar Horario de Llegada de Agenda",
            search: "Buscar un horario de llegada de agenda",
            name: "Nombre",
            description: "Descripción",
            created_successfully:
              "Horario de llegada de agenda creado con éxito",
            confirm: {
              title: "¿Eliminar horario de llegada de agenda?",
              description:
                "Esto eliminará permanentemente el horario de llegada de agenda",
            },
            errors: {
              name: "El nombre es obligatorio",
            },
            appointment_arrival_config: "Horarios de Llegada",
            appointmentArrivalConfig: {
              appointment_arrival_configs: "Horarios de Llegada",
              appointment_arrival_config: "Horario de Llegada",
              new_appointment_arrival_config: "Nuevo Horario de Llegada",
              add_appointment_arrival_config: "Agregar Horario de Llegada",
              search: "Buscar un horario de llegada",
              from: "Desde",
              to: "Hasta",
              arrival_time: "Horario de Llegada",
              if: "Si",
              then: "Entonces",
              appointments: "Agendamientos:",
              arrival_time_description:
                "Informar al paciente que llegue a las:",
              confirm: {
                title: "¿Eliminar horario de llegada?",
                description:
                  "Esto eliminará permanentemente el horario de llegada",
              },
              errors: {
                from: "La fecha de inicio es obligatoria",
                to: "La fecha de fin es obligatoria",
                arrival_time: "El horario de llegada es obligatorio",
              },
            },
          },
        },
        templates: {
          whatsapp_template: {
            category: "Categoría",
            whatsapp_templates: "Templates del Whatsapp",
            whatsapp_template: "Template del Whatsapp",
            new_whatsapp_template: "Nuevo template del Whatsapp",
            header_type: "Tipo de encabezado",
            search: "Buscar un template del Whatsapp",
            action_type: "Tipo de acción",
            dynamic: "Dinámica",
            add_whatsapp_template: "Añadir template del Whatsapp",
            name: "Nombre",
            enable: "Permitir",
            automation: "Automatización",
            ticket_service: "Servicio de ticket(card)",
            no_ticket_service:
              "Debes tener al menos un servicio de tickets(cards) registrado para poder registrar una plantilla de Whatsapp",
            template_meta_name: "Nombre del template en Meta",
            automation_status: "Status de automatización",
            status: "Status",
            active: "Activo",
            inactive: "Inactivo",
            message_preview: "Preview del mensaje",
            preview_button: "Ver preview del template",
            optional: "Opcional",
            header: "Encabezamiento",
            header_sub:
              "Agregue un título o elija qué tipo de medio utilizará para este encabezado.",
            file_sending_mode: "Modo de envío del Archivo",
            send_contact_related_file:
              "Enviar siempre el archivo vinculado al contacto de la lista",
            send_contact_related_file_info:
              "Si esta opción está marcada, no enviaremos el archivo anterior. Enviaremos el archivo que se envía vía API en el momento de crear el contacto",
            send_selected_file: "Enviar siempre el archivo seleccionado",
            send_selected_file_info:
              "Si esta opción está marcada, no enviaremos el archivo de arriba. Enviaremos el archivo que se adjuntará al crear el ticket.",
            send_template_related_file:
              "Enviar siempre el archivo vinculado a esta plantilla",
            send_template_related_file_info:
              "Si esta opción está marcada, siempre enviaremos el mismo archivo, que es el archivo vinculado a esta plantilla",
            title: "Título",
            body: "Cuerpo",
            body_sub: "Ingrese el texto de su mensaje.",
            internal_template: "Plantilla interna de CRM",
            body_placeholder: "Ingresa el cuerpo de tu mensaje...",
            footer: "Zócalo",
            footer_sub:
              "Agregue una pequeña línea de texto en la parte inferior de su plantilla de mensaje.",
            buttons: "Botones",
            buttons_sub:
              "Cree botones para que los clientes respondan a su mensaje o tomen medidas.",
            resend: "Reenviar",
            resend_success: "Template reenviado exitosamente",
            whatsappTemplateAutomation: {
              title: "Alterar automatización?",
              description:
                "Cambiar la automatización hará que se borren todos los campos",
              cancel: "Cancelar",
              change: "Alterar",
            },
            confirm: {
              title: "¿Eliminar el template del Whatsapp?",
              description:
                "Esto eliminará permanentemente el template del Whatsapp",
            },
            errors: {
              name: "El nombre es obligatorio",
              ticket_service: "El servicio de ticket(card) es obligatorio",
              ticket_automation: "La automatización es obligatoria",
              body: "El cuerpo debe tener al menos 1 carácter.",
              body_max: "El cuerpo debe tener un máximo de 1024 caracteres.",
              body_invalid_variables: "Todas las variables deben ser válidas",
              body_max_550: "El cuerpo debe tener un máximo de 550 caracteres.",
              custom_button_text:
                "El texto del botón debe tener al menos 1 carácter",
              media_file: "Al menos un archivo es obligatorio",
              custom_button_text_max:
                "El texto del botón debe tener un máximo de 25 caracteres",
              url_type: "El tipo de URL es obligatorio",
              country: "El país es obligatorio",
              text: "El texto del botón debe tener al menos 1 carácter",
              text_max:
                "El texto del botón debe tener un máximo de 25 caracteres",
              payload: "Campo obligatorio",
              url_payload:
                "El botón debe contener un enlace válido (http o https)",
              example: "El ejemplo es obligatorio",
              whatsMetaCategory: "La categoría es obligatoria",
              action_type: "El tipo de acción es obligatorio",
              file_fixed: "Seleccione un modo de envío del archivo",
            },
          },
          internalCrm: {
            new_variable: "Nueva Variable",
            new_category: "Nueva Categoría",
            new_template: "Nueva Template",
            search_category: "Buscar una categoría",
            search_variable: "Buscar una variable",
            search_template: "Buscar una Template",
            add_automation_rule: "Agregar regla de automatización",
            categories: "Categorías",
            fields: "Campos",
            label: "Etiqueta",
            screen_order: "Orden de Pantalla",
            add_new_item: "Agregar nuevo campo",
            is_required: "Obligatorio",
            character_limit: "Límite de caracteres",
            variables: "Variables",
            templates: "Templates",
            status: "Status",
            active: "Activo",
            inactive: "Inactivo",
            name: "Nombre",
            category: "Categoría",
            data_type: "Tipo de dato",
            enable: "Activar",
            code: "Código",
            confirm: {
              title_variable: "¿Eliminar variable?",
              description_variable:
                "Esto eliminará permanentemente la variable",
              title_category: "¿Eliminar categoría?",
              description_category:
                "Esto eliminará permanentemente la categoría",
              title_template: "¿Eliminar plantilla?",
              description_template:
                "Esto eliminará permanentemente la plantilla",
            },
            errors: {
              name: "El nombre es obligatorio",
              label: "La etiqueta es obligatoria",
              screen_order: "El orden de pantalla es obligatorio",
              categories: "La categoría es obligatoria",
              data_type: "El tipo de dato es obligatorio",
              variable: "La Variable es obligatoria",
              fields: "Al menos un campo es obligatorio",
            },
          },
        },
        automations: {
          automationRuleEncMessage: {
            message: "Mensaje",
            new_message: "Nuevo mensaje",
            add_message: "Agregar mensaje",
            search: "Buscar un mensaje",
            name: "Nombre",
            enable: "Habilitar",
            exception: "Excepción",
            status: "Estado",
            active: "Activo",
            inactive: "Inactivo",
            send: "Enviar",
            if: "Si",
            then: "Entonces",
            priority: "Prioridad",
            qtyMessageSendingAttempts: "Intentos de reenvío",
            missing_status: "Status da Agenda",
            establishment: "Establecimiento",
            initial_date: "Fecha de inicio",
            end_date: "Fecha de fin",
            individualIdentifier: "Identificador individual",
            ticketAutomationRuleEncMessageSectors: "Sectores de la atención",
            ticketAutomationRuleEncMessagePrescriptionSectors:
              "Sectores de la prescripción",
            ticketAutomationRuleEncMessageEncounterTypes: "Tipos de atención",
            ticketAutomationRuleEncMessageInProcClassifics: "Clasificación",
            ticketAutomationRuleEncMessageMedProcTypes:
              "Tipos de procedimiento interno",
            sendTypeEmrResult: "Resultado del informe",
            templateGeneral: "Plantilla",
            sendTypePasswordEmrResult: "Contraseña del informe",
            individualIdentifierMessageHelper:
              "Los valores deben estar separados por comas",
            confirm: {
              title: "¿Eliminar mensaje?",
              description: "Esto eliminará permanentemente el mensaje",
            },
            errors: {
              name: "El nombre es obligatorio",
              establishments: "El establecimiento es obligatorio",
              initial_date: "La fecha de inicio es obligatoria",
              end_date: "La fecha de fin es obligatoria",
              templateGeneral: "La plantilla es obligatoria",
            },
          },
          automationReceivedRules: {
            automation_received_rules: "Reglas de recepción",
            automation_received_rule: "Regla de recepción",
            search: "Buscar una regla de recepción",
            new_automation_received_rule: "Nueva regla de recepción",
            name: "Nombre",
            created_by: "Creado por",
            created_successfully: "Creado correctamente",
            insurance: "Convenio / Categoría",
            private_insurance: "Convenio Privado",
            cancelation_reasons: "Motivos de Cancelacion",
            slot: "Slot Sorteo",
            days_ahead: "Días por delante",
            messages: "Mensajes",
            custom_message: "Mensajes personalizados",
            establishment: "Establecimiento",
            add_automation_received_rule: "Agregar regla de recepción",
            ticket_default_doc: "Protocolos Predeterminados",
            tasy_orientation: "Orientación Tasy",
            offer_classification: "Clasificación de la Oferta",
            allowed_actions: "Acciones Permitidas",
            preferences: "Preferencias",
            unchosenProfessionalPriorities:
              "Prioridades de Profesionales No Elegidos",
            confirm: {
              title: "¿Eliminar la regla de recepción?",
              description:
                "Esto eliminará permanentemente la regla de recepción",
            },
            status: "Estado",
            active: "Activo",
            inactive: "Inactivo",
            code: "Código",
            initial_date: "Fecha inicial",
            end_date: "Fecha final",
            when_error:
              "Transferir a (Cuando ocurra algún error durante el flujo):",
            when_finished: "Transferir a (Cuando finalice la programación):",
            transfer_message: "Mensaje de transferencia",
            error_message: "Mensaje de transferencia cuando ocurre un error",
            automation: "Automatización",
            enable: "Habilitar",
            appointment_arrival_consultation:
              "Horario de Llegada de la Consulta",
            appointment_arrival_exam: "Horario de Llegada del Examen",
            ticketAutRecRuleTasyOrientation: {
              ticket_autrecrule_tasy_orientation: "Orientación Tasy",
              new_ticket_autrecrule_tasy_orientation: "Nueva orientación Tasy",
              enable: "Habilitar",
              type_tasy_orientation: "Tipo de orientación Tasy",
              send_when: "Enviar cuando",
              status: "Estado",
              active: "Activo",
              inactive: "Inactivo",
              add_ticket_autrecrule_tasy_orientation:
                "Agregar orientación Tasy",
              confirm: {
                title: "¿Eliminar la orientación Tasy?",
                description:
                  "Esto eliminará permanentemente la orientación Tasy",
              },
              errors: {
                type_tasy_orientation:
                  "El tipo de orientación Tasy es obligatorio",
                send_when: "El campo Enviar cuando es obligatorio",
              },
            },
            automationRecRuleTicketDefDoc: {
              ticket_default_doc: "Protocolo Predeterminado",
              new_ticket_default_doc: "Nuevo Protocolo Predeterminado",
              add_ticket_default_doc: "Agregar Protocolo Predeterminado",
              send_when: "Enviar Cuando",
              description: "Descripción",
              status: "Estado",
              active: "Activo",
              inactive: "Inactivo",
              enable: "Habilitar",
              ticketAutRecRuleTicketDefDocsInsurances: "Convenios",
              ticketAutRecRuleTicketDefDocsInternalProcedures:
                "Procedimientos Internos",
              procedure_caption: "Escribe al menos 3 letras para buscar",
              ticketAutRecRuleTicketDefDocsCalendars: "Agendas",
              confirm: {
                title: "¿Eliminar Protocolo Predeterminado?",
                description:
                  "Esto eliminará permanentemente el Protocolo Predeterminado",
              },
              errors: {
                send_when: "El campo enviar cuando es obligatorio",
                ticket_default_doc:
                  "El protocolo predeterminado es obligatorio",
              },
            },
            automationReceivedDaysAhead: {
              days_ahead: "Día por delante",
              new_days_ahead: "Nuevo  Día por delante",
              add_days_ahead: "Agregar  Día por delante",
              qtd_days: "Cantidad de Días",
              procedure_caption: "Escribe al menos 3 letras para buscar",
              search_internal_procedures: "Buscar Procedimiento Interno",
              ticketAutomationReceivedDaysAheadCalendars: "Calendarios",
              ticketAutomationReceivedDaysAheadInsurances: "Convenios",
              ticketAutomationReceivedDaysAheadProcedures: "Procedimientos",
              status: "Estado",
              active: "Activo",
              inactive: "Inactivo",
              enable: "Habilitar",
              if: "Si",
              then: "Entonces",
              limit_final_date: "Limitar fecha final de la oferta",
              time_limit_type: "Tipo de límite de tiempo",
              limit_days: "Cantidad de límite",
              confirm: {
                title: "Confirmar Día por delante",
                description:
                  "Esto eliminará permanentemente el Día por delante",
              },
              errors: {
                destination_calendar_file:
                  "El Lugar para guardar es obligatorio",
                ticketAutomationReceivedDaysAheadCalendars:
                  "El calendario es obligatorio",
                ticketAutomationReceivedDaysAheadInsurances:
                  "El convenio es obligatorio",
                ticketAutomationReceivedDaysAheadProcedures:
                  "El procedimiento es obligatorio",
                qtd_days: "La cantidad de días es obligatoria",
              },
            },
            automationReceivedConfFile: {
              file: "Archivo",
              new_file: "Nuevo archivo",
              add_file: "Agregar archivo",
              destination_calendar_file: "Lugar para guardar",
              display_order: "Orden de visualización",
              displayOrder: "Orden de visualización",
              wait_limit_time: "Tiempo Máximo de Espera en Minutos",
              ticketAutomationReceivedConfFileCalendars: "Agendas",
              ticketAutomationReceivedConfFileCalePreferences:
                "Preferencias de la agenda",
              ticketAutomationReceivedConfFileCaleProcedures: "Procedimientos",
              message: "Mensaje",
              messageErro: "Mensaje de error",
              calendar_slot_sort_type: "Tipo de ordenamiento de slots",
              ticketAutomationReceivedConfFileCaleInsurances: "Convenios",
              confirm: {
                title: "Confirmar acción",
                description: "¿Está seguro que desea continuar?",
              },
              ticketAutomationReceivedConfFileCaleInsuranceTypes:
                "Tipos de Convenios",
              procedure_caption: "Escribe al menos 3 letras para buscar",
              search_internal_procedures: "Buscar Procedimiento Interno",
              errors: {
                destination_calendar_file:
                  "El Lugar para guardar es obligatorio",
                ticketAutomationReceivedConfFileCalendars:
                  "La agenda es obligatoria",
                ticketAutomationReceivedConfFileCalePreferences:
                  "La preferencia es obligatoria",
                ticketAutomationReceivedConfFileCaleProcedures:
                  "El procedimiento es obligatorio",
                displayOrder: "El orden de visualización es obligatorio",
                message: "El mensaje es obligatorio",
                messageError: "El mensaje de error es obligatorio",
              },
            },
            automationReceivedCustomMessage: {
              custom_message: "Mensaje personalizado",
              new_custom_message: "Nuevo mensaje personalizado",
              add_custom_message: "Agregar mensaje personalizado",
              message: "Mensaje",
              ticket_channel: "Tablero",
              ticket_channel_step: "Lista",
              ticketAutomationReceivedCustomMessageCalendars: "Agendas",
              ticketAutomationReceivedCaleExamGroupings:
                "Agrupación de Calendario",
              confirm: {
                title: "¿Eliminar mensaje personalizado?",
                description:
                  "Esto eliminará permanentemente el mensaje personalizado",
              },
              errors: {
                message: "El mensaje es obligatorio",
                ticket_channel: "El tablero es obligatorio",
                ticket_channel_step: "La lista es obligatoria",
                ticketAutomationReceivedCaleExamGroupings:
                  "La agrupación de calendario es obligatoria",
              },
            },
            automationReceivedRuleInsuranceCategory: {
              insurance: "Convenio",
              new_insurance: "Nuevo convenio",
              enable: "Habilitar",
              add_insurance: "Agregar convenio",
              insuranceExternalId: "ID externo del convenio",
              insuranceExternalName: "Nombre del convenio",
              status: "Estado",
              active: "Activo",
              inactive: "Inactivo",
              confirm: {
                title: "¿Eliminar el convenio?",
                description: "Esto eliminará permanentemente el convenio",
              },
              errors: {
                insurance_register: "El Convenio es obligatorio",
              },
            },
            automationReceivedRulePriceInsurance: {
              insurance: "Convenio Precio",
              new_insurance: "Nuevo Convenio Precio",
              enable: "Activar",
              add_insurance: "Agregar Convenio Precio",
              external_id: "ID Externo del Convenio",
              external_name: "Nombre del Convenio",
              insurance_field: "Convenio",
              confirm: {
                title: "¿Eliminar Convenio Precio?",
                description:
                  "Esto eliminará permanentemente el Convenio Precio",
              },
              errors: {
                insurance_field: "El convenio es obligatorio",
              },
            },
            automationReceivedRuleCancelationReason: {
              cancelation_reason: "Motivo de Cancelacion",
              new_cancelation_reason: "Nuevo Motivo de Cancelacion",
              add_cancelation_reason: "Agregar Motivo de Cancelacion",
              external_id: "Codigo Externo",
              external_name: "Nombre Externo",
              cancelation_reason_field: "Motivo de Cancelacion",
              confirm: {
                title: "Eliminar Motivo de Cancelacion?",
                description:
                  "Esto eliminara permanentemente el motivo de cancelacion",
              },
              errors: {
                cancelation_reason_field:
                  "El Motivo de Cancelacion es obligatorio",
              },
            },
            automationReceivedRuleEstablishment: {
              establishment_id: "Id del Establecimiento",
              establishment_name: "Alias del Establecimiento",
              original_establishment_name: "Nombre del Establecimiento",
              add_establishment: "Agregar Establecimiento",
              confirm_title: "Establecimiento",
              confirm_description:
                "Está seguro de que desea eliminar este establecimiento de forma permanente",
              establishment: "Establecimiento",
              new_establishment: "Nuevo Establecimiento",
              establishment_field: "Establecimientos",
              establishment_name_field: "Alias del Establecimiento",
            },
            automationReceivedMessagePrivateInsurance: {
              private_insurance: "Convenio Privado",
              new_private_insurance: "Nuevo Convenio Privado",
              add_private_insurance: "Agregar Convenio Privado",
              external_private_id: "ID Externo del Convenio Privado",
              external_private_name: "Nombre del Convenio Privado Externo",
              confirm: {
                title: "¿Eliminar Convenio Privado?",
                description:
                  "Esto eliminará permanentemente el convenio privado",
              },
              errors: {
                external: "El Convenio Privado es obligatorio",
              },
            },
            automationReceivedSlot: {
              slot_schedule: "Slot Sorteo",
              new_slot_schedule: "Nueva Slot Sorteo",
              add_slot_schedule: "Agregar Slot Sorteo",
              enable: "Habilitar",
              if: "Si",
              ticketAutomationReceivedSlotCalendars: "Agenda",
              priority: "Prioridad",
              then: "Entonces",
              slots_available: "Cantidad de franjas disponibles",
              calendar_slot_sort_type: "Método de sorteo",
              status: "Estado",
              active: "Activo",
              inactive: "Inactivo",
              confirm: {
                title: "¿Eliminar la Slot Sorteo?",
                description: "Esto eliminará permanentemente la Slot Sorteo",
              },
              errors: {
                calendar_slot_sort_type: "El método de sorteo es obligatorio",
                ticketAutomationReceivedSlotCalendars:
                  "La agenda es obligatoria",
                slots_available:
                  "La cantidad de franjas disponibles es obligatoria",
                priority: "La prioridad es obligatoria",
              },
            },
            automationReceivedMessages: {
              message: "Mensaje",
              new_message: "Nuevo Mensaje",
              add_message: "Agregar Mensaje",
              search: "Buscar un mensaje",
              active: "Activo",
              inactive: "Inactivo",
              status: "Estado",
              enable: "Habilitar",
              show_app_and_online_calendar: "Solo Agenda Online",
              if: "Si",
              then: "Entonces",
              return_days: "Días de Retorno",
              calendar_classification: "Clasificaciones de Agenda",
              preference: "Preferencias",
              consultation_grouping_register: "Agrupamientos de la Agenda",
              calendar_specialties: "Especialidades de la Agenda",
              agendas: "Agendas",
              confirm: {
                title: "¿Eliminar Mensaje?",
                description: "Esto eliminará permanentemente el Mensaje",
              },
              errors: {
                return_days: "La cantidad de días de retorno es obligatoria",
              },
            },
            ticketAutomationReceivedRuleOfferClassif: {
              offer_classification: "Clasificación de la Oferta",
              add_offer_classification: "Agregar Clasificación de la Oferta",
              new_offer_classification: "Nueva Clasificación de la Oferta",
              classifications: "Clasificaciones",
              default_classification: "Clasificación Predeterminada",
              require_turn_slot_classif:
                "Exigir clasificación en el turno/slot",
              update_slot_classif:
                "Al agendar, actualizar la clasificación en el slot",
              confirm: {
                title: "¿Eliminar Clasificación de la Oferta?",
                description:
                  "Esto eliminará permanentemente la Clasificación de la Oferta",
              },
              errors: {
                classifications: "La clasificación es obligatoria",
                default_classification:
                  "La clasificación predeterminada es obligatoria",
              },
            },
            ticketAutomationReceivedRuleAllowedAction: {
              allowed_action: "Acción Permitida",
              add_allowed_action: "Agregar Acción Permitida",
              new_allowed_action: "Nueva Acción Permitida",
              new_schedule: "Nuevo Agendamiento",
              confirm_field: "Confirmar",
              cancel: "Cancelar",
              check_in: "Check-in",
              reschedule: "Reagendar",
              reschedule_fields_caption:
                "Ingrese en los campos siguientes las reglas que se utilizarán para el reagendamiento según el tipo de agenda",
              featured_received_rule: "Regla de Recepción con Destaque",
              return_received_rule: "Regla de Recepción de Retorno",
              exam_received_rule: "Regla de Recepción de Exámenes",
              consultation_received_rule: "Regla de Recepción de Consultas",
              yes: "Sí",
              no: "No",
              confirm: {
                title: "¿Eliminar Acción Permitida?",
                description:
                  "Esto eliminará permanentemente la Acción Permitida",
              },
            },
            appointmentArrival: {
              appointment_arrival_consultation:
                "Horario de Llegada de la Consulta",
              new_appointment_arrival_consultation:
                "Nuevo Horario de Llegada de la Consulta",
              add_appointment_arrival_consultation:
                "Agregar Horario de Llegada de la Consulta",
              appointment_arrival_exam: "Horario de Llegada del Examen",
              new_appointment_arrival_exam:
                "Nuevo Horario de Llegada del Examen",
              add_appointment_arrival_exam:
                "Agregar Horario de Llegada del Examen",
              search_consultation:
                "Buscar un Horario de Llegada de la Consulta",
              search_exam: "Buscar un Horario de Llegada del Examen",
              if: "Si",
              then: "Entonces",
              establishments: "Establecimientos",
              insurances: "Convenios",
              calendars: "Agendas",
              classifications: "Clasificaciones de Agenda",
              internal_procedures: "Procedimientos Internos",
              procedure_caption: "Ingrese al menos 3 letras para buscar",
              appointment_arrival_rule: "Regla de Horario de Llegada",
              confirm: {
                title_consultation:
                  "¿Eliminar Horario de Llegada de la Consulta?",
                description_consultation:
                  "Esto eliminará permanentemente el Horario de Llegada de la Consulta",
                title_exam: "¿Eliminar Horario de Llegada del Examen?",
                description_exam:
                  "Esto eliminará permanentemente el Horario de Llegada del Examen",
              },
              errors: {
                appointment_arrival_rule:
                  "La regla de horario de llegada es obligatoria",
              },
            },
            ticketAutomationReceivedRulePreference: {
              preference: "Preferencia",
              add_preference: "Agregar Preferencia",
              new_preference: "Nueva Preferencia",
              enable: "Habilitar",
              active: "Activo",
              inactive: "Inactivo",
              medical_specialty: "Especialidad Médica",
              status: "Estado",
              calendar_preferences: "Preferencias",
              confirm: {
                title: "¿Eliminar Preferencia?",
                description: "Esto eliminará permanentemente la Preferencia",
              },
              errors: {
                medical_specialty: "La especialidad médica es obligatoria",
              },
            },
            ticketAutRecRuleUnchosenProfessionalRule: {
              unchosenProfessionalPriority:
                "Prioridad de Profesional No Elegido",
              new_unchosenProfessionalPriority:
                "Nueva Prioridad de Profesional No Elegido",
              add_unchosenProfessionalPriority:
                "Agregar Prioridad de Profesional No Elegido",
              status: "Estado",
              active: "Activo",
              inactive: "Inactivo",
              enable: "Activar",
              if: "Si",
              then: "Entonces",
              name: "Nombre",
              priority: "Prioridad",
              initial_age: "Edad Inicial",
              final_age: "Edad Final",
              unchosen_professional_criterion: "Criterio",
              specialties: "Especialidades",
              insurances: "Convenios",
              calendars: "Agendas",
              physicians: "Médicos",
              add_priority: "Agregar Prioridad",
              confirm: {
                title: "¿Eliminar la Prioridad de Profesional No Elegido?",
                description:
                  "Esto eliminará permanentemente la Prioridad de Profesional No Elegido",
              },
              errors: {
                name: "El nombre es obligatorio",
                unchosen_professional_criterion: "El criterio es obligatorio",
                offers: "Seleccione al menos una agenda o un médico",
                offer_priority: "La prioridad es obligatoria",
                offer_priority_duplicated:
                  "La prioridad ya está siendo utilizada por otro elemento. Utilice otro valor",
              },
            },
          },
          templateGeneral: {
            title: "Plantilla general",
            new: "Nueva plantilla general",
            add: "Agregar plantilla general",
            editor: "Editor",
            html: "HTML",
            insert_html: "Ingrese el HTML de {{section_name}}",
            content_header: "Encabezado",
            content_footer: "Pie de página",
            template_general_type: "Tipo de plantilla general",
            status: "Estado",
            name: "Nombre",
            active: "Activo",
            inactive: "Inactivo",
            enable: "Activar",
            confirm: {
              title: "¿Eliminar plantilla general?",
              description:
                "Esto eliminará permanentemente la plantilla general.",
            },
            errors: {
              name: "El nombre es obligatorio",
              templateGeneralType:
                "El tipo de plantilla general es obligatorio",
            },
          },
          automationMessageTicketDefaulDoc: {
            title: "Documento Predeterminado",
            new: "Nuevo documento predeterminado",
            add: "Agregar documento predeterminado",
            send_when: "Enviar Cuando",
            ticket_default_doc: "Documento Predeterminado",
            enable: "Activar",
            description: "Descripción",
            schedules: "Agendas",
            insurances: "Convenios",
            internalProcedures: "Proc internos",
            active: "Activo",
            inactive: "Inactivo",
            status: "Status",
            schedulesMessageHelper:
              "Los valores deben estar separados por comas",
            insurancesMessageHelper:
              "Los valores deben estar separados por comas",
            internalProceduresMessageHelper:
              "Os valores devem ser separados por vírgula",
            confirm: {
              title: "¿Eliminar el documento predeterminado?",
              description:
                "Esto eliminará permanentemente el documento predeterminado",
            },
            errors: {
              ticket_default_doc: "El documento predeterminado es obligatorio",
              send_when: "Enviar cuando es obligatorio",
            },
          },
          ticketAutomationMsgTicketAutTemplate: {
            title: "Plantilla después de la respuesta",
            new: "Nuevo plantilla después de la respuesta",
            add: "Agregar plantilla después de la respuesta",
            send_when: "Enviar Cuando",
            ticket_automation_template: "Plantilla",
            schedules: "Agendas",
            insurances: "Convenios",
            schedulesMessageHelper:
              "Los valores deben estar separados por comas",
            insurancesMessageHelper:
              "Los valores deben estar separados por comas",
            confirm: {
              title: "¿Eliminar el plantilla después de la respuesta?",
              description:
                "Esto eliminará permanentemente el plantilla después de la respuesta",
            },
            errors: {
              ticket_automation_template: "La plantilla es obligatorio",
              send_when: "Enviar cuando es obligatorio",
              schedules: "Agendas o Convenios es obligatorio",
              insurances: "Agendas o Convenios es obligatorio",
            },
          },
          AutomationTasyOrientation: {
            title: "Orientación Tasy",
            new: "Nuevo orientación Tasy",
            add: "Agregar orientación Tasy",
            send_when: "Enviar Cuando",
            type_tasy_orientation: "Proceso Tasy",
            enable: "Permitir",
            active: "Activo",
            inactive: "Inactivo",
            status: "Status",
            confirm: {
              title: "¿Eliminar el orientación Tasy?",
              description: "Esto eliminará permanentemente el orientación Tasy",
            },
            errors: {
              send_when: "Enviar cuando es obligatorio",
              type_tasy_orientation: "El Proceso Tasy es obligatorio",
            },
          },
          automationRules: {
            automation_rules: "Reglas de Envío",
            automation_rule: "Regla de Envío",
            new_automation_rule: "Nueva regla de envío",
            action_after_24_hours: "Acción después de 24 horas",
            select_action_after_24_hours:
              "Seleccione la acción después de 24 horas",
            restart_conversation: "Reinicio de conversación",
            new_contact_attempt: "Nuevo intento",
            both: "Ambos",
            no_action: "Sin acción",
            search: "Buscar una regla de envío",
            add_automation_rule: "Añadir regla de envío",
            name: "Nombre",
            automation: "Automatización",
            created_by: "Creado por",
            status: "Status",
            active: "Activo",
            inactive: "Inactivo",
            enable: "Permitir",
            event: "Evento",
            automation_message_ticket_defaul_doc: "Documento Predeterminado",
            automation_message_ticket_automation_template:
              "Plantilla después de la respuesta",
            automation_tasy_orientation: "Orientación Tasy",
            ticket_service: "Servicio de ticket(card)",
            initial_date: "Data de inicio",
            end_date: "Data de fin",
            whatsapp_template: "Template de WhatsApp",
            robot: "Robot",
            attendant: "Atendente",
            pendent: "Envío Pendiente",
            when_error: "Cuando hay un error al iniciar template",
            when_blacklist: "Cuando el contacto esté en la blacklist",
            board: "Tablero",
            list: "Lista",
            time_rule: "Regla de tiempo",
            automation_message: "Mensaje de automatización",
            messages: "Mensajes",
            created_successfully: "Regla de automatización creada con éxito",
            confirm: {
              title: "¿Eliminar la regla de envío?",
              description: "Esto eliminará permanentemente la regla de envío",
            },
            errors: {
              name: "El nombre es obligatorio",
              ticket_automation: "La automatización es obligatoria",
              ticket_event: "El evento es obligatorio",
              ticket_service: "El servicio de ticket(card) es obligatorio",
              initial_date: "La fecha de inicio es obligatoria",
              end_date: "La fecha de fin es obligatoria",
              ticket_automation_template:
                "El template de WhatsApp es obligatorio",
              ticket_channel_step_robot: "La lista del robot es obligatoria",
              ticket_channel_step_attendant:
                "La lista del atendente es obligatoria",
              ticket_channel_step_pendent:
                "La lista de envío pendiente es obligatoria",
              initial_date_bigger:
                "La fecha de inicio no puede ser mayor que la fecha de fin",
              list: "La lista es obligatoria",
              action_after_24_hours: "Seleccione la acción después de 24 horas",
            },
          },
        },
        flows: {
          serviceWhatsapp: {
            title: "Has sido redirigido al administrador de flujo.",
            subtitle: "Para acceder nuevamente haga clic en el botón de abajo",
            button: "Acceso",
          },
        },
      },
    },
    "4uESign": {
      page: {
        automations: {
          automationRules: {
            signOnly: "Filtro de firma",
            periodInDays: "Periodo en días",
            attendantTypeHelperText:
              "Los valores deben estar separados por comas",
            wordFile: "Archivo Word",
            model_file: "Archivo modelo",
            download_model: "Descargar modelo",
            model_files: {
              guia_sp_sadt: "Guía SP-SADT",
              ficha_paciente: "Ficha del paciente",
            },
            active: "Activo",
            inactive: "Inactivo",
            establishment: "Establecimientos",
            esignAttendantType: "Tipo de atención",
            insuranceType: "Tipo de seguro",
            external_medical_certificate_types: "Tipo de receta",
            header_footer_type:
              "Modelo predeterminado de encabezado y pie de página",
            direction: "Dirección",
            esignStoragePlace: "Ubicación de almacenamiento",
            additionalData: "Dato adicional para guardar el archivo",
            requiredSignatures: "Firmas requeridas",
            technicalManagerCode: "Código del responsable técnico",
            interoperability: "Interoperabilidad",
            service: "Servicio",
            documents: "Documentos",
            document: "Documento",
            new_document: "Nuevo documento",
            edit_document: "Editar documento",
            new_service: "Nuevo servicio",
            edit_service: "Editar servicio",
            addVariables: "Añadir variables",
            available_variables: "Variables disponibles",
            available_variables_button: "Variables",
            available_variables_tooltip: "Ver variables disponibles",
            available_variables_helper:
              "Use las variables a continuación en el documento Word de esta regla.",
            no_available_variables:
              "No hay variables disponibles para esta automatización.",
            variables_load_error:
              "No fue posible cargar las variables disponibles.",
            variables_automation_not_found:
              "No fue posible identificar la automatización vinculada a esta regla.",
            copy_variable: "Copiar variable",
            close: "Cerrar",
            try_again: "Intentar nuevamente",
            add_automation_rule: "Añadir regla de automatización",
            qrCodeEnable: "Habilitar QRCode",
            enable: "Habilitar",
            esign_automation: "Automatización",
            priority: "Prioridad",
            tasy_automation_warning:
              "Esta automatización agrupará todas las reglas referentes a la ficha de atención para recolectar la firma del paciente una única vez, por lo que si hay varias reglas, se recolectará una sola firma del paciente.",
            file_generation: "De la generación del archivo e integración",
            file_type: "Tipo de Archivo",
            add_service: "Añadir servicio",
            add_document: "Añadir documento",
            tabs: {
              general: "Datos Generales",
              documents: "Documentos",
              interoperability: "Interoperabilidad",
            },
            order: "Orden",
            body_pdf: "Cuerpo del PDF",
            interroperability_delete: {
              title: "¿Desea eliminar este servicio?",
              description: "Esto eliminará permanentemente este servicio",
            },
            document_delete: {
              title: "¿Desea eliminar este documento?",
              description: "Esto eliminará permanentemente este documento",
            },
            automation_rules: "Reglas de automatización",
            automation_rule: "Regla de automatización",
            search: "Buscar una regla de automatización",
            name: "Nombre",
            code: "Código",
            created_by: "Creado por",
            status: "Status",
            new_automation_rule: "Nueva regla de automatización",
            ticket_channels: "Tableros",
            ticket_channels_subtitle:
              "Si no se especifica ningún tablero, la regla estará disponible para todos los tableros",
            add_ticket_channels: "Tableros agregados",
            initial_date: "Fecha inicial",
            end_date: "Fecha de finalización",
            observation: "Observación",
            header_pdf: "Encabezado PDF",
            footer_pdf: "Pie de página del PDF",
            created_successfully: "Regla de automatización creada con éxito",
            automation: "Automatización",
            physicians: "Médicos",
            insuranceTypes: "Tipo de convenio",
            authorizationTypes: "Tipo de autorización",
            guideTypes: "Tipo de guía",
            authorizationStages: "Etapa de autorización",
            insurances: "Convenio",
            media_files: "Documentos",
            add_media_file: "Añadir documento",
            body: "Cuerpo del documento",
            document_search: "Buscar un documento",
            interroperability_search: "Buscar un servicio",
            confirm: {
              title: "¿Eliminar la regla de automatización?",
              description:
                "Esto eliminará permanentemente la regla de automatización",
            },
            errors: {
              headerFooterType:
                "El modelo predeterminado de encabezado y pie de página es obligatorio",
              direction: "La dirección es obligatoria",
              signOnlyPeriod: "El periodo en días es obligatorio",
              signOnlyRequired: "El filtro de firma es obligatorio",
              name: "El nombre es obligatorio",
              automation: "La automatización es obligatoria",
              priority: "La prioridad es obligatoria",
              initial_date: "La fecha de inicio es obligatoria",
              end_date: "La fecha de fin es obligatoria",
              initial_date_bigger:
                "La fecha de inicio no puede ser mayor que la fecha de fin",
              order: "El orden debe ser mayor o igual a 1",
              requiredSignatures: "Al menos una firma es obligatoria",
              requiredSignatures_empty:
                "Seleccione al menos una firma requerida",
              technicalManagerCode:
                "El código del responsable técnico es obligatorio",
              establishment: "El establecimiento es obligatorio",
              physicians: "Seleccione al menos un médico",
              insuranceTypes: "Seleccione al menos un tipo de seguro",
              esignLocationSaveFile:
                "La ubicación de almacenamiento es obligatoria",
              service: "El servicio es obligatorio",
            },
          },
          emailSendRules: {
            title: "Reglas de envío de correo electrónico",
            form_title: "Regla de envío de correo electrónico",
            new: "Nueva regla de envío de correo electrónico",
            add: "Añadir regla de envío de correo electrónico",
            search: "Buscar una regla de envío de correo electrónico",
            name: "Nombre",
            initial_date: "Fecha de inicio",
            end_date: "Fecha de fin",
            subject: "Título",
            body: "Contenido",
            enable: "Habilitar",
            status: "Estado",
            active: "Activo",
            inactive: "Inactivo",
            variables_button: "Variables",
            variables_tooltip: "Ver variables disponibles",
            available_variables: "Variables disponibles",
            copy_variable: "Copiar variable",
            close: "Cerrar",
            overlap_error:
              "Ya existe una regla de envío de correo electrónico con un período de vigencia superpuesto.",
            variables: {
              patient_name: "Nombre del paciente",
              encounter_number: "Número de atención",
            },
            confirm: {
              title: "¿Eliminar regla de envío de correo electrónico?",
              description:
                "Esto eliminará permanentemente la regla de envío de correo electrónico",
            },
            errors: {
              name: "El nombre es obligatorio",
              initial_date: "La fecha de inicio es obligatoria",
              end_date: "La fecha de fin es obligatoria",
              subject: "El título es obligatorio",
              body: "El contenido es obligatorio",
              end_date_less:
                "La fecha de fin debe ser mayor o igual a la fecha de inicio",
            },
          },
          signatureGroups: {
            title: "Grupos de Firma",
            edit: "Editar grupo de firma",
            name: "Nombre",
            linkedRules: "Reglas vinculadas",
            search: "Buscar un grupo de firma",
            errors: { name: "El nombre es obligatorio" },
          },
        },
        logs: {
          forubusSignatureLogs: {
            identifier: "Identificador",
            signature_type: "Tipo de Firma",
            first_integration_id: "Identificador",
            first_integration_id_hint:
              "Puede ser el número de la receta, del certificado o de la atención",
            document_code: "Código del Documento",
            ged_integration_id: "Integración GED",
            finish_date: "Fecha de Finalización",
            search_placeholder: "Buscar...",
            view_details: "Ver detalles",
            start_date: "Fecha inicial",
            end_date: "Fecha final",
            emailSend: {
              action: "Correo al paciente",
              title: "Correo al paciente",
              identification:
                "Documento {{documentCode}} • Atención {{encounterNumber}}",
              close: "Cerrar",
              loading: "Consultando el estado del correo...",
              not_sent: "Correo no enviado",
              not_sent_description:
                "Todavía no hay un registro de envío de correo para este sobre.",
              load_error: "No se pudo consultar el correo",
              load_error_description:
                "No se pudo cargar el estado del envío. Inténtelo de nuevo.",
              retry: "Intentar de nuevo",
              status: "Estado",
              statusValues: {
                pending: "Pendiente de envío",
                sending: "Enviando",
                sent: "Enviado",
                error: "Error de envío",
                unknown: "Estado desconocido",
              },
              send_details: "Detalles del envío",
              recipient: "Destinatario",
              sent_at: "Fecha de envío",
              not_sent_yet: "Aún no enviado",
              attachments_count: "Cantidad de archivos adjuntos",
              attempts: "Número de intentos",
              error_message: "Mensaje de error",
              no_error_message: "Sin mensaje de error",
            },
            details: {
              title: "Detalles de la Firma",
              close: "Cerrar",
              record_info: "Registro de firma digital",
              signed: "Firmado",
              pending: "Pendiente",
              section_identification: "Identificación",
              section_integrations: "Integraciones",
              section_dates: "Fechas",
              section_qrcode: "Código QR",
              document_code: "Código del Documento",
              file_name: "Nombre del Archivo",
              file_path: "Ruta del Archivo",
              mime_type: "Tipo MIME",
              file_size: "Tamaño del Archivo",
              first_integration_id: "ID Receta / Certificado",
              second_integration_id: "Segunda Integración",
              third_integration_id: "Tercera Integración",
              ged_integration_id: "Integración GED",
              created: "Creado el",
              last_modified: "Última Modificación",
              send_date: "Fecha de Envío",
              finish_date: "Fecha de Conclusión",
              qr_code: "Datos del Código QR",
            },
          },
        },
      },
    },
  },
};

export default es;
